/* empty css            */ function Qi(e, t) {
  return function () {
    return e.apply(t, arguments);
  };
}
const { toString: Jl } = Object.prototype,
  { getPrototypeOf: fr } = Object,
  { iterator: cs, toStringTag: Vi } = Symbol,
  fs = ((e) => (t) => {
    const n = Jl.call(t);
    return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
  })(Object.create(null)),
  We = (e) => ((e = e.toLowerCase()), (t) => fs(t) === e),
  us = (e) => (t) => typeof t === e,
  { isArray: Yt } = Array,
  Jt = us('undefined');
function Tn(e) {
  return (
    e !== null &&
    !Jt(e) &&
    e.constructor !== null &&
    !Jt(e.constructor) &&
    Re(e.constructor.isBuffer) &&
    e.constructor.isBuffer(e)
  );
}
const Wi = We('ArrayBuffer');
function Xl(e) {
  let t;
  return (
    typeof ArrayBuffer < 'u' && ArrayBuffer.isView
      ? (t = ArrayBuffer.isView(e))
      : (t = e && e.buffer && Wi(e.buffer)),
    t
  );
}
const Zl = us('string'),
  Re = us('function'),
  Ki = us('number'),
  Fn = (e) => e !== null && typeof e == 'object',
  Yl = (e) => e === !0 || e === !1,
  Hn = (e) => {
    if (fs(e) !== 'object') return !1;
    const t = fr(e);
    return (
      (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) &&
      !(Vi in e) &&
      !(cs in e)
    );
  },
  ea = (e) => {
    if (!Fn(e) || Tn(e)) return !1;
    try {
      return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
    } catch {
      return !1;
    }
  },
  ta = We('Date'),
  na = We('File'),
  sa = We('Blob'),
  ra = We('FileList'),
  ia = (e) => Fn(e) && Re(e.pipe),
  oa = (e) => {
    let t;
    return (
      e &&
      ((typeof FormData == 'function' && e instanceof FormData) ||
        (Re(e.append) &&
          ((t = fs(e)) === 'formdata' ||
            (t === 'object' && Re(e.toString) && e.toString() === '[object FormData]'))))
    );
  },
  la = We('URLSearchParams'),
  [aa, ca, fa, ua] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(We),
  da = (e) => (e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ''));
function An(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > 'u') return;
  let s, r;
  if ((typeof e != 'object' && (e = [e]), Yt(e)))
    for (s = 0, r = e.length; s < r; s++) t.call(null, e[s], s, e);
  else {
    if (Tn(e)) return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e),
      o = i.length;
    let l;
    for (s = 0; s < o; s++) ((l = i[s]), t.call(null, e[l], l, e));
  }
}
function Gi(e, t) {
  if (Tn(e)) return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let s = n.length,
    r;
  for (; s-- > 0; ) if (((r = n[s]), t === r.toLowerCase())) return r;
  return null;
}
const kt =
    typeof globalThis < 'u'
      ? globalThis
      : typeof self < 'u'
        ? self
        : typeof window < 'u'
          ? window
          : global,
  Ji = (e) => !Jt(e) && e !== kt;
function Qs() {
  const { caseless: e, skipUndefined: t } = (Ji(this) && this) || {},
    n = {},
    s = (r, i) => {
      const o = (e && Gi(n, i)) || i;
      Hn(n[o]) && Hn(r)
        ? (n[o] = Qs(n[o], r))
        : Hn(r)
          ? (n[o] = Qs({}, r))
          : Yt(r)
            ? (n[o] = r.slice())
            : (!t || !Jt(r)) && (n[o] = r);
    };
  for (let r = 0, i = arguments.length; r < i; r++) arguments[r] && An(arguments[r], s);
  return n;
}
const pa = (e, t, n, { allOwnKeys: s } = {}) => (
    An(
      t,
      (r, i) => {
        n && Re(r) ? (e[i] = Qi(r, n)) : (e[i] = r);
      },
      { allOwnKeys: s }
    ),
    e
  ),
  ha = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e),
  ma = (e, t, n, s) => {
    ((e.prototype = Object.create(t.prototype, s)),
      (e.prototype.constructor = e),
      Object.defineProperty(e, 'super', { value: t.prototype }),
      n && Object.assign(e.prototype, n));
  },
  ga = (e, t, n, s) => {
    let r, i, o;
    const l = {};
    if (((t = t || {}), e == null)) return t;
    do {
      for (r = Object.getOwnPropertyNames(e), i = r.length; i-- > 0; )
        ((o = r[i]), (!s || s(o, e, t)) && !l[o] && ((t[o] = e[o]), (l[o] = !0)));
      e = n !== !1 && fr(e);
    } while (e && (!n || n(e, t)) && e !== Object.prototype);
    return t;
  },
  ba = (e, t, n) => {
    ((e = String(e)), (n === void 0 || n > e.length) && (n = e.length), (n -= t.length));
    const s = e.indexOf(t, n);
    return s !== -1 && s === n;
  },
  ya = (e) => {
    if (!e) return null;
    if (Yt(e)) return e;
    let t = e.length;
    if (!Ki(t)) return null;
    const n = new Array(t);
    for (; t-- > 0; ) n[t] = e[t];
    return n;
  },
  qa = (
    (e) => (t) =>
      e && t instanceof e
  )(typeof Uint8Array < 'u' && fr(Uint8Array)),
  wa = (e, t) => {
    const s = (e && e[cs]).call(e);
    let r;
    for (; (r = s.next()) && !r.done; ) {
      const i = r.value;
      t.call(e, i[0], i[1]);
    }
  },
  xa = (e, t) => {
    let n;
    const s = [];
    for (; (n = e.exec(t)) !== null; ) s.push(n);
    return s;
  },
  va = We('HTMLFormElement'),
  _a = (e) =>
    e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function (n, s, r) {
      return s.toUpperCase() + r;
    }),
  Br = (
    ({ hasOwnProperty: e }) =>
    (t, n) =>
      e.call(t, n)
  )(Object.prototype),
  Sa = We('RegExp'),
  Xi = (e, t) => {
    const n = Object.getOwnPropertyDescriptors(e),
      s = {};
    (An(n, (r, i) => {
      let o;
      (o = t(r, i, e)) !== !1 && (s[i] = o || r);
    }),
      Object.defineProperties(e, s));
  },
  Ca = (e) => {
    Xi(e, (t, n) => {
      if (Re(e) && ['arguments', 'caller', 'callee'].indexOf(n) !== -1) return !1;
      const s = e[n];
      if (Re(s)) {
        if (((t.enumerable = !1), 'writable' in t)) {
          t.writable = !1;
          return;
        }
        t.set ||
          (t.set = () => {
            throw Error("Can not rewrite read-only method '" + n + "'");
          });
      }
    });
  },
  Ea = (e, t) => {
    const n = {},
      s = (r) => {
        r.forEach((i) => {
          n[i] = !0;
        });
      };
    return (Yt(e) ? s(e) : s(String(e).split(t)), n);
  },
  Ta = () => {},
  Fa = (e, t) => (e != null && Number.isFinite((e = +e)) ? e : t);
function Aa(e) {
  return !!(e && Re(e.append) && e[Vi] === 'FormData' && e[cs]);
}
const ka = (e) => {
    const t = new Array(10),
      n = (s, r) => {
        if (Fn(s)) {
          if (t.indexOf(s) >= 0) return;
          if (Tn(s)) return s;
          if (!('toJSON' in s)) {
            t[r] = s;
            const i = Yt(s) ? [] : {};
            return (
              An(s, (o, l) => {
                const a = n(o, r + 1);
                !Jt(a) && (i[l] = a);
              }),
              (t[r] = void 0),
              i
            );
          }
        }
        return s;
      };
    return n(e, 0);
  },
  Ra = We('AsyncFunction'),
  Oa = (e) => e && (Fn(e) || Re(e)) && Re(e.then) && Re(e.catch),
  Zi = ((e, t) =>
    e
      ? setImmediate
      : t
        ? ((n, s) => (
            kt.addEventListener(
              'message',
              ({ source: r, data: i }) => {
                r === kt && i === n && s.length && s.shift()();
              },
              !1
            ),
            (r) => {
              (s.push(r), kt.postMessage(n, '*'));
            }
          ))(`axios@${Math.random()}`, [])
        : (n) => setTimeout(n))(typeof setImmediate == 'function', Re(kt.postMessage)),
  Pa =
    typeof queueMicrotask < 'u'
      ? queueMicrotask.bind(kt)
      : (typeof process < 'u' && process.nextTick) || Zi,
  Ia = (e) => e != null && Re(e[cs]),
  g = {
    isArray: Yt,
    isArrayBuffer: Wi,
    isBuffer: Tn,
    isFormData: oa,
    isArrayBufferView: Xl,
    isString: Zl,
    isNumber: Ki,
    isBoolean: Yl,
    isObject: Fn,
    isPlainObject: Hn,
    isEmptyObject: ea,
    isReadableStream: aa,
    isRequest: ca,
    isResponse: fa,
    isHeaders: ua,
    isUndefined: Jt,
    isDate: ta,
    isFile: na,
    isBlob: sa,
    isRegExp: Sa,
    isFunction: Re,
    isStream: ia,
    isURLSearchParams: la,
    isTypedArray: qa,
    isFileList: ra,
    forEach: An,
    merge: Qs,
    extend: pa,
    trim: da,
    stripBOM: ha,
    inherits: ma,
    toFlatObject: ga,
    kindOf: fs,
    kindOfTest: We,
    endsWith: ba,
    toArray: ya,
    forEachEntry: wa,
    matchAll: xa,
    isHTMLForm: va,
    hasOwnProperty: Br,
    hasOwnProp: Br,
    reduceDescriptors: Xi,
    freezeMethods: Ca,
    toObjectSet: Ea,
    toCamelCase: _a,
    noop: Ta,
    toFiniteNumber: Fa,
    findKey: Gi,
    global: kt,
    isContextDefined: Ji,
    isSpecCompliantForm: Aa,
    toJSONObject: ka,
    isAsyncFn: Ra,
    isThenable: Oa,
    setImmediate: Zi,
    asap: Pa,
    isIterable: Ia
  };
function H(e, t, n, s, r) {
  (Error.call(this),
    Error.captureStackTrace
      ? Error.captureStackTrace(this, this.constructor)
      : (this.stack = new Error().stack),
    (this.message = e),
    (this.name = 'AxiosError'),
    t && (this.code = t),
    n && (this.config = n),
    s && (this.request = s),
    r && ((this.response = r), (this.status = r.status ? r.status : null)));
}
g.inherits(H, Error, {
  toJSON: function () {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: g.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Yi = H.prototype,
  eo = {};
[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
].forEach((e) => {
  eo[e] = { value: e };
});
Object.defineProperties(H, eo);
Object.defineProperty(Yi, 'isAxiosError', { value: !0 });
H.from = (e, t, n, s, r, i) => {
  const o = Object.create(Yi);
  g.toFlatObject(
    e,
    o,
    function (c) {
      return c !== Error.prototype;
    },
    (f) => f !== 'isAxiosError'
  );
  const l = e && e.message ? e.message : 'Error',
    a = t == null && e ? e.code : t;
  return (
    H.call(o, l, a, n, s, r),
    e && o.cause == null && Object.defineProperty(o, 'cause', { value: e, configurable: !0 }),
    (o.name = (e && e.name) || 'Error'),
    i && Object.assign(o, i),
    o
  );
};
const Ma = null;
function Vs(e) {
  return g.isPlainObject(e) || g.isArray(e);
}
function to(e) {
  return g.endsWith(e, '[]') ? e.slice(0, -2) : e;
}
function zr(e, t, n) {
  return e
    ? e
        .concat(t)
        .map(function (r, i) {
          return ((r = to(r)), !n && i ? '[' + r + ']' : r);
        })
        .join(n ? '.' : '')
    : t;
}
function $a(e) {
  return g.isArray(e) && !e.some(Vs);
}
const Na = g.toFlatObject(g, {}, null, function (t) {
  return /^is[A-Z]/.test(t);
});
function ds(e, t, n) {
  if (!g.isObject(e)) throw new TypeError('target must be an object');
  ((t = t || new FormData()),
    (n = g.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function (q, w) {
      return !g.isUndefined(w[q]);
    })));
  const s = n.metaTokens,
    r = n.visitor || c,
    i = n.dots,
    o = n.indexes,
    a = (n.Blob || (typeof Blob < 'u' && Blob)) && g.isSpecCompliantForm(t);
  if (!g.isFunction(r)) throw new TypeError('visitor must be a function');
  function f(h) {
    if (h === null) return '';
    if (g.isDate(h)) return h.toISOString();
    if (g.isBoolean(h)) return h.toString();
    if (!a && g.isBlob(h)) throw new H('Blob is not supported. Use a Buffer instead.');
    return g.isArrayBuffer(h) || g.isTypedArray(h)
      ? a && typeof Blob == 'function'
        ? new Blob([h])
        : Buffer.from(h)
      : h;
  }
  function c(h, q, w) {
    let O = h;
    if (h && !w && typeof h == 'object') {
      if (g.endsWith(q, '{}')) ((q = s ? q : q.slice(0, -2)), (h = JSON.stringify(h)));
      else if (
        (g.isArray(h) && $a(h)) ||
        ((g.isFileList(h) || g.endsWith(q, '[]')) && (O = g.toArray(h)))
      )
        return (
          (q = to(q)),
          O.forEach(function (N, F) {
            !(g.isUndefined(N) || N === null) &&
              t.append(o === !0 ? zr([q], F, i) : o === null ? q : q + '[]', f(N));
          }),
          !1
        );
    }
    return Vs(h) ? !0 : (t.append(zr(w, q, i), f(h)), !1);
  }
  const u = [],
    m = Object.assign(Na, { defaultVisitor: c, convertValue: f, isVisitable: Vs });
  function y(h, q) {
    if (!g.isUndefined(h)) {
      if (u.indexOf(h) !== -1) throw Error('Circular reference detected in ' + q.join('.'));
      (u.push(h),
        g.forEach(h, function (O, $) {
          (!(g.isUndefined(O) || O === null) &&
            r.call(t, O, g.isString($) ? $.trim() : $, q, m)) === !0 && y(O, q ? q.concat($) : [$]);
        }),
        u.pop());
    }
  }
  if (!g.isObject(e)) throw new TypeError('data must be an object');
  return (y(e), t);
}
function Lr(e) {
  const t = { '!': '%21', "'": '%27', '(': '%28', ')': '%29', '~': '%7E', '%20': '+', '%00': '\0' };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function (s) {
    return t[s];
  });
}
function ur(e, t) {
  ((this._pairs = []), e && ds(e, this, t));
}
const no = ur.prototype;
no.append = function (t, n) {
  this._pairs.push([t, n]);
};
no.toString = function (t) {
  const n = t
    ? function (s) {
        return t.call(this, s, Lr);
      }
    : Lr;
  return this._pairs
    .map(function (r) {
      return n(r[0]) + '=' + n(r[1]);
    }, '')
    .join('&');
};
function ja(e) {
  return encodeURIComponent(e)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+');
}
function so(e, t, n) {
  if (!t) return e;
  const s = (n && n.encode) || ja;
  g.isFunction(n) && (n = { serialize: n });
  const r = n && n.serialize;
  let i;
  if (
    (r ? (i = r(t, n)) : (i = g.isURLSearchParams(t) ? t.toString() : new ur(t, n).toString(s)), i)
  ) {
    const o = e.indexOf('#');
    (o !== -1 && (e = e.slice(0, o)), (e += (e.indexOf('?') === -1 ? '?' : '&') + i));
  }
  return e;
}
class Dr {
  constructor() {
    this.handlers = [];
  }
  use(t, n, s) {
    return (
      this.handlers.push({
        fulfilled: t,
        rejected: n,
        synchronous: s ? s.synchronous : !1,
        runWhen: s ? s.runWhen : null
      }),
      this.handlers.length - 1
    );
  }
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(t) {
    g.forEach(this.handlers, function (s) {
      s !== null && t(s);
    });
  }
}
const ro = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 },
  Ba = typeof URLSearchParams < 'u' ? URLSearchParams : ur,
  za = typeof FormData < 'u' ? FormData : null,
  La = typeof Blob < 'u' ? Blob : null,
  Da = {
    isBrowser: !0,
    classes: { URLSearchParams: Ba, FormData: za, Blob: La },
    protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
  },
  dr = typeof window < 'u' && typeof document < 'u',
  Ws = (typeof navigator == 'object' && navigator) || void 0,
  Ua = dr && (!Ws || ['ReactNative', 'NativeScript', 'NS'].indexOf(Ws.product) < 0),
  Ha =
    typeof WorkerGlobalScope < 'u' &&
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts == 'function',
  Qa = (dr && window.location.href) || 'http://localhost',
  Va = Object.freeze(
    Object.defineProperty(
      {
        __proto__: null,
        hasBrowserEnv: dr,
        hasStandardBrowserEnv: Ua,
        hasStandardBrowserWebWorkerEnv: Ha,
        navigator: Ws,
        origin: Qa
      },
      Symbol.toStringTag,
      { value: 'Module' }
    )
  ),
  _e = { ...Va, ...Da };
function Wa(e, t) {
  return ds(e, new _e.classes.URLSearchParams(), {
    visitor: function (n, s, r, i) {
      return _e.isNode && g.isBuffer(n)
        ? (this.append(s, n.toString('base64')), !1)
        : i.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function Ka(e) {
  return g.matchAll(/\w+|\[(\w*)]/g, e).map((t) => (t[0] === '[]' ? '' : t[1] || t[0]));
}
function Ga(e) {
  const t = {},
    n = Object.keys(e);
  let s;
  const r = n.length;
  let i;
  for (s = 0; s < r; s++) ((i = n[s]), (t[i] = e[i]));
  return t;
}
function io(e) {
  function t(n, s, r, i) {
    let o = n[i++];
    if (o === '__proto__') return !0;
    const l = Number.isFinite(+o),
      a = i >= n.length;
    return (
      (o = !o && g.isArray(r) ? r.length : o),
      a
        ? (g.hasOwnProp(r, o) ? (r[o] = [r[o], s]) : (r[o] = s), !l)
        : ((!r[o] || !g.isObject(r[o])) && (r[o] = []),
          t(n, s, r[o], i) && g.isArray(r[o]) && (r[o] = Ga(r[o])),
          !l)
    );
  }
  if (g.isFormData(e) && g.isFunction(e.entries)) {
    const n = {};
    return (
      g.forEachEntry(e, (s, r) => {
        t(Ka(s), r, n, 0);
      }),
      n
    );
  }
  return null;
}
function Ja(e, t, n) {
  if (g.isString(e))
    try {
      return ((t || JSON.parse)(e), g.trim(e));
    } catch (s) {
      if (s.name !== 'SyntaxError') throw s;
    }
  return (n || JSON.stringify)(e);
}
const kn = {
  transitional: ro,
  adapter: ['xhr', 'http', 'fetch'],
  transformRequest: [
    function (t, n) {
      const s = n.getContentType() || '',
        r = s.indexOf('application/json') > -1,
        i = g.isObject(t);
      if ((i && g.isHTMLForm(t) && (t = new FormData(t)), g.isFormData(t)))
        return r ? JSON.stringify(io(t)) : t;
      if (
        g.isArrayBuffer(t) ||
        g.isBuffer(t) ||
        g.isStream(t) ||
        g.isFile(t) ||
        g.isBlob(t) ||
        g.isReadableStream(t)
      )
        return t;
      if (g.isArrayBufferView(t)) return t.buffer;
      if (g.isURLSearchParams(t))
        return (
          n.setContentType('application/x-www-form-urlencoded;charset=utf-8', !1),
          t.toString()
        );
      let l;
      if (i) {
        if (s.indexOf('application/x-www-form-urlencoded') > -1)
          return Wa(t, this.formSerializer).toString();
        if ((l = g.isFileList(t)) || s.indexOf('multipart/form-data') > -1) {
          const a = this.env && this.env.FormData;
          return ds(l ? { 'files[]': t } : t, a && new a(), this.formSerializer);
        }
      }
      return i || r ? (n.setContentType('application/json', !1), Ja(t)) : t;
    }
  ],
  transformResponse: [
    function (t) {
      const n = this.transitional || kn.transitional,
        s = n && n.forcedJSONParsing,
        r = this.responseType === 'json';
      if (g.isResponse(t) || g.isReadableStream(t)) return t;
      if (t && g.isString(t) && ((s && !this.responseType) || r)) {
        const o = !(n && n.silentJSONParsing) && r;
        try {
          return JSON.parse(t, this.parseReviver);
        } catch (l) {
          if (o)
            throw l.name === 'SyntaxError'
              ? H.from(l, H.ERR_BAD_RESPONSE, this, null, this.response)
              : l;
        }
      }
      return t;
    }
  ],
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  env: { FormData: _e.classes.FormData, Blob: _e.classes.Blob },
  validateStatus: function (t) {
    return t >= 200 && t < 300;
  },
  headers: { common: { Accept: 'application/json, text/plain, */*', 'Content-Type': void 0 } }
};
g.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (e) => {
  kn.headers[e] = {};
});
const Xa = g.toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
  ]),
  Za = (e) => {
    const t = {};
    let n, s, r;
    return (
      e &&
        e
          .split(
            `
`
          )
          .forEach(function (o) {
            ((r = o.indexOf(':')),
              (n = o.substring(0, r).trim().toLowerCase()),
              (s = o.substring(r + 1).trim()),
              !(!n || (t[n] && Xa[n])) &&
                (n === 'set-cookie'
                  ? t[n]
                    ? t[n].push(s)
                    : (t[n] = [s])
                  : (t[n] = t[n] ? t[n] + ', ' + s : s)));
          }),
      t
    );
  },
  Ur = Symbol('internals');
function ln(e) {
  return e && String(e).trim().toLowerCase();
}
function Qn(e) {
  return e === !1 || e == null ? e : g.isArray(e) ? e.map(Qn) : String(e);
}
function Ya(e) {
  const t = Object.create(null),
    n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; (s = n.exec(e)); ) t[s[1]] = s[2];
  return t;
}
const ec = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function As(e, t, n, s, r) {
  if (g.isFunction(s)) return s.call(this, t, n);
  if ((r && (t = n), !!g.isString(t))) {
    if (g.isString(s)) return t.indexOf(s) !== -1;
    if (g.isRegExp(s)) return s.test(t);
  }
}
function tc(e) {
  return e
    .trim()
    .toLowerCase()
    .replace(/([a-z\d])(\w*)/g, (t, n, s) => n.toUpperCase() + s);
}
function nc(e, t) {
  const n = g.toCamelCase(' ' + t);
  ['get', 'set', 'has'].forEach((s) => {
    Object.defineProperty(e, s + n, {
      value: function (r, i, o) {
        return this[s].call(this, t, r, i, o);
      },
      configurable: !0
    });
  });
}
let Oe = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, s) {
    const r = this;
    function i(l, a, f) {
      const c = ln(a);
      if (!c) throw new Error('header name must be a non-empty string');
      const u = g.findKey(r, c);
      (!u || r[u] === void 0 || f === !0 || (f === void 0 && r[u] !== !1)) && (r[u || a] = Qn(l));
    }
    const o = (l, a) => g.forEach(l, (f, c) => i(f, c, a));
    if (g.isPlainObject(t) || t instanceof this.constructor) o(t, n);
    else if (g.isString(t) && (t = t.trim()) && !ec(t)) o(Za(t), n);
    else if (g.isObject(t) && g.isIterable(t)) {
      let l = {},
        a,
        f;
      for (const c of t) {
        if (!g.isArray(c)) throw TypeError('Object iterator must return a key-value pair');
        l[(f = c[0])] = (a = l[f]) ? (g.isArray(a) ? [...a, c[1]] : [a, c[1]]) : c[1];
      }
      o(l, n);
    } else t != null && i(n, t, s);
    return this;
  }
  get(t, n) {
    if (((t = ln(t)), t)) {
      const s = g.findKey(this, t);
      if (s) {
        const r = this[s];
        if (!n) return r;
        if (n === !0) return Ya(r);
        if (g.isFunction(n)) return n.call(this, r, s);
        if (g.isRegExp(n)) return n.exec(r);
        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }
  has(t, n) {
    if (((t = ln(t)), t)) {
      const s = g.findKey(this, t);
      return !!(s && this[s] !== void 0 && (!n || As(this, this[s], s, n)));
    }
    return !1;
  }
  delete(t, n) {
    const s = this;
    let r = !1;
    function i(o) {
      if (((o = ln(o)), o)) {
        const l = g.findKey(s, o);
        l && (!n || As(s, s[l], l, n)) && (delete s[l], (r = !0));
      }
    }
    return (g.isArray(t) ? t.forEach(i) : i(t), r);
  }
  clear(t) {
    const n = Object.keys(this);
    let s = n.length,
      r = !1;
    for (; s--; ) {
      const i = n[s];
      (!t || As(this, this[i], i, t, !0)) && (delete this[i], (r = !0));
    }
    return r;
  }
  normalize(t) {
    const n = this,
      s = {};
    return (
      g.forEach(this, (r, i) => {
        const o = g.findKey(s, i);
        if (o) {
          ((n[o] = Qn(r)), delete n[i]);
          return;
        }
        const l = t ? tc(i) : String(i).trim();
        (l !== i && delete n[i], (n[l] = Qn(r)), (s[l] = !0));
      }),
      this
    );
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = Object.create(null);
    return (
      g.forEach(this, (s, r) => {
        s != null && s !== !1 && (n[r] = t && g.isArray(s) ? s.join(', ') : s);
      }),
      n
    );
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ': ' + n).join(`
`);
  }
  getSetCookie() {
    return this.get('set-cookie') || [];
  }
  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const s = new this(t);
    return (n.forEach((r) => s.set(r)), s);
  }
  static accessor(t) {
    const s = (this[Ur] = this[Ur] = { accessors: {} }).accessors,
      r = this.prototype;
    function i(o) {
      const l = ln(o);
      s[l] || (nc(r, o), (s[l] = !0));
    }
    return (g.isArray(t) ? t.forEach(i) : i(t), this);
  }
};
Oe.accessor([
  'Content-Type',
  'Content-Length',
  'Accept',
  'Accept-Encoding',
  'User-Agent',
  'Authorization'
]);
g.reduceDescriptors(Oe.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(s) {
      this[n] = s;
    }
  };
});
g.freezeMethods(Oe);
function ks(e, t) {
  const n = this || kn,
    s = t || n,
    r = Oe.from(s.headers);
  let i = s.data;
  return (
    g.forEach(e, function (l) {
      i = l.call(n, i, r.normalize(), t ? t.status : void 0);
    }),
    r.normalize(),
    i
  );
}
function oo(e) {
  return !!(e && e.__CANCEL__);
}
function en(e, t, n) {
  (H.call(this, e ?? 'canceled', H.ERR_CANCELED, t, n), (this.name = 'CanceledError'));
}
g.inherits(en, H, { __CANCEL__: !0 });
function lo(e, t, n) {
  const s = n.config.validateStatus;
  !n.status || !s || s(n.status)
    ? e(n)
    : t(
        new H(
          'Request failed with status code ' + n.status,
          [H.ERR_BAD_REQUEST, H.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
          n.config,
          n.request,
          n
        )
      );
}
function sc(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return (t && t[1]) || '';
}
function rc(e, t) {
  e = e || 10;
  const n = new Array(e),
    s = new Array(e);
  let r = 0,
    i = 0,
    o;
  return (
    (t = t !== void 0 ? t : 1e3),
    function (a) {
      const f = Date.now(),
        c = s[i];
      (o || (o = f), (n[r] = a), (s[r] = f));
      let u = i,
        m = 0;
      for (; u !== r; ) ((m += n[u++]), (u = u % e));
      if (((r = (r + 1) % e), r === i && (i = (i + 1) % e), f - o < t)) return;
      const y = c && f - c;
      return y ? Math.round((m * 1e3) / y) : void 0;
    }
  );
}
function ic(e, t) {
  let n = 0,
    s = 1e3 / t,
    r,
    i;
  const o = (f, c = Date.now()) => {
    ((n = c), (r = null), i && (clearTimeout(i), (i = null)), e(...f));
  };
  return [
    (...f) => {
      const c = Date.now(),
        u = c - n;
      u >= s
        ? o(f, c)
        : ((r = f),
          i ||
            (i = setTimeout(() => {
              ((i = null), o(r));
            }, s - u)));
    },
    () => r && o(r)
  ];
}
const Xn = (e, t, n = 3) => {
    let s = 0;
    const r = rc(50, 250);
    return ic((i) => {
      const o = i.loaded,
        l = i.lengthComputable ? i.total : void 0,
        a = o - s,
        f = r(a),
        c = o <= l;
      s = o;
      const u = {
        loaded: o,
        total: l,
        progress: l ? o / l : void 0,
        bytes: a,
        rate: f || void 0,
        estimated: f && l && c ? (l - o) / f : void 0,
        event: i,
        lengthComputable: l != null,
        [t ? 'download' : 'upload']: !0
      };
      e(u);
    }, n);
  },
  Hr = (e, t) => {
    const n = e != null;
    return [(s) => t[0]({ lengthComputable: n, total: e, loaded: s }), t[1]];
  },
  Qr =
    (e) =>
    (...t) =>
      g.asap(() => e(...t)),
  oc = _e.hasStandardBrowserEnv
    ? ((e, t) => (n) => (
        (n = new URL(n, _e.origin)),
        e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)
      ))(new URL(_e.origin), _e.navigator && /(msie|trident)/i.test(_e.navigator.userAgent))
    : () => !0,
  lc = _e.hasStandardBrowserEnv
    ? {
        write(e, t, n, s, r, i) {
          const o = [e + '=' + encodeURIComponent(t)];
          (g.isNumber(n) && o.push('expires=' + new Date(n).toGMTString()),
            g.isString(s) && o.push('path=' + s),
            g.isString(r) && o.push('domain=' + r),
            i === !0 && o.push('secure'),
            (document.cookie = o.join('; ')));
        },
        read(e) {
          const t = document.cookie.match(new RegExp('(^|;\\s*)(' + e + ')=([^;]*)'));
          return t ? decodeURIComponent(t[3]) : null;
        },
        remove(e) {
          this.write(e, '', Date.now() - 864e5);
        }
      }
    : {
        write() {},
        read() {
          return null;
        },
        remove() {}
      };
function ac(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function cc(e, t) {
  return t ? e.replace(/\/?\/$/, '') + '/' + t.replace(/^\/+/, '') : e;
}
function ao(e, t, n) {
  let s = !ac(t);
  return e && (s || n == !1) ? cc(e, t) : t;
}
const Vr = (e) => (e instanceof Oe ? { ...e } : e);
function It(e, t) {
  t = t || {};
  const n = {};
  function s(f, c, u, m) {
    return g.isPlainObject(f) && g.isPlainObject(c)
      ? g.merge.call({ caseless: m }, f, c)
      : g.isPlainObject(c)
        ? g.merge({}, c)
        : g.isArray(c)
          ? c.slice()
          : c;
  }
  function r(f, c, u, m) {
    if (g.isUndefined(c)) {
      if (!g.isUndefined(f)) return s(void 0, f, u, m);
    } else return s(f, c, u, m);
  }
  function i(f, c) {
    if (!g.isUndefined(c)) return s(void 0, c);
  }
  function o(f, c) {
    if (g.isUndefined(c)) {
      if (!g.isUndefined(f)) return s(void 0, f);
    } else return s(void 0, c);
  }
  function l(f, c, u) {
    if (u in t) return s(f, c);
    if (u in e) return s(void 0, f);
  }
  const a = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: l,
    headers: (f, c, u) => r(Vr(f), Vr(c), u, !0)
  };
  return (
    g.forEach(Object.keys({ ...e, ...t }), function (c) {
      const u = a[c] || r,
        m = u(e[c], t[c], c);
      (g.isUndefined(m) && u !== l) || (n[c] = m);
    }),
    n
  );
}
const co = (e) => {
    const t = It({}, e);
    let {
      data: n,
      withXSRFToken: s,
      xsrfHeaderName: r,
      xsrfCookieName: i,
      headers: o,
      auth: l
    } = t;
    if (
      ((t.headers = o = Oe.from(o)),
      (t.url = so(ao(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer)),
      l &&
        o.set(
          'Authorization',
          'Basic ' +
            btoa(
              (l.username || '') +
                ':' +
                (l.password ? unescape(encodeURIComponent(l.password)) : '')
            )
        ),
      g.isFormData(n))
    ) {
      if (_e.hasStandardBrowserEnv || _e.hasStandardBrowserWebWorkerEnv) o.setContentType(void 0);
      else if (g.isFunction(n.getHeaders)) {
        const a = n.getHeaders(),
          f = ['content-type', 'content-length'];
        Object.entries(a).forEach(([c, u]) => {
          f.includes(c.toLowerCase()) && o.set(c, u);
        });
      }
    }
    if (
      _e.hasStandardBrowserEnv &&
      (s && g.isFunction(s) && (s = s(t)), s || (s !== !1 && oc(t.url)))
    ) {
      const a = r && i && lc.read(i);
      a && o.set(r, a);
    }
    return t;
  },
  fc = typeof XMLHttpRequest < 'u',
  uc =
    fc &&
    function (e) {
      return new Promise(function (n, s) {
        const r = co(e);
        let i = r.data;
        const o = Oe.from(r.headers).normalize();
        let { responseType: l, onUploadProgress: a, onDownloadProgress: f } = r,
          c,
          u,
          m,
          y,
          h;
        function q() {
          (y && y(),
            h && h(),
            r.cancelToken && r.cancelToken.unsubscribe(c),
            r.signal && r.signal.removeEventListener('abort', c));
        }
        let w = new XMLHttpRequest();
        (w.open(r.method.toUpperCase(), r.url, !0), (w.timeout = r.timeout));
        function O() {
          if (!w) return;
          const N = Oe.from('getAllResponseHeaders' in w && w.getAllResponseHeaders()),
            j = {
              data: !l || l === 'text' || l === 'json' ? w.responseText : w.response,
              status: w.status,
              statusText: w.statusText,
              headers: N,
              config: e,
              request: w
            };
          (lo(
            function (K) {
              (n(K), q());
            },
            function (K) {
              (s(K), q());
            },
            j
          ),
            (w = null));
        }
        ('onloadend' in w
          ? (w.onloadend = O)
          : (w.onreadystatechange = function () {
              !w ||
                w.readyState !== 4 ||
                (w.status === 0 && !(w.responseURL && w.responseURL.indexOf('file:') === 0)) ||
                setTimeout(O);
            }),
          (w.onabort = function () {
            w && (s(new H('Request aborted', H.ECONNABORTED, e, w)), (w = null));
          }),
          (w.onerror = function (F) {
            const j = F && F.message ? F.message : 'Network Error',
              te = new H(j, H.ERR_NETWORK, e, w);
            ((te.event = F || null), s(te), (w = null));
          }),
          (w.ontimeout = function () {
            let F = r.timeout ? 'timeout of ' + r.timeout + 'ms exceeded' : 'timeout exceeded';
            const j = r.transitional || ro;
            (r.timeoutErrorMessage && (F = r.timeoutErrorMessage),
              s(new H(F, j.clarifyTimeoutError ? H.ETIMEDOUT : H.ECONNABORTED, e, w)),
              (w = null));
          }),
          i === void 0 && o.setContentType(null),
          'setRequestHeader' in w &&
            g.forEach(o.toJSON(), function (F, j) {
              w.setRequestHeader(j, F);
            }),
          g.isUndefined(r.withCredentials) || (w.withCredentials = !!r.withCredentials),
          l && l !== 'json' && (w.responseType = r.responseType),
          f && (([m, h] = Xn(f, !0)), w.addEventListener('progress', m)),
          a &&
            w.upload &&
            (([u, y] = Xn(a)),
            w.upload.addEventListener('progress', u),
            w.upload.addEventListener('loadend', y)),
          (r.cancelToken || r.signal) &&
            ((c = (N) => {
              w && (s(!N || N.type ? new en(null, e, w) : N), w.abort(), (w = null));
            }),
            r.cancelToken && r.cancelToken.subscribe(c),
            r.signal && (r.signal.aborted ? c() : r.signal.addEventListener('abort', c))));
        const $ = sc(r.url);
        if ($ && _e.protocols.indexOf($) === -1) {
          s(new H('Unsupported protocol ' + $ + ':', H.ERR_BAD_REQUEST, e));
          return;
        }
        w.send(i || null);
      });
    },
  dc = (e, t) => {
    const { length: n } = (e = e ? e.filter(Boolean) : []);
    if (t || n) {
      let s = new AbortController(),
        r;
      const i = function (f) {
        if (!r) {
          ((r = !0), l());
          const c = f instanceof Error ? f : this.reason;
          s.abort(c instanceof H ? c : new en(c instanceof Error ? c.message : c));
        }
      };
      let o =
        t &&
        setTimeout(() => {
          ((o = null), i(new H(`timeout ${t} of ms exceeded`, H.ETIMEDOUT)));
        }, t);
      const l = () => {
        e &&
          (o && clearTimeout(o),
          (o = null),
          e.forEach((f) => {
            f.unsubscribe ? f.unsubscribe(i) : f.removeEventListener('abort', i);
          }),
          (e = null));
      };
      e.forEach((f) => f.addEventListener('abort', i));
      const { signal: a } = s;
      return ((a.unsubscribe = () => g.asap(l)), a);
    }
  },
  pc = function* (e, t) {
    let n = e.byteLength;
    if (n < t) {
      yield e;
      return;
    }
    let s = 0,
      r;
    for (; s < n; ) ((r = s + t), yield e.slice(s, r), (s = r));
  },
  hc = async function* (e, t) {
    for await (const n of mc(e)) yield* pc(n, t);
  },
  mc = async function* (e) {
    if (e[Symbol.asyncIterator]) {
      yield* e;
      return;
    }
    const t = e.getReader();
    try {
      for (;;) {
        const { done: n, value: s } = await t.read();
        if (n) break;
        yield s;
      }
    } finally {
      await t.cancel();
    }
  },
  Wr = (e, t, n, s) => {
    const r = hc(e, t);
    let i = 0,
      o,
      l = (a) => {
        o || ((o = !0), s && s(a));
      };
    return new ReadableStream(
      {
        async pull(a) {
          try {
            const { done: f, value: c } = await r.next();
            if (f) {
              (l(), a.close());
              return;
            }
            let u = c.byteLength;
            if (n) {
              let m = (i += u);
              n(m);
            }
            a.enqueue(new Uint8Array(c));
          } catch (f) {
            throw (l(f), f);
          }
        },
        cancel(a) {
          return (l(a), r.return());
        }
      },
      { highWaterMark: 2 }
    );
  },
  Kr = 64 * 1024,
  { isFunction: jn } = g,
  gc = (({ Request: e, Response: t }) => ({ Request: e, Response: t }))(g.global),
  { ReadableStream: Gr, TextEncoder: Jr } = g.global,
  Xr = (e, ...t) => {
    try {
      return !!e(...t);
    } catch {
      return !1;
    }
  },
  bc = (e) => {
    e = g.merge.call({ skipUndefined: !0 }, gc, e);
    const { fetch: t, Request: n, Response: s } = e,
      r = t ? jn(t) : typeof fetch == 'function',
      i = jn(n),
      o = jn(s);
    if (!r) return !1;
    const l = r && jn(Gr),
      a =
        r &&
        (typeof Jr == 'function'
          ? (
              (h) => (q) =>
                h.encode(q)
            )(new Jr())
          : async (h) => new Uint8Array(await new n(h).arrayBuffer())),
      f =
        i &&
        l &&
        Xr(() => {
          let h = !1;
          const q = new n(_e.origin, {
            body: new Gr(),
            method: 'POST',
            get duplex() {
              return ((h = !0), 'half');
            }
          }).headers.has('Content-Type');
          return h && !q;
        }),
      c = o && l && Xr(() => g.isReadableStream(new s('').body)),
      u = { stream: c && ((h) => h.body) };
    r &&
      ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach((h) => {
        !u[h] &&
          (u[h] = (q, w) => {
            let O = q && q[h];
            if (O) return O.call(q);
            throw new H(`Response type '${h}' is not supported`, H.ERR_NOT_SUPPORT, w);
          });
      });
    const m = async (h) => {
        if (h == null) return 0;
        if (g.isBlob(h)) return h.size;
        if (g.isSpecCompliantForm(h))
          return (await new n(_e.origin, { method: 'POST', body: h }).arrayBuffer()).byteLength;
        if (g.isArrayBufferView(h) || g.isArrayBuffer(h)) return h.byteLength;
        if ((g.isURLSearchParams(h) && (h = h + ''), g.isString(h))) return (await a(h)).byteLength;
      },
      y = async (h, q) => {
        const w = g.toFiniteNumber(h.getContentLength());
        return w ?? m(q);
      };
    return async (h) => {
      let {
          url: q,
          method: w,
          data: O,
          signal: $,
          cancelToken: N,
          timeout: F,
          onDownloadProgress: j,
          onUploadProgress: te,
          responseType: K,
          headers: I,
          withCredentials: x = 'same-origin',
          fetchOptions: M
        } = co(h),
        W = t || fetch;
      K = K ? (K + '').toLowerCase() : 'text';
      let A = dc([$, N && N.toAbortSignal()], F),
        G = null;
      const se =
        A &&
        A.unsubscribe &&
        (() => {
          A.unsubscribe();
        });
      let Ae;
      try {
        if (te && f && w !== 'get' && w !== 'head' && (Ae = await y(I, O)) !== 0) {
          let we = new n(q, { method: 'POST', body: O, duplex: 'half' }),
            ye;
          if (
            (g.isFormData(O) && (ye = we.headers.get('content-type')) && I.setContentType(ye),
            we.body)
          ) {
            const [zt, Lt] = Hr(Ae, Xn(Qr(te)));
            O = Wr(we.body, Kr, zt, Lt);
          }
        }
        g.isString(x) || (x = x ? 'include' : 'omit');
        const J = i && 'credentials' in n.prototype,
          V = {
            ...M,
            signal: A,
            method: w.toUpperCase(),
            headers: I.normalize().toJSON(),
            body: O,
            duplex: 'half',
            credentials: J ? x : void 0
          };
        G = i && new n(q, V);
        let X = await (i ? W(G, M) : W(q, V));
        const Ke = c && (K === 'stream' || K === 'response');
        if (c && (j || (Ke && se))) {
          const we = {};
          ['status', 'statusText', 'headers'].forEach(($n) => {
            we[$n] = X[$n];
          });
          const ye = g.toFiniteNumber(X.headers.get('content-length')),
            [zt, Lt] = (j && Hr(ye, Xn(Qr(j), !0))) || [];
          X = new s(
            Wr(X.body, Kr, zt, () => {
              (Lt && Lt(), se && se());
            }),
            we
          );
        }
        K = K || 'text';
        let Bt = await u[g.findKey(u, K) || 'text'](X, h);
        return (
          !Ke && se && se(),
          await new Promise((we, ye) => {
            lo(we, ye, {
              data: Bt,
              headers: Oe.from(X.headers),
              status: X.status,
              statusText: X.statusText,
              config: h,
              request: G
            });
          })
        );
      } catch (J) {
        throw (
          se && se(),
          J && J.name === 'TypeError' && /Load failed|fetch/i.test(J.message)
            ? Object.assign(new H('Network Error', H.ERR_NETWORK, h, G), { cause: J.cause || J })
            : H.from(J, J && J.code, h, G)
        );
      }
    };
  },
  yc = new Map(),
  fo = (e) => {
    let t = e ? e.env : {};
    const { fetch: n, Request: s, Response: r } = t,
      i = [s, r, n];
    let o = i.length,
      l = o,
      a,
      f,
      c = yc;
    for (; l--; )
      ((a = i[l]), (f = c.get(a)), f === void 0 && c.set(a, (f = l ? new Map() : bc(t))), (c = f));
    return f;
  };
fo();
const Ks = { http: Ma, xhr: uc, fetch: { get: fo } };
g.forEach(Ks, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, 'name', { value: t });
    } catch {}
    Object.defineProperty(e, 'adapterName', { value: t });
  }
});
const Zr = (e) => `- ${e}`,
  qc = (e) => g.isFunction(e) || e === null || e === !1,
  uo = {
    getAdapter: (e, t) => {
      e = g.isArray(e) ? e : [e];
      const { length: n } = e;
      let s, r;
      const i = {};
      for (let o = 0; o < n; o++) {
        s = e[o];
        let l;
        if (((r = s), !qc(s) && ((r = Ks[(l = String(s)).toLowerCase()]), r === void 0)))
          throw new H(`Unknown adapter '${l}'`);
        if (r && (g.isFunction(r) || (r = r.get(t)))) break;
        i[l || '#' + o] = r;
      }
      if (!r) {
        const o = Object.entries(i).map(
          ([a, f]) =>
            `adapter ${a} ` +
            (f === !1 ? 'is not supported by the environment' : 'is not available in the build')
        );
        let l = n
          ? o.length > 1
            ? `since :
` +
              o.map(Zr).join(`
`)
            : ' ' + Zr(o[0])
          : 'as no adapter specified';
        throw new H('There is no suitable adapter to dispatch the request ' + l, 'ERR_NOT_SUPPORT');
      }
      return r;
    },
    adapters: Ks
  };
function Rs(e) {
  if ((e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted))
    throw new en(null, e);
}
function Yr(e) {
  return (
    Rs(e),
    (e.headers = Oe.from(e.headers)),
    (e.data = ks.call(e, e.transformRequest)),
    ['post', 'put', 'patch'].indexOf(e.method) !== -1 &&
      e.headers.setContentType('application/x-www-form-urlencoded', !1),
    uo
      .getAdapter(
        e.adapter || kn.adapter,
        e
      )(e)
      .then(
        function (s) {
          return (
            Rs(e),
            (s.data = ks.call(e, e.transformResponse, s)),
            (s.headers = Oe.from(s.headers)),
            s
          );
        },
        function (s) {
          return (
            oo(s) ||
              (Rs(e),
              s &&
                s.response &&
                ((s.response.data = ks.call(e, e.transformResponse, s.response)),
                (s.response.headers = Oe.from(s.response.headers)))),
            Promise.reject(s)
          );
        }
      )
  );
}
const po = '1.12.2',
  ps = {};
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((e, t) => {
  ps[e] = function (s) {
    return typeof s === e || 'a' + (t < 1 ? 'n ' : ' ') + e;
  };
});
const ei = {};
ps.transitional = function (t, n, s) {
  function r(i, o) {
    return '[Axios v' + po + "] Transitional option '" + i + "'" + o + (s ? '. ' + s : '');
  }
  return (i, o, l) => {
    if (t === !1) throw new H(r(o, ' has been removed' + (n ? ' in ' + n : '')), H.ERR_DEPRECATED);
    return (
      n &&
        !ei[o] &&
        ((ei[o] = !0),
        console.warn(
          r(o, ' has been deprecated since v' + n + ' and will be removed in the near future')
        )),
      t ? t(i, o, l) : !0
    );
  };
};
ps.spelling = function (t) {
  return (n, s) => (console.warn(`${s} is likely a misspelling of ${t}`), !0);
};
function wc(e, t, n) {
  if (typeof e != 'object') throw new H('options must be an object', H.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(e);
  let r = s.length;
  for (; r-- > 0; ) {
    const i = s[r],
      o = t[i];
    if (o) {
      const l = e[i],
        a = l === void 0 || o(l, i, e);
      if (a !== !0) throw new H('option ' + i + ' must be ' + a, H.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0) throw new H('Unknown option ' + i, H.ERR_BAD_OPTION);
  }
}
const Vn = { assertOptions: wc, validators: ps },
  Ze = Vn.validators;
let Rt = class {
  constructor(t) {
    ((this.defaults = t || {}), (this.interceptors = { request: new Dr(), response: new Dr() }));
  }
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (s) {
      if (s instanceof Error) {
        let r = {};
        Error.captureStackTrace ? Error.captureStackTrace(r) : (r = new Error());
        const i = r.stack ? r.stack.replace(/^.+\n/, '') : '';
        try {
          s.stack
            ? i &&
              !String(s.stack).endsWith(i.replace(/^.+\n.+\n/, '')) &&
              (s.stack +=
                `
` + i)
            : (s.stack = i);
        } catch {}
      }
      throw s;
    }
  }
  _request(t, n) {
    (typeof t == 'string' ? ((n = n || {}), (n.url = t)) : (n = t || {}),
      (n = It(this.defaults, n)));
    const { transitional: s, paramsSerializer: r, headers: i } = n;
    (s !== void 0 &&
      Vn.assertOptions(
        s,
        {
          silentJSONParsing: Ze.transitional(Ze.boolean),
          forcedJSONParsing: Ze.transitional(Ze.boolean),
          clarifyTimeoutError: Ze.transitional(Ze.boolean)
        },
        !1
      ),
      r != null &&
        (g.isFunction(r)
          ? (n.paramsSerializer = { serialize: r })
          : Vn.assertOptions(r, { encode: Ze.function, serialize: Ze.function }, !0)),
      n.allowAbsoluteUrls !== void 0 ||
        (this.defaults.allowAbsoluteUrls !== void 0
          ? (n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls)
          : (n.allowAbsoluteUrls = !0)),
      Vn.assertOptions(
        n,
        { baseUrl: Ze.spelling('baseURL'), withXsrfToken: Ze.spelling('withXSRFToken') },
        !0
      ),
      (n.method = (n.method || this.defaults.method || 'get').toLowerCase()));
    let o = i && g.merge(i.common, i[n.method]);
    (i &&
      g.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], (h) => {
        delete i[h];
      }),
      (n.headers = Oe.concat(o, i)));
    const l = [];
    let a = !0;
    this.interceptors.request.forEach(function (q) {
      (typeof q.runWhen == 'function' && q.runWhen(n) === !1) ||
        ((a = a && q.synchronous), l.unshift(q.fulfilled, q.rejected));
    });
    const f = [];
    this.interceptors.response.forEach(function (q) {
      f.push(q.fulfilled, q.rejected);
    });
    let c,
      u = 0,
      m;
    if (!a) {
      const h = [Yr.bind(this), void 0];
      for (h.unshift(...l), h.push(...f), m = h.length, c = Promise.resolve(n); u < m; )
        c = c.then(h[u++], h[u++]);
      return c;
    }
    m = l.length;
    let y = n;
    for (; u < m; ) {
      const h = l[u++],
        q = l[u++];
      try {
        y = h(y);
      } catch (w) {
        q.call(this, w);
        break;
      }
    }
    try {
      c = Yr.call(this, y);
    } catch (h) {
      return Promise.reject(h);
    }
    for (u = 0, m = f.length; u < m; ) c = c.then(f[u++], f[u++]);
    return c;
  }
  getUri(t) {
    t = It(this.defaults, t);
    const n = ao(t.baseURL, t.url, t.allowAbsoluteUrls);
    return so(n, t.params, t.paramsSerializer);
  }
};
g.forEach(['delete', 'get', 'head', 'options'], function (t) {
  Rt.prototype[t] = function (n, s) {
    return this.request(It(s || {}, { method: t, url: n, data: (s || {}).data }));
  };
});
g.forEach(['post', 'put', 'patch'], function (t) {
  function n(s) {
    return function (i, o, l) {
      return this.request(
        It(l || {}, {
          method: t,
          headers: s ? { 'Content-Type': 'multipart/form-data' } : {},
          url: i,
          data: o
        })
      );
    };
  }
  ((Rt.prototype[t] = n()), (Rt.prototype[t + 'Form'] = n(!0)));
});
let xc = class ho {
  constructor(t) {
    if (typeof t != 'function') throw new TypeError('executor must be a function.');
    let n;
    this.promise = new Promise(function (i) {
      n = i;
    });
    const s = this;
    (this.promise.then((r) => {
      if (!s._listeners) return;
      let i = s._listeners.length;
      for (; i-- > 0; ) s._listeners[i](r);
      s._listeners = null;
    }),
      (this.promise.then = (r) => {
        let i;
        const o = new Promise((l) => {
          (s.subscribe(l), (i = l));
        }).then(r);
        return (
          (o.cancel = function () {
            s.unsubscribe(i);
          }),
          o
        );
      }),
      t(function (i, o, l) {
        s.reason || ((s.reason = new en(i, o, l)), n(s.reason));
      }));
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : (this._listeners = [t]);
  }
  unsubscribe(t) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(),
      n = (s) => {
        t.abort(s);
      };
    return (this.subscribe(n), (t.signal.unsubscribe = () => this.unsubscribe(n)), t.signal);
  }
  static source() {
    let t;
    return {
      token: new ho(function (r) {
        t = r;
      }),
      cancel: t
    };
  }
};
function vc(e) {
  return function (n) {
    return e.apply(null, n);
  };
}
function _c(e) {
  return g.isObject(e) && e.isAxiosError === !0;
}
const Gs = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Gs).forEach(([e, t]) => {
  Gs[t] = e;
});
function mo(e) {
  const t = new Rt(e),
    n = Qi(Rt.prototype.request, t);
  return (
    g.extend(n, Rt.prototype, t, { allOwnKeys: !0 }),
    g.extend(n, t, null, { allOwnKeys: !0 }),
    (n.create = function (r) {
      return mo(It(e, r));
    }),
    n
  );
}
const pe = mo(kn);
pe.Axios = Rt;
pe.CanceledError = en;
pe.CancelToken = xc;
pe.isCancel = oo;
pe.VERSION = po;
pe.toFormData = ds;
pe.AxiosError = H;
pe.Cancel = pe.CanceledError;
pe.all = function (t) {
  return Promise.all(t);
};
pe.spread = vc;
pe.isAxiosError = _c;
pe.mergeConfig = It;
pe.AxiosHeaders = Oe;
pe.formToJSON = (e) => io(g.isHTMLForm(e) ? new FormData(e) : e);
pe.getAdapter = uo.getAdapter;
pe.HttpStatusCode = Gs;
pe.default = pe;
const {
  Axios: Zp,
  AxiosError: Yp,
  CanceledError: eh,
  isCancel: th,
  CancelToken: nh,
  VERSION: sh,
  all: rh,
  Cancel: ih,
  isAxiosError: oh,
  spread: lh,
  toFormData: ah,
  AxiosHeaders: ch,
  HttpStatusCode: fh,
  formToJSON: uh,
  getAdapter: dh,
  mergeConfig: ph
} = pe;
window.axios = pe;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
/**
 * @vue/shared v3.5.13
 * (c) 2018-present Yuxi (Evan) You and Vue contributors
 * @license MIT
 **/ /*! #__NO_SIDE_EFFECTS__ */ function pr(e) {
  const t = Object.create(null);
  for (const n of e.split(',')) t[n] = 1;
  return (n) => n in t;
}
const oe = {},
  Qt = [],
  st = () => {},
  Sc = () => !1,
  hs = (e) =>
    e.charCodeAt(0) === 111 &&
    e.charCodeAt(1) === 110 &&
    (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97),
  hr = (e) => e.startsWith('onUpdate:'),
  ge = Object.assign,
  mr = (e, t) => {
    const n = e.indexOf(t);
    n > -1 && e.splice(n, 1);
  },
  Cc = Object.prototype.hasOwnProperty,
  re = (e, t) => Cc.call(e, t),
  B = Array.isArray,
  Vt = (e) => Rn(e) === '[object Map]',
  tn = (e) => Rn(e) === '[object Set]',
  ti = (e) => Rn(e) === '[object Date]',
  U = (e) => typeof e == 'function',
  ue = (e) => typeof e == 'string',
  Qe = (e) => typeof e == 'symbol',
  ae = (e) => e !== null && typeof e == 'object',
  go = (e) => (ae(e) || U(e)) && U(e.then) && U(e.catch),
  bo = Object.prototype.toString,
  Rn = (e) => bo.call(e),
  Ec = (e) => Rn(e).slice(8, -1),
  yo = (e) => Rn(e) === '[object Object]',
  gr = (e) => ue(e) && e !== 'NaN' && e[0] !== '-' && '' + parseInt(e, 10) === e,
  un = pr(
    ',key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted'
  ),
  ms = (e) => {
    const t = Object.create(null);
    return (n) => t[n] || (t[n] = e(n));
  },
  Tc = /-(\w)/g,
  Le = ms((e) => e.replace(Tc, (t, n) => (n ? n.toUpperCase() : ''))),
  Fc = /\B([A-Z])/g,
  xt = ms((e) => e.replace(Fc, '-$1').toLowerCase()),
  gs = ms((e) => e.charAt(0).toUpperCase() + e.slice(1)),
  Os = ms((e) => (e ? `on${gs(e)}` : '')),
  bt = (e, t) => !Object.is(e, t),
  Wn = (e, ...t) => {
    for (let n = 0; n < e.length; n++) e[n](...t);
  },
  qo = (e, t, n, s = !1) => {
    Object.defineProperty(e, t, { configurable: !0, enumerable: !1, writable: s, value: n });
  },
  Zn = (e) => {
    const t = parseFloat(e);
    return isNaN(t) ? e : t;
  },
  Ac = (e) => {
    const t = ue(e) ? Number(e) : NaN;
    return isNaN(t) ? e : t;
  };
let ni;
const bs = () =>
  ni ||
  (ni =
    typeof globalThis < 'u'
      ? globalThis
      : typeof self < 'u'
        ? self
        : typeof window < 'u'
          ? window
          : typeof global < 'u'
            ? global
            : {});
function nn(e) {
  if (B(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const s = e[n],
        r = ue(s) ? Pc(s) : nn(s);
      if (r) for (const i in r) t[i] = r[i];
    }
    return t;
  } else if (ue(e) || ae(e)) return e;
}
const kc = /;(?![^(]*\))/g,
  Rc = /:([^]+)/,
  Oc = /\/\*[^]*?\*\//g;
function Pc(e) {
  const t = {};
  return (
    e
      .replace(Oc, '')
      .split(kc)
      .forEach((n) => {
        if (n) {
          const s = n.split(Rc);
          s.length > 1 && (t[s[0].trim()] = s[1].trim());
        }
      }),
    t
  );
}
function Pe(e) {
  let t = '';
  if (ue(e)) t = e;
  else if (B(e))
    for (let n = 0; n < e.length; n++) {
      const s = Pe(e[n]);
      s && (t += s + ' ');
    }
  else if (ae(e)) for (const n in e) e[n] && (t += n + ' ');
  return t.trim();
}
const Ic = 'itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly',
  Mc = pr(Ic);
function wo(e) {
  return !!e || e === '';
}
function $c(e, t) {
  if (e.length !== t.length) return !1;
  let n = !0;
  for (let s = 0; n && s < e.length; s++) n = Mt(e[s], t[s]);
  return n;
}
function Mt(e, t) {
  if (e === t) return !0;
  let n = ti(e),
    s = ti(t);
  if (n || s) return n && s ? e.getTime() === t.getTime() : !1;
  if (((n = Qe(e)), (s = Qe(t)), n || s)) return e === t;
  if (((n = B(e)), (s = B(t)), n || s)) return n && s ? $c(e, t) : !1;
  if (((n = ae(e)), (s = ae(t)), n || s)) {
    if (!n || !s) return !1;
    const r = Object.keys(e).length,
      i = Object.keys(t).length;
    if (r !== i) return !1;
    for (const o in e) {
      const l = e.hasOwnProperty(o),
        a = t.hasOwnProperty(o);
      if ((l && !a) || (!l && a) || !Mt(e[o], t[o])) return !1;
    }
  }
  return String(e) === String(t);
}
function br(e, t) {
  return e.findIndex((n) => Mt(n, t));
}
const xo = (e) => !!(e && e.__v_isRef === !0),
  qe = (e) =>
    ue(e)
      ? e
      : e == null
        ? ''
        : B(e) || (ae(e) && (e.toString === bo || !U(e.toString)))
          ? xo(e)
            ? qe(e.value)
            : JSON.stringify(e, vo, 2)
          : String(e),
  vo = (e, t) =>
    xo(t)
      ? vo(e, t.value)
      : Vt(t)
        ? {
            [`Map(${t.size})`]: [...t.entries()].reduce(
              (n, [s, r], i) => ((n[Ps(s, i) + ' =>'] = r), n),
              {}
            )
          }
        : tn(t)
          ? { [`Set(${t.size})`]: [...t.values()].map((n) => Ps(n)) }
          : Qe(t)
            ? Ps(t)
            : ae(t) && !B(t) && !yo(t)
              ? String(t)
              : t,
  Ps = (e, t = '') => {
    var n;
    return Qe(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e;
  };
/**
 * @vue/reactivity v3.5.13
 * (c) 2018-present Yuxi (Evan) You and Vue contributors
 * @license MIT
 **/ let Ce;
class _o {
  constructor(t = !1) {
    ((this.detached = t),
      (this._active = !0),
      (this.effects = []),
      (this.cleanups = []),
      (this._isPaused = !1),
      (this.parent = Ce),
      !t && Ce && (this.index = (Ce.scopes || (Ce.scopes = [])).push(this) - 1));
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, n;
      if (this.scopes) for (t = 0, n = this.scopes.length; t < n; t++) this.scopes[t].pause();
      for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].pause();
    }
  }
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, n;
      if (this.scopes) for (t = 0, n = this.scopes.length; t < n; t++) this.scopes[t].resume();
      for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const n = Ce;
      try {
        return ((Ce = this), t());
      } finally {
        Ce = n;
      }
    }
  }
  on() {
    Ce = this;
  }
  off() {
    Ce = this.parent;
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let n, s;
      for (n = 0, s = this.effects.length; n < s; n++) this.effects[n].stop();
      for (this.effects.length = 0, n = 0, s = this.cleanups.length; n < s; n++) this.cleanups[n]();
      if (((this.cleanups.length = 0), this.scopes)) {
        for (n = 0, s = this.scopes.length; n < s; n++) this.scopes[n].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const r = this.parent.scopes.pop();
        r && r !== this && ((this.parent.scopes[this.index] = r), (r.index = this.index));
      }
      this.parent = void 0;
    }
  }
}
function So(e) {
  return new _o(e);
}
function Co() {
  return Ce;
}
function Nc(e, t = !1) {
  Ce && Ce.cleanups.push(e);
}
let fe;
const Is = new WeakSet();
class Eo {
  constructor(t) {
    ((this.fn = t),
      (this.deps = void 0),
      (this.depsTail = void 0),
      (this.flags = 5),
      (this.next = void 0),
      (this.cleanup = void 0),
      (this.scheduler = void 0),
      Ce && Ce.active && Ce.effects.push(this));
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && ((this.flags &= -65), Is.has(this) && (Is.delete(this), this.trigger()));
  }
  notify() {
    (this.flags & 2 && !(this.flags & 32)) || this.flags & 8 || Fo(this);
  }
  run() {
    if (!(this.flags & 1)) return this.fn();
    ((this.flags |= 2), si(this), Ao(this));
    const t = fe,
      n = Ue;
    ((fe = this), (Ue = !0));
    try {
      return this.fn();
    } finally {
      (ko(this), (fe = t), (Ue = n), (this.flags &= -3));
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep) wr(t);
      ((this.deps = this.depsTail = void 0),
        si(this),
        this.onStop && this.onStop(),
        (this.flags &= -2));
    }
  }
  trigger() {
    this.flags & 64 ? Is.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  runIfDirty() {
    Js(this) && this.run();
  }
  get dirty() {
    return Js(this);
  }
}
let To = 0,
  dn,
  pn;
function Fo(e, t = !1) {
  if (((e.flags |= 8), t)) {
    ((e.next = pn), (pn = e));
    return;
  }
  ((e.next = dn), (dn = e));
}
function yr() {
  To++;
}
function qr() {
  if (--To > 0) return;
  if (pn) {
    let t = pn;
    for (pn = void 0; t; ) {
      const n = t.next;
      ((t.next = void 0), (t.flags &= -9), (t = n));
    }
  }
  let e;
  for (; dn; ) {
    let t = dn;
    for (dn = void 0; t; ) {
      const n = t.next;
      if (((t.next = void 0), (t.flags &= -9), t.flags & 1))
        try {
          t.trigger();
        } catch (s) {
          e || (e = s);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function Ao(e) {
  for (let t = e.deps; t; t = t.nextDep)
    ((t.version = -1), (t.prevActiveLink = t.dep.activeLink), (t.dep.activeLink = t));
}
function ko(e) {
  let t,
    n = e.depsTail,
    s = n;
  for (; s; ) {
    const r = s.prevDep;
    (s.version === -1 ? (s === n && (n = r), wr(s), jc(s)) : (t = s),
      (s.dep.activeLink = s.prevActiveLink),
      (s.prevActiveLink = void 0),
      (s = r));
  }
  ((e.deps = t), (e.depsTail = n));
}
function Js(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (
      t.dep.version !== t.version ||
      (t.dep.computed && (Ro(t.dep.computed) || t.dep.version !== t.version))
    )
      return !0;
  return !!e._dirty;
}
function Ro(e) {
  if ((e.flags & 4 && !(e.flags & 16)) || ((e.flags &= -17), e.globalVersion === wn)) return;
  e.globalVersion = wn;
  const t = e.dep;
  if (((e.flags |= 2), t.version > 0 && !e.isSSR && e.deps && !Js(e))) {
    e.flags &= -3;
    return;
  }
  const n = fe,
    s = Ue;
  ((fe = e), (Ue = !0));
  try {
    Ao(e);
    const r = e.fn(e._value);
    (t.version === 0 || bt(r, e._value)) && ((e._value = r), t.version++);
  } catch (r) {
    throw (t.version++, r);
  } finally {
    ((fe = n), (Ue = s), ko(e), (e.flags &= -3));
  }
}
function wr(e, t = !1) {
  const { dep: n, prevSub: s, nextSub: r } = e;
  if (
    (s && ((s.nextSub = r), (e.prevSub = void 0)),
    r && ((r.prevSub = s), (e.nextSub = void 0)),
    n.subs === e && ((n.subs = s), !s && n.computed))
  ) {
    n.computed.flags &= -5;
    for (let i = n.computed.deps; i; i = i.nextDep) wr(i, !0);
  }
  !t && !--n.sc && n.map && n.map.delete(n.key);
}
function jc(e) {
  const { prevDep: t, nextDep: n } = e;
  (t && ((t.nextDep = n), (e.prevDep = void 0)), n && ((n.prevDep = t), (e.nextDep = void 0)));
}
let Ue = !0;
const Oo = [];
function vt() {
  (Oo.push(Ue), (Ue = !1));
}
function _t() {
  const e = Oo.pop();
  Ue = e === void 0 ? !0 : e;
}
function si(e) {
  const { cleanup: t } = e;
  if (((e.cleanup = void 0), t)) {
    const n = fe;
    fe = void 0;
    try {
      t();
    } finally {
      fe = n;
    }
  }
}
let wn = 0;
class Bc {
  constructor(t, n) {
    ((this.sub = t),
      (this.dep = n),
      (this.version = n.version),
      (this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0));
  }
}
class xr {
  constructor(t) {
    ((this.computed = t),
      (this.version = 0),
      (this.activeLink = void 0),
      (this.subs = void 0),
      (this.map = void 0),
      (this.key = void 0),
      (this.sc = 0));
  }
  track(t) {
    if (!fe || !Ue || fe === this.computed) return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== fe)
      ((n = this.activeLink = new Bc(fe, this)),
        fe.deps
          ? ((n.prevDep = fe.depsTail), (fe.depsTail.nextDep = n), (fe.depsTail = n))
          : (fe.deps = fe.depsTail = n),
        Po(n));
    else if (n.version === -1 && ((n.version = this.version), n.nextDep)) {
      const s = n.nextDep;
      ((s.prevDep = n.prevDep),
        n.prevDep && (n.prevDep.nextDep = s),
        (n.prevDep = fe.depsTail),
        (n.nextDep = void 0),
        (fe.depsTail.nextDep = n),
        (fe.depsTail = n),
        fe.deps === n && (fe.deps = s));
    }
    return n;
  }
  trigger(t) {
    (this.version++, wn++, this.notify(t));
  }
  notify(t) {
    yr();
    try {
      for (let n = this.subs; n; n = n.prevSub) n.sub.notify() && n.sub.dep.notify();
    } finally {
      qr();
    }
  }
}
function Po(e) {
  if ((e.dep.sc++, e.sub.flags & 4)) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let s = t.deps; s; s = s.nextDep) Po(s);
    }
    const n = e.dep.subs;
    (n !== e && ((e.prevSub = n), n && (n.nextSub = e)), (e.dep.subs = e));
  }
}
const Yn = new WeakMap(),
  Ot = Symbol(''),
  Xs = Symbol(''),
  xn = Symbol('');
function xe(e, t, n) {
  if (Ue && fe) {
    let s = Yn.get(e);
    s || Yn.set(e, (s = new Map()));
    let r = s.get(n);
    (r || (s.set(n, (r = new xr())), (r.map = s), (r.key = n)), r.track());
  }
}
function ot(e, t, n, s, r, i) {
  const o = Yn.get(e);
  if (!o) {
    wn++;
    return;
  }
  const l = (a) => {
    a && a.trigger();
  };
  if ((yr(), t === 'clear')) o.forEach(l);
  else {
    const a = B(e),
      f = a && gr(n);
    if (a && n === 'length') {
      const c = Number(s);
      o.forEach((u, m) => {
        (m === 'length' || m === xn || (!Qe(m) && m >= c)) && l(u);
      });
    } else
      switch (((n !== void 0 || o.has(void 0)) && l(o.get(n)), f && l(o.get(xn)), t)) {
        case 'add':
          a ? f && l(o.get('length')) : (l(o.get(Ot)), Vt(e) && l(o.get(Xs)));
          break;
        case 'delete':
          a || (l(o.get(Ot)), Vt(e) && l(o.get(Xs)));
          break;
        case 'set':
          Vt(e) && l(o.get(Ot));
          break;
      }
  }
  qr();
}
function zc(e, t) {
  const n = Yn.get(e);
  return n && n.get(t);
}
function Dt(e) {
  const t = Y(e);
  return t === e ? t : (xe(t, 'iterate', xn), Be(e) ? t : t.map(ve));
}
function ys(e) {
  return (xe((e = Y(e)), 'iterate', xn), e);
}
const Lc = {
  __proto__: null,
  [Symbol.iterator]() {
    return Ms(this, Symbol.iterator, ve);
  },
  concat(...e) {
    return Dt(this).concat(...e.map((t) => (B(t) ? Dt(t) : t)));
  },
  entries() {
    return Ms(this, 'entries', (e) => ((e[1] = ve(e[1])), e));
  },
  every(e, t) {
    return rt(this, 'every', e, t, void 0, arguments);
  },
  filter(e, t) {
    return rt(this, 'filter', e, t, (n) => n.map(ve), arguments);
  },
  find(e, t) {
    return rt(this, 'find', e, t, ve, arguments);
  },
  findIndex(e, t) {
    return rt(this, 'findIndex', e, t, void 0, arguments);
  },
  findLast(e, t) {
    return rt(this, 'findLast', e, t, ve, arguments);
  },
  findLastIndex(e, t) {
    return rt(this, 'findLastIndex', e, t, void 0, arguments);
  },
  forEach(e, t) {
    return rt(this, 'forEach', e, t, void 0, arguments);
  },
  includes(...e) {
    return $s(this, 'includes', e);
  },
  indexOf(...e) {
    return $s(this, 'indexOf', e);
  },
  join(e) {
    return Dt(this).join(e);
  },
  lastIndexOf(...e) {
    return $s(this, 'lastIndexOf', e);
  },
  map(e, t) {
    return rt(this, 'map', e, t, void 0, arguments);
  },
  pop() {
    return an(this, 'pop');
  },
  push(...e) {
    return an(this, 'push', e);
  },
  reduce(e, ...t) {
    return ri(this, 'reduce', e, t);
  },
  reduceRight(e, ...t) {
    return ri(this, 'reduceRight', e, t);
  },
  shift() {
    return an(this, 'shift');
  },
  some(e, t) {
    return rt(this, 'some', e, t, void 0, arguments);
  },
  splice(...e) {
    return an(this, 'splice', e);
  },
  toReversed() {
    return Dt(this).toReversed();
  },
  toSorted(e) {
    return Dt(this).toSorted(e);
  },
  toSpliced(...e) {
    return Dt(this).toSpliced(...e);
  },
  unshift(...e) {
    return an(this, 'unshift', e);
  },
  values() {
    return Ms(this, 'values', ve);
  }
};
function Ms(e, t, n) {
  const s = ys(e),
    r = s[t]();
  return (
    s !== e &&
      !Be(e) &&
      ((r._next = r.next),
      (r.next = () => {
        const i = r._next();
        return (i.value && (i.value = n(i.value)), i);
      })),
    r
  );
}
const Dc = Array.prototype;
function rt(e, t, n, s, r, i) {
  const o = ys(e),
    l = o !== e && !Be(e),
    a = o[t];
  if (a !== Dc[t]) {
    const u = a.apply(e, i);
    return l ? ve(u) : u;
  }
  let f = n;
  o !== e &&
    (l
      ? (f = function (u, m) {
          return n.call(this, ve(u), m, e);
        })
      : n.length > 2 &&
        (f = function (u, m) {
          return n.call(this, u, m, e);
        }));
  const c = a.call(o, f, s);
  return l && r ? r(c) : c;
}
function ri(e, t, n, s) {
  const r = ys(e);
  let i = n;
  return (
    r !== e &&
      (Be(e)
        ? n.length > 3 &&
          (i = function (o, l, a) {
            return n.call(this, o, l, a, e);
          })
        : (i = function (o, l, a) {
            return n.call(this, o, ve(l), a, e);
          })),
    r[t](i, ...s)
  );
}
function $s(e, t, n) {
  const s = Y(e);
  xe(s, 'iterate', xn);
  const r = s[t](...n);
  return (r === -1 || r === !1) && Sr(n[0]) ? ((n[0] = Y(n[0])), s[t](...n)) : r;
}
function an(e, t, n = []) {
  (vt(), yr());
  const s = Y(e)[t].apply(e, n);
  return (qr(), _t(), s);
}
const Uc = pr('__proto__,__v_isRef,__isVue'),
  Io = new Set(
    Object.getOwnPropertyNames(Symbol)
      .filter((e) => e !== 'arguments' && e !== 'caller')
      .map((e) => Symbol[e])
      .filter(Qe)
  );
function Hc(e) {
  Qe(e) || (e = String(e));
  const t = Y(this);
  return (xe(t, 'has', e), t.hasOwnProperty(e));
}
class Mo {
  constructor(t = !1, n = !1) {
    ((this._isReadonly = t), (this._isShallow = n));
  }
  get(t, n, s) {
    if (n === '__v_skip') return t.__v_skip;
    const r = this._isReadonly,
      i = this._isShallow;
    if (n === '__v_isReactive') return !r;
    if (n === '__v_isReadonly') return r;
    if (n === '__v_isShallow') return i;
    if (n === '__v_raw')
      return s === (r ? (i ? ef : Bo) : i ? jo : No).get(t) ||
        Object.getPrototypeOf(t) === Object.getPrototypeOf(s)
        ? t
        : void 0;
    const o = B(t);
    if (!r) {
      let a;
      if (o && (a = Lc[n])) return a;
      if (n === 'hasOwnProperty') return Hc;
    }
    const l = Reflect.get(t, n, de(t) ? t : s);
    return (Qe(n) ? Io.has(n) : Uc(n)) || (r || xe(t, 'get', n), i)
      ? l
      : de(l)
        ? o && gr(n)
          ? l
          : l.value
        : ae(l)
          ? r
            ? zo(l)
            : qs(l)
          : l;
  }
}
class $o extends Mo {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, s, r) {
    let i = t[n];
    if (!this._isShallow) {
      const a = $t(i);
      if ((!Be(s) && !$t(s) && ((i = Y(i)), (s = Y(s))), !B(t) && de(i) && !de(s)))
        return a ? !1 : ((i.value = s), !0);
    }
    const o = B(t) && gr(n) ? Number(n) < t.length : re(t, n),
      l = Reflect.set(t, n, s, de(t) ? t : r);
    return (t === Y(r) && (o ? bt(s, i) && ot(t, 'set', n, s) : ot(t, 'add', n, s)), l);
  }
  deleteProperty(t, n) {
    const s = re(t, n);
    t[n];
    const r = Reflect.deleteProperty(t, n);
    return (r && s && ot(t, 'delete', n, void 0), r);
  }
  has(t, n) {
    const s = Reflect.has(t, n);
    return ((!Qe(n) || !Io.has(n)) && xe(t, 'has', n), s);
  }
  ownKeys(t) {
    return (xe(t, 'iterate', B(t) ? 'length' : Ot), Reflect.ownKeys(t));
  }
}
class Qc extends Mo {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return !0;
  }
  deleteProperty(t, n) {
    return !0;
  }
}
const Vc = new $o(),
  Wc = new Qc(),
  Kc = new $o(!0);
const Zs = (e) => e,
  Bn = (e) => Reflect.getPrototypeOf(e);
function Gc(e, t, n) {
  return function (...s) {
    const r = this.__v_raw,
      i = Y(r),
      o = Vt(i),
      l = e === 'entries' || (e === Symbol.iterator && o),
      a = e === 'keys' && o,
      f = r[e](...s),
      c = n ? Zs : t ? Ys : ve;
    return (
      !t && xe(i, 'iterate', a ? Xs : Ot),
      {
        next() {
          const { value: u, done: m } = f.next();
          return m ? { value: u, done: m } : { value: l ? [c(u[0]), c(u[1])] : c(u), done: m };
        },
        [Symbol.iterator]() {
          return this;
        }
      }
    );
  };
}
function zn(e) {
  return function (...t) {
    return e === 'delete' ? !1 : e === 'clear' ? void 0 : this;
  };
}
function Jc(e, t) {
  const n = {
    get(r) {
      const i = this.__v_raw,
        o = Y(i),
        l = Y(r);
      e || (bt(r, l) && xe(o, 'get', r), xe(o, 'get', l));
      const { has: a } = Bn(o),
        f = t ? Zs : e ? Ys : ve;
      if (a.call(o, r)) return f(i.get(r));
      if (a.call(o, l)) return f(i.get(l));
      i !== o && i.get(r);
    },
    get size() {
      const r = this.__v_raw;
      return (!e && xe(Y(r), 'iterate', Ot), Reflect.get(r, 'size', r));
    },
    has(r) {
      const i = this.__v_raw,
        o = Y(i),
        l = Y(r);
      return (
        e || (bt(r, l) && xe(o, 'has', r), xe(o, 'has', l)),
        r === l ? i.has(r) : i.has(r) || i.has(l)
      );
    },
    forEach(r, i) {
      const o = this,
        l = o.__v_raw,
        a = Y(l),
        f = t ? Zs : e ? Ys : ve;
      return (!e && xe(a, 'iterate', Ot), l.forEach((c, u) => r.call(i, f(c), f(u), o)));
    }
  };
  return (
    ge(
      n,
      e
        ? { add: zn('add'), set: zn('set'), delete: zn('delete'), clear: zn('clear') }
        : {
            add(r) {
              !t && !Be(r) && !$t(r) && (r = Y(r));
              const i = Y(this);
              return (Bn(i).has.call(i, r) || (i.add(r), ot(i, 'add', r, r)), this);
            },
            set(r, i) {
              !t && !Be(i) && !$t(i) && (i = Y(i));
              const o = Y(this),
                { has: l, get: a } = Bn(o);
              let f = l.call(o, r);
              f || ((r = Y(r)), (f = l.call(o, r)));
              const c = a.call(o, r);
              return (o.set(r, i), f ? bt(i, c) && ot(o, 'set', r, i) : ot(o, 'add', r, i), this);
            },
            delete(r) {
              const i = Y(this),
                { has: o, get: l } = Bn(i);
              let a = o.call(i, r);
              (a || ((r = Y(r)), (a = o.call(i, r))), l && l.call(i, r));
              const f = i.delete(r);
              return (a && ot(i, 'delete', r, void 0), f);
            },
            clear() {
              const r = Y(this),
                i = r.size !== 0,
                o = r.clear();
              return (i && ot(r, 'clear', void 0, void 0), o);
            }
          }
    ),
    ['keys', 'values', 'entries', Symbol.iterator].forEach((r) => {
      n[r] = Gc(r, e, t);
    }),
    n
  );
}
function vr(e, t) {
  const n = Jc(e, t);
  return (s, r, i) =>
    r === '__v_isReactive'
      ? !e
      : r === '__v_isReadonly'
        ? e
        : r === '__v_raw'
          ? s
          : Reflect.get(re(n, r) && r in s ? n : s, r, i);
}
const Xc = { get: vr(!1, !1) },
  Zc = { get: vr(!1, !0) },
  Yc = { get: vr(!0, !1) };
const No = new WeakMap(),
  jo = new WeakMap(),
  Bo = new WeakMap(),
  ef = new WeakMap();
function tf(e) {
  switch (e) {
    case 'Object':
    case 'Array':
      return 1;
    case 'Map':
    case 'Set':
    case 'WeakMap':
    case 'WeakSet':
      return 2;
    default:
      return 0;
  }
}
function nf(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : tf(Ec(e));
}
function qs(e) {
  return $t(e) ? e : _r(e, !1, Vc, Xc, No);
}
function sf(e) {
  return _r(e, !1, Kc, Zc, jo);
}
function zo(e) {
  return _r(e, !0, Wc, Yc, Bo);
}
function _r(e, t, n, s, r) {
  if (!ae(e) || (e.__v_raw && !(t && e.__v_isReactive))) return e;
  const i = r.get(e);
  if (i) return i;
  const o = nf(e);
  if (o === 0) return e;
  const l = new Proxy(e, o === 2 ? s : n);
  return (r.set(e, l), l);
}
function yt(e) {
  return $t(e) ? yt(e.__v_raw) : !!(e && e.__v_isReactive);
}
function $t(e) {
  return !!(e && e.__v_isReadonly);
}
function Be(e) {
  return !!(e && e.__v_isShallow);
}
function Sr(e) {
  return e ? !!e.__v_raw : !1;
}
function Y(e) {
  const t = e && e.__v_raw;
  return t ? Y(t) : e;
}
function Cr(e) {
  return (!re(e, '__v_skip') && Object.isExtensible(e) && qo(e, '__v_skip', !0), e);
}
const ve = (e) => (ae(e) ? qs(e) : e),
  Ys = (e) => (ae(e) ? zo(e) : e);
function de(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function Te(e) {
  return rf(e, !1);
}
function rf(e, t) {
  return de(e) ? e : new of(e, t);
}
class of {
  constructor(t, n) {
    ((this.dep = new xr()),
      (this.__v_isRef = !0),
      (this.__v_isShallow = !1),
      (this._rawValue = n ? t : Y(t)),
      (this._value = n ? t : ve(t)),
      (this.__v_isShallow = n));
  }
  get value() {
    return (this.dep.track(), this._value);
  }
  set value(t) {
    const n = this._rawValue,
      s = this.__v_isShallow || Be(t) || $t(t);
    ((t = s ? t : Y(t)),
      bt(t, n) && ((this._rawValue = t), (this._value = s ? t : ve(t)), this.dep.trigger()));
  }
}
function hn(e) {
  return de(e) ? e.value : e;
}
const lf = {
  get: (e, t, n) => (t === '__v_raw' ? e : hn(Reflect.get(e, t, n))),
  set: (e, t, n, s) => {
    const r = e[t];
    return de(r) && !de(n) ? ((r.value = n), !0) : Reflect.set(e, t, n, s);
  }
};
function Lo(e) {
  return yt(e) ? e : new Proxy(e, lf);
}
function af(e) {
  const t = B(e) ? new Array(e.length) : {};
  for (const n in e) t[n] = ff(e, n);
  return t;
}
class cf {
  constructor(t, n, s) {
    ((this._object = t),
      (this._key = n),
      (this._defaultValue = s),
      (this.__v_isRef = !0),
      (this._value = void 0));
  }
  get value() {
    const t = this._object[this._key];
    return (this._value = t === void 0 ? this._defaultValue : t);
  }
  set value(t) {
    this._object[this._key] = t;
  }
  get dep() {
    return zc(Y(this._object), this._key);
  }
}
function ff(e, t, n) {
  const s = e[t];
  return de(s) ? s : new cf(e, t, n);
}
class uf {
  constructor(t, n, s) {
    ((this.fn = t),
      (this.setter = n),
      (this._value = void 0),
      (this.dep = new xr(this)),
      (this.__v_isRef = !0),
      (this.deps = void 0),
      (this.depsTail = void 0),
      (this.flags = 16),
      (this.globalVersion = wn - 1),
      (this.next = void 0),
      (this.effect = this),
      (this.__v_isReadonly = !n),
      (this.isSSR = s));
  }
  notify() {
    if (((this.flags |= 16), !(this.flags & 8) && fe !== this)) return (Fo(this, !0), !0);
  }
  get value() {
    const t = this.dep.track();
    return (Ro(this), t && (t.version = this.dep.version), this._value);
  }
  set value(t) {
    this.setter && this.setter(t);
  }
}
function df(e, t, n = !1) {
  let s, r;
  return (U(e) ? (s = e) : ((s = e.get), (r = e.set)), new uf(s, r, n));
}
const Ln = {},
  es = new WeakMap();
let Ft;
function pf(e, t = !1, n = Ft) {
  if (n) {
    let s = es.get(n);
    (s || es.set(n, (s = [])), s.push(e));
  }
}
function hf(e, t, n = oe) {
  const { immediate: s, deep: r, once: i, scheduler: o, augmentJob: l, call: a } = n,
    f = (F) => (r ? F : Be(F) || r === !1 || r === 0 ? lt(F, 1) : lt(F));
  let c,
    u,
    m,
    y,
    h = !1,
    q = !1;
  if (
    (de(e)
      ? ((u = () => e.value), (h = Be(e)))
      : yt(e)
        ? ((u = () => f(e)), (h = !0))
        : B(e)
          ? ((q = !0),
            (h = e.some((F) => yt(F) || Be(F))),
            (u = () =>
              e.map((F) => {
                if (de(F)) return F.value;
                if (yt(F)) return f(F);
                if (U(F)) return a ? a(F, 2) : F();
              })))
          : U(e)
            ? t
              ? (u = a ? () => a(e, 2) : e)
              : (u = () => {
                  if (m) {
                    vt();
                    try {
                      m();
                    } finally {
                      _t();
                    }
                  }
                  const F = Ft;
                  Ft = c;
                  try {
                    return a ? a(e, 3, [y]) : e(y);
                  } finally {
                    Ft = F;
                  }
                })
            : (u = st),
    t && r)
  ) {
    const F = u,
      j = r === !0 ? 1 / 0 : r;
    u = () => lt(F(), j);
  }
  const w = Co(),
    O = () => {
      (c.stop(), w && w.active && mr(w.effects, c));
    };
  if (i && t) {
    const F = t;
    t = (...j) => {
      (F(...j), O());
    };
  }
  let $ = q ? new Array(e.length).fill(Ln) : Ln;
  const N = (F) => {
    if (!(!(c.flags & 1) || (!c.dirty && !F)))
      if (t) {
        const j = c.run();
        if (r || h || (q ? j.some((te, K) => bt(te, $[K])) : bt(j, $))) {
          m && m();
          const te = Ft;
          Ft = c;
          try {
            const K = [j, $ === Ln ? void 0 : q && $[0] === Ln ? [] : $, y];
            (a ? a(t, 3, K) : t(...K), ($ = j));
          } finally {
            Ft = te;
          }
        }
      } else c.run();
  };
  return (
    l && l(N),
    (c = new Eo(u)),
    (c.scheduler = o ? () => o(N, !1) : N),
    (y = (F) => pf(F, !1, c)),
    (m = c.onStop =
      () => {
        const F = es.get(c);
        if (F) {
          if (a) a(F, 4);
          else for (const j of F) j();
          es.delete(c);
        }
      }),
    t ? (s ? N(!0) : ($ = c.run())) : o ? o(N.bind(null, !0), !0) : c.run(),
    (O.pause = c.pause.bind(c)),
    (O.resume = c.resume.bind(c)),
    (O.stop = O),
    O
  );
}
function lt(e, t = 1 / 0, n) {
  if (t <= 0 || !ae(e) || e.__v_skip || ((n = n || new Set()), n.has(e))) return e;
  if ((n.add(e), t--, de(e))) lt(e.value, t, n);
  else if (B(e)) for (let s = 0; s < e.length; s++) lt(e[s], t, n);
  else if (tn(e) || Vt(e))
    e.forEach((s) => {
      lt(s, t, n);
    });
  else if (yo(e)) {
    for (const s in e) lt(e[s], t, n);
    for (const s of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, s) && lt(e[s], t, n);
  }
  return e;
}
/**
 * @vue/runtime-core v3.5.13
 * (c) 2018-present Yuxi (Evan) You and Vue contributors
 * @license MIT
 **/ function On(e, t, n, s) {
  try {
    return s ? e(...s) : e();
  } catch (r) {
    ws(r, t, n);
  }
}
function Ve(e, t, n, s) {
  if (U(e)) {
    const r = On(e, t, n, s);
    return (
      r &&
        go(r) &&
        r.catch((i) => {
          ws(i, t, n);
        }),
      r
    );
  }
  if (B(e)) {
    const r = [];
    for (let i = 0; i < e.length; i++) r.push(Ve(e[i], t, n, s));
    return r;
  }
}
function ws(e, t, n, s = !0) {
  const r = t ? t.vnode : null,
    { errorHandler: i, throwUnhandledErrorInProduction: o } = (t && t.appContext.config) || oe;
  if (t) {
    let l = t.parent;
    const a = t.proxy,
      f = `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; l; ) {
      const c = l.ec;
      if (c) {
        for (let u = 0; u < c.length; u++) if (c[u](e, a, f) === !1) return;
      }
      l = l.parent;
    }
    if (i) {
      (vt(), On(i, null, 10, [e, a, f]), _t());
      return;
    }
  }
  mf(e, n, r, s, o);
}
function mf(e, t, n, s = !0, r = !1) {
  if (r) throw e;
  console.error(e);
}
const Ee = [];
let tt = -1;
const Wt = [];
let ht = null,
  Ht = 0;
const Do = Promise.resolve();
let ts = null;
function Er(e) {
  const t = ts || Do;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function gf(e) {
  let t = tt + 1,
    n = Ee.length;
  for (; t < n; ) {
    const s = (t + n) >>> 1,
      r = Ee[s],
      i = vn(r);
    i < e || (i === e && r.flags & 2) ? (t = s + 1) : (n = s);
  }
  return t;
}
function Tr(e) {
  if (!(e.flags & 1)) {
    const t = vn(e),
      n = Ee[Ee.length - 1];
    (!n || (!(e.flags & 2) && t >= vn(n)) ? Ee.push(e) : Ee.splice(gf(t), 0, e),
      (e.flags |= 1),
      Uo());
  }
}
function Uo() {
  ts || (ts = Do.then(Qo));
}
function bf(e) {
  (B(e)
    ? Wt.push(...e)
    : ht && e.id === -1
      ? ht.splice(Ht + 1, 0, e)
      : e.flags & 1 || (Wt.push(e), (e.flags |= 1)),
    Uo());
}
function ii(e, t, n = tt + 1) {
  for (; n < Ee.length; n++) {
    const s = Ee[n];
    if (s && s.flags & 2) {
      if (e && s.id !== e.uid) continue;
      (Ee.splice(n, 1), n--, s.flags & 4 && (s.flags &= -2), s(), s.flags & 4 || (s.flags &= -2));
    }
  }
}
function Ho(e) {
  if (Wt.length) {
    const t = [...new Set(Wt)].sort((n, s) => vn(n) - vn(s));
    if (((Wt.length = 0), ht)) {
      ht.push(...t);
      return;
    }
    for (ht = t, Ht = 0; Ht < ht.length; Ht++) {
      const n = ht[Ht];
      (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), (n.flags &= -2));
    }
    ((ht = null), (Ht = 0));
  }
}
const vn = (e) => (e.id == null ? (e.flags & 2 ? -1 : 1 / 0) : e.id);
function Qo(e) {
  try {
    for (tt = 0; tt < Ee.length; tt++) {
      const t = Ee[tt];
      t &&
        !(t.flags & 8) &&
        (t.flags & 4 && (t.flags &= -2), On(t, t.i, t.i ? 15 : 14), t.flags & 4 || (t.flags &= -2));
    }
  } finally {
    for (; tt < Ee.length; tt++) {
      const t = Ee[tt];
      t && (t.flags &= -2);
    }
    ((tt = -1), (Ee.length = 0), Ho(), (ts = null), (Ee.length || Wt.length) && Qo());
  }
}
let me = null,
  Vo = null;
function ns(e) {
  const t = me;
  return ((me = e), (Vo = (e && e.type.__scopeId) || null), t);
}
function St(e, t = me, n) {
  if (!t || e._n) return e;
  const s = (...r) => {
    s._d && gi(-1);
    const i = ns(t);
    let o;
    try {
      o = e(...r);
    } finally {
      (ns(i), s._d && gi(1));
    }
    return o;
  };
  return ((s._n = !0), (s._c = !0), (s._d = !0), s);
}
function yf(e, t) {
  if (me === null) return e;
  const n = Cs(me),
    s = e.dirs || (e.dirs = []);
  for (let r = 0; r < t.length; r++) {
    let [i, o, l, a = oe] = t[r];
    i &&
      (U(i) && (i = { mounted: i, updated: i }),
      i.deep && lt(o),
      s.push({ dir: i, instance: n, value: o, oldValue: void 0, arg: l, modifiers: a }));
  }
  return e;
}
function Ct(e, t, n, s) {
  const r = e.dirs,
    i = t && t.dirs;
  for (let o = 0; o < r.length; o++) {
    const l = r[o];
    i && (l.oldValue = i[o].value);
    let a = l.dir[s];
    a && (vt(), Ve(a, n, 8, [e.el, l, e, t]), _t());
  }
}
const qf = Symbol('_vte'),
  Wo = (e) => e.__isTeleport,
  mt = Symbol('_leaveCb'),
  Dn = Symbol('_enterCb');
function Ko() {
  const e = { isMounted: !1, isLeaving: !1, isUnmounting: !1, leavingVNodes: new Map() };
  return (
    Pn(() => {
      e.isMounted = !0;
    }),
    nl(() => {
      e.isUnmounting = !0;
    }),
    e
  );
}
const je = [Function, Array],
  Go = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    onBeforeEnter: je,
    onEnter: je,
    onAfterEnter: je,
    onEnterCancelled: je,
    onBeforeLeave: je,
    onLeave: je,
    onAfterLeave: je,
    onLeaveCancelled: je,
    onBeforeAppear: je,
    onAppear: je,
    onAfterAppear: je,
    onAppearCancelled: je
  },
  Jo = (e) => {
    const t = e.subTree;
    return t.component ? Jo(t.component) : t;
  },
  wf = {
    name: 'BaseTransition',
    props: Go,
    setup(e, { slots: t }) {
      const n = Or(),
        s = Ko();
      return () => {
        const r = t.default && Fr(t.default(), !0);
        if (!r || !r.length) return;
        const i = Xo(r),
          o = Y(e),
          { mode: l } = o;
        if (s.isLeaving) return Ns(i);
        const a = oi(i);
        if (!a) return Ns(i);
        let f = _n(a, o, s, n, (u) => (f = u));
        a.type !== Fe && Nt(a, f);
        let c = n.subTree && oi(n.subTree);
        if (c && c.type !== Fe && !At(a, c) && Jo(n).type !== Fe) {
          let u = _n(c, o, s, n);
          if ((Nt(c, u), l === 'out-in' && a.type !== Fe))
            return (
              (s.isLeaving = !0),
              (u.afterLeave = () => {
                ((s.isLeaving = !1),
                  n.job.flags & 8 || n.update(),
                  delete u.afterLeave,
                  (c = void 0));
              }),
              Ns(i)
            );
          l === 'in-out' && a.type !== Fe
            ? (u.delayLeave = (m, y, h) => {
                const q = Zo(s, c);
                ((q[String(c.key)] = c),
                  (m[mt] = () => {
                    (y(), (m[mt] = void 0), delete f.delayedLeave, (c = void 0));
                  }),
                  (f.delayedLeave = () => {
                    (h(), delete f.delayedLeave, (c = void 0));
                  }));
              })
            : (c = void 0);
        } else c && (c = void 0);
        return i;
      };
    }
  };
function Xo(e) {
  let t = e[0];
  if (e.length > 1) {
    for (const n of e)
      if (n.type !== Fe) {
        t = n;
        break;
      }
  }
  return t;
}
const xf = wf;
function Zo(e, t) {
  const { leavingVNodes: n } = e;
  let s = n.get(t.type);
  return (s || ((s = Object.create(null)), n.set(t.type, s)), s);
}
function _n(e, t, n, s, r) {
  const {
      appear: i,
      mode: o,
      persisted: l = !1,
      onBeforeEnter: a,
      onEnter: f,
      onAfterEnter: c,
      onEnterCancelled: u,
      onBeforeLeave: m,
      onLeave: y,
      onAfterLeave: h,
      onLeaveCancelled: q,
      onBeforeAppear: w,
      onAppear: O,
      onAfterAppear: $,
      onAppearCancelled: N
    } = t,
    F = String(e.key),
    j = Zo(n, e),
    te = (x, M) => {
      x && Ve(x, s, 9, M);
    },
    K = (x, M) => {
      const W = M[1];
      (te(x, M), B(x) ? x.every((A) => A.length <= 1) && W() : x.length <= 1 && W());
    },
    I = {
      mode: o,
      persisted: l,
      beforeEnter(x) {
        let M = a;
        if (!n.isMounted)
          if (i) M = w || a;
          else return;
        x[mt] && x[mt](!0);
        const W = j[F];
        (W && At(e, W) && W.el[mt] && W.el[mt](), te(M, [x]));
      },
      enter(x) {
        let M = f,
          W = c,
          A = u;
        if (!n.isMounted)
          if (i) ((M = O || f), (W = $ || c), (A = N || u));
          else return;
        let G = !1;
        const se = (x[Dn] = (Ae) => {
          G ||
            ((G = !0),
            Ae ? te(A, [x]) : te(W, [x]),
            I.delayedLeave && I.delayedLeave(),
            (x[Dn] = void 0));
        });
        M ? K(M, [x, se]) : se();
      },
      leave(x, M) {
        const W = String(e.key);
        if ((x[Dn] && x[Dn](!0), n.isUnmounting)) return M();
        te(m, [x]);
        let A = !1;
        const G = (x[mt] = (se) => {
          A ||
            ((A = !0),
            M(),
            se ? te(q, [x]) : te(h, [x]),
            (x[mt] = void 0),
            j[W] === e && delete j[W]);
        });
        ((j[W] = e), y ? K(y, [x, G]) : G());
      },
      clone(x) {
        const M = _n(x, t, n, s, r);
        return (r && r(M), M);
      }
    };
  return I;
}
function Ns(e) {
  if (xs(e)) return ((e = qt(e)), (e.children = null), e);
}
function oi(e) {
  if (!xs(e)) return Wo(e.type) && e.children ? Xo(e.children) : e;
  const { shapeFlag: t, children: n } = e;
  if (n) {
    if (t & 16) return n[0];
    if (t & 32 && U(n.default)) return n.default();
  }
}
function Nt(e, t) {
  e.shapeFlag & 6 && e.component
    ? ((e.transition = t), Nt(e.component.subTree, t))
    : e.shapeFlag & 128
      ? ((e.ssContent.transition = t.clone(e.ssContent)),
        (e.ssFallback.transition = t.clone(e.ssFallback)))
      : (e.transition = t);
}
function Fr(e, t = !1, n) {
  let s = [],
    r = 0;
  for (let i = 0; i < e.length; i++) {
    let o = e[i];
    const l = n == null ? o.key : String(n) + String(o.key != null ? o.key : i);
    o.type === he
      ? (o.patchFlag & 128 && r++, (s = s.concat(Fr(o.children, t, l))))
      : (t || o.type !== Fe) && s.push(l != null ? qt(o, { key: l }) : o);
  }
  if (r > 1) for (let i = 0; i < s.length; i++) s[i].patchFlag = -2;
  return s;
}
/*! #__NO_SIDE_EFFECTS__ */ function De(e, t) {
  return U(e) ? ge({ name: e.name }, t, { setup: e }) : e;
}
function Yo(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + '-', 0, 0];
}
function ss(e, t, n, s, r = !1) {
  if (B(e)) {
    e.forEach((h, q) => ss(h, t && (B(t) ? t[q] : t), n, s, r));
    return;
  }
  if (Kt(s) && !r) {
    s.shapeFlag & 512 &&
      s.type.__asyncResolved &&
      s.component.subTree.component &&
      ss(e, t, n, s.component.subTree);
    return;
  }
  const i = s.shapeFlag & 4 ? Cs(s.component) : s.el,
    o = r ? null : i,
    { i: l, r: a } = e,
    f = t && t.r,
    c = l.refs === oe ? (l.refs = {}) : l.refs,
    u = l.setupState,
    m = Y(u),
    y = u === oe ? () => !1 : (h) => re(m, h);
  if (
    (f != null &&
      f !== a &&
      (ue(f) ? ((c[f] = null), y(f) && (u[f] = null)) : de(f) && (f.value = null)),
    U(a))
  )
    On(a, l, 12, [o, c]);
  else {
    const h = ue(a),
      q = de(a);
    if (h || q) {
      const w = () => {
        if (e.f) {
          const O = h ? (y(a) ? u[a] : c[a]) : a.value;
          r
            ? B(O) && mr(O, i)
            : B(O)
              ? O.includes(i) || O.push(i)
              : h
                ? ((c[a] = [i]), y(a) && (u[a] = c[a]))
                : ((a.value = [i]), e.k && (c[e.k] = a.value));
        } else h ? ((c[a] = o), y(a) && (u[a] = o)) : q && ((a.value = o), e.k && (c[e.k] = o));
      };
      o ? ((w.id = -1), $e(w, n)) : w();
    }
  }
}
bs().requestIdleCallback;
bs().cancelIdleCallback;
const Kt = (e) => !!e.type.__asyncLoader,
  xs = (e) => e.type.__isKeepAlive;
function vf(e, t) {
  el(e, 'a', t);
}
function _f(e, t) {
  el(e, 'da', t);
}
function el(e, t, n = be) {
  const s =
    e.__wdc ||
    (e.__wdc = () => {
      let r = n;
      for (; r; ) {
        if (r.isDeactivated) return;
        r = r.parent;
      }
      return e();
    });
  if ((vs(t, s, n), n)) {
    let r = n.parent;
    for (; r && r.parent; ) (xs(r.parent.vnode) && Sf(s, t, n, r), (r = r.parent));
  }
}
function Sf(e, t, n, s) {
  const r = vs(t, e, s, !0);
  Ar(() => {
    mr(s[t], r);
  }, n);
}
function vs(e, t, n = be, s = !1) {
  if (n) {
    const r = n[e] || (n[e] = []),
      i =
        t.__weh ||
        (t.__weh = (...o) => {
          vt();
          const l = Mn(n),
            a = Ve(t, n, e, o);
          return (l(), _t(), a);
        });
    return (s ? r.unshift(i) : r.push(i), i);
  }
}
const ft =
    (e) =>
    (t, n = be) => {
      (!En || e === 'sp') && vs(e, (...s) => t(...s), n);
    },
  Cf = ft('bm'),
  Pn = ft('m'),
  Ef = ft('bu'),
  tl = ft('u'),
  nl = ft('bum'),
  Ar = ft('um'),
  Tf = ft('sp'),
  Ff = ft('rtg'),
  Af = ft('rtc');
function kf(e, t = be) {
  vs('ec', e, t);
}
const Rf = 'components',
  sl = Symbol.for('v-ndc');
function Of(e) {
  return ue(e) ? Pf(Rf, e, !1) || e : e || sl;
}
function Pf(e, t, n = !0, s = !1) {
  const r = me || be;
  if (r) {
    const i = r.type;
    {
      const l = xu(i, !1);
      if (l && (l === t || l === Le(t) || l === gs(Le(t)))) return i;
    }
    const o = li(r[e] || i[e], t) || li(r.appContext[e], t);
    return !o && s ? i : o;
  }
}
function li(e, t) {
  return e && (e[t] || e[Le(t)] || e[gs(Le(t))]);
}
function In(e, t, n, s) {
  let r;
  const i = n,
    o = B(e);
  if (o || ue(e)) {
    const l = o && yt(e);
    let a = !1;
    (l && ((a = !Be(e)), (e = ys(e))), (r = new Array(e.length)));
    for (let f = 0, c = e.length; f < c; f++) r[f] = t(a ? ve(e[f]) : e[f], f, void 0, i);
  } else if (typeof e == 'number') {
    r = new Array(e);
    for (let l = 0; l < e; l++) r[l] = t(l + 1, l, void 0, i);
  } else if (ae(e))
    if (e[Symbol.iterator]) r = Array.from(e, (l, a) => t(l, a, void 0, i));
    else {
      const l = Object.keys(e);
      r = new Array(l.length);
      for (let a = 0, f = l.length; a < f; a++) {
        const c = l[a];
        r[a] = t(e[c], c, a, i);
      }
    }
  else r = [];
  return r;
}
function rl(e, t, n = {}, s, r) {
  if (me.ce || (me.parent && Kt(me.parent) && me.parent.ce))
    return (Q(), ct(he, null, [ne('slot', n, s && s())], 64));
  let i = e[t];
  (i && i._c && (i._d = !1), Q());
  const o = i && il(i(n)),
    l = n.key || (o && o.key),
    a = ct(
      he,
      { key: (l && !Qe(l) ? l : `_${t}`) + (!o && s ? '_fb' : '') },
      o || (s ? s() : []),
      o && e._ === 1 ? 64 : -2
    );
  return (a.scopeId && (a.slotScopeIds = [a.scopeId + '-s']), i && i._c && (i._d = !0), a);
}
function il(e) {
  return e.some((t) => (Cn(t) ? !(t.type === Fe || (t.type === he && !il(t.children))) : !0))
    ? e
    : null;
}
const er = (e) => (e ? (Fl(e) ? Cs(e) : er(e.parent)) : null),
  mn = ge(Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => e.props,
    $attrs: (e) => e.attrs,
    $slots: (e) => e.slots,
    $refs: (e) => e.refs,
    $parent: (e) => er(e.parent),
    $root: (e) => er(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => al(e),
    $forceUpdate: (e) =>
      e.f ||
      (e.f = () => {
        Tr(e.update);
      }),
    $nextTick: (e) => e.n || (e.n = Er.bind(e.proxy)),
    $watch: (e) => su.bind(e)
  }),
  js = (e, t) => e !== oe && !e.__isScriptSetup && re(e, t),
  If = {
    get({ _: e }, t) {
      if (t === '__v_skip') return !0;
      const {
        ctx: n,
        setupState: s,
        data: r,
        props: i,
        accessCache: o,
        type: l,
        appContext: a
      } = e;
      let f;
      if (t[0] !== '$') {
        const y = o[t];
        if (y !== void 0)
          switch (y) {
            case 1:
              return s[t];
            case 2:
              return r[t];
            case 4:
              return n[t];
            case 3:
              return i[t];
          }
        else {
          if (js(s, t)) return ((o[t] = 1), s[t]);
          if (r !== oe && re(r, t)) return ((o[t] = 2), r[t]);
          if ((f = e.propsOptions[0]) && re(f, t)) return ((o[t] = 3), i[t]);
          if (n !== oe && re(n, t)) return ((o[t] = 4), n[t]);
          tr && (o[t] = 0);
        }
      }
      const c = mn[t];
      let u, m;
      if (c) return (t === '$attrs' && xe(e.attrs, 'get', ''), c(e));
      if ((u = l.__cssModules) && (u = u[t])) return u;
      if (n !== oe && re(n, t)) return ((o[t] = 4), n[t]);
      if (((m = a.config.globalProperties), re(m, t))) return m[t];
    },
    set({ _: e }, t, n) {
      const { data: s, setupState: r, ctx: i } = e;
      return js(r, t)
        ? ((r[t] = n), !0)
        : s !== oe && re(s, t)
          ? ((s[t] = n), !0)
          : re(e.props, t) || (t[0] === '$' && t.slice(1) in e)
            ? !1
            : ((i[t] = n), !0);
    },
    has(
      { _: { data: e, setupState: t, accessCache: n, ctx: s, appContext: r, propsOptions: i } },
      o
    ) {
      let l;
      return (
        !!n[o] ||
        (e !== oe && re(e, o)) ||
        js(t, o) ||
        ((l = i[0]) && re(l, o)) ||
        re(s, o) ||
        re(mn, o) ||
        re(r.config.globalProperties, o)
      );
    },
    defineProperty(e, t, n) {
      return (
        n.get != null ? (e._.accessCache[t] = 0) : re(n, 'value') && this.set(e, t, n.value, null),
        Reflect.defineProperty(e, t, n)
      );
    }
  };
function ol() {
  return Mf().attrs;
}
function Mf() {
  const e = Or();
  return e.setupContext || (e.setupContext = kl(e));
}
function ai(e) {
  return B(e) ? e.reduce((t, n) => ((t[n] = null), t), {}) : e;
}
let tr = !0;
function $f(e) {
  const t = al(e),
    n = e.proxy,
    s = e.ctx;
  ((tr = !1), t.beforeCreate && ci(t.beforeCreate, e, 'bc'));
  const {
    data: r,
    computed: i,
    methods: o,
    watch: l,
    provide: a,
    inject: f,
    created: c,
    beforeMount: u,
    mounted: m,
    beforeUpdate: y,
    updated: h,
    activated: q,
    deactivated: w,
    beforeDestroy: O,
    beforeUnmount: $,
    destroyed: N,
    unmounted: F,
    render: j,
    renderTracked: te,
    renderTriggered: K,
    errorCaptured: I,
    serverPrefetch: x,
    expose: M,
    inheritAttrs: W,
    components: A,
    directives: G,
    filters: se
  } = t;
  if ((f && Nf(f, s, null), o))
    for (const V in o) {
      const X = o[V];
      U(X) && (s[V] = X.bind(n));
    }
  if (r) {
    const V = r.call(n, n);
    ae(V) && (e.data = qs(V));
  }
  if (((tr = !0), i))
    for (const V in i) {
      const X = i[V],
        Ke = U(X) ? X.bind(n, n) : U(X.get) ? X.get.bind(n, n) : st,
        Bt = !U(X) && U(X.set) ? X.set.bind(n) : st,
        we = le({ get: Ke, set: Bt });
      Object.defineProperty(s, V, {
        enumerable: !0,
        configurable: !0,
        get: () => we.value,
        set: (ye) => (we.value = ye)
      });
    }
  if (l) for (const V in l) ll(l[V], s, n, V);
  if (a) {
    const V = U(a) ? a.call(n) : a;
    Reflect.ownKeys(V).forEach((X) => {
      Uf(X, V[X]);
    });
  }
  c && ci(c, e, 'c');
  function J(V, X) {
    B(X) ? X.forEach((Ke) => V(Ke.bind(n))) : X && V(X.bind(n));
  }
  if (
    (J(Cf, u),
    J(Pn, m),
    J(Ef, y),
    J(tl, h),
    J(vf, q),
    J(_f, w),
    J(kf, I),
    J(Af, te),
    J(Ff, K),
    J(nl, $),
    J(Ar, F),
    J(Tf, x),
    B(M))
  )
    if (M.length) {
      const V = e.exposed || (e.exposed = {});
      M.forEach((X) => {
        Object.defineProperty(V, X, { get: () => n[X], set: (Ke) => (n[X] = Ke) });
      });
    } else e.exposed || (e.exposed = {});
  (j && e.render === st && (e.render = j),
    W != null && (e.inheritAttrs = W),
    A && (e.components = A),
    G && (e.directives = G),
    x && Yo(e));
}
function Nf(e, t, n = st) {
  B(e) && (e = nr(e));
  for (const s in e) {
    const r = e[s];
    let i;
    (ae(r)
      ? 'default' in r
        ? (i = gn(r.from || s, r.default, !0))
        : (i = gn(r.from || s))
      : (i = gn(r)),
      de(i)
        ? Object.defineProperty(t, s, {
            enumerable: !0,
            configurable: !0,
            get: () => i.value,
            set: (o) => (i.value = o)
          })
        : (t[s] = i));
  }
}
function ci(e, t, n) {
  Ve(B(e) ? e.map((s) => s.bind(t.proxy)) : e.bind(t.proxy), t, n);
}
function ll(e, t, n, s) {
  let r = s.includes('.') ? vl(n, s) : () => n[s];
  if (ue(e)) {
    const i = t[e];
    U(i) && Gt(r, i);
  } else if (U(e)) Gt(r, e.bind(n));
  else if (ae(e))
    if (B(e)) e.forEach((i) => ll(i, t, n, s));
    else {
      const i = U(e.handler) ? e.handler.bind(n) : t[e.handler];
      U(i) && Gt(r, i, e);
    }
}
function al(e) {
  const t = e.type,
    { mixins: n, extends: s } = t,
    {
      mixins: r,
      optionsCache: i,
      config: { optionMergeStrategies: o }
    } = e.appContext,
    l = i.get(t);
  let a;
  return (
    l
      ? (a = l)
      : !r.length && !n && !s
        ? (a = t)
        : ((a = {}), r.length && r.forEach((f) => rs(a, f, o, !0)), rs(a, t, o)),
    ae(t) && i.set(t, a),
    a
  );
}
function rs(e, t, n, s = !1) {
  const { mixins: r, extends: i } = t;
  (i && rs(e, i, n, !0), r && r.forEach((o) => rs(e, o, n, !0)));
  for (const o in t)
    if (!(s && o === 'expose')) {
      const l = jf[o] || (n && n[o]);
      e[o] = l ? l(e[o], t[o]) : t[o];
    }
  return e;
}
const jf = {
  data: fi,
  props: ui,
  emits: ui,
  methods: fn,
  computed: fn,
  beforeCreate: Se,
  created: Se,
  beforeMount: Se,
  mounted: Se,
  beforeUpdate: Se,
  updated: Se,
  beforeDestroy: Se,
  beforeUnmount: Se,
  destroyed: Se,
  unmounted: Se,
  activated: Se,
  deactivated: Se,
  errorCaptured: Se,
  serverPrefetch: Se,
  components: fn,
  directives: fn,
  watch: zf,
  provide: fi,
  inject: Bf
};
function fi(e, t) {
  return t
    ? e
      ? function () {
          return ge(U(e) ? e.call(this, this) : e, U(t) ? t.call(this, this) : t);
        }
      : t
    : e;
}
function Bf(e, t) {
  return fn(nr(e), nr(t));
}
function nr(e) {
  if (B(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
    return t;
  }
  return e;
}
function Se(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function fn(e, t) {
  return e ? ge(Object.create(null), e, t) : t;
}
function ui(e, t) {
  return e
    ? B(e) && B(t)
      ? [...new Set([...e, ...t])]
      : ge(Object.create(null), ai(e), ai(t ?? {}))
    : t;
}
function zf(e, t) {
  if (!e) return t;
  if (!t) return e;
  const n = ge(Object.create(null), e);
  for (const s in t) n[s] = Se(e[s], t[s]);
  return n;
}
function cl() {
  return {
    app: null,
    config: {
      isNativeTag: Sc,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: Object.create(null),
    optionsCache: new WeakMap(),
    propsCache: new WeakMap(),
    emitsCache: new WeakMap()
  };
}
let Lf = 0;
function Df(e, t) {
  return function (s, r = null) {
    (U(s) || (s = ge({}, s)), r != null && !ae(r) && (r = null));
    const i = cl(),
      o = new WeakSet(),
      l = [];
    let a = !1;
    const f = (i.app = {
      _uid: Lf++,
      _component: s,
      _props: r,
      _container: null,
      _context: i,
      _instance: null,
      version: Su,
      get config() {
        return i.config;
      },
      set config(c) {},
      use(c, ...u) {
        return (
          o.has(c) ||
            (c && U(c.install) ? (o.add(c), c.install(f, ...u)) : U(c) && (o.add(c), c(f, ...u))),
          f
        );
      },
      mixin(c) {
        return (i.mixins.includes(c) || i.mixins.push(c), f);
      },
      component(c, u) {
        return u ? ((i.components[c] = u), f) : i.components[c];
      },
      directive(c, u) {
        return u ? ((i.directives[c] = u), f) : i.directives[c];
      },
      mount(c, u, m) {
        if (!a) {
          const y = f._ceVNode || ne(s, r);
          return (
            (y.appContext = i),
            m === !0 ? (m = 'svg') : m === !1 && (m = void 0),
            e(y, c, m),
            (a = !0),
            (f._container = c),
            (c.__vue_app__ = f),
            Cs(y.component)
          );
        }
      },
      onUnmount(c) {
        l.push(c);
      },
      unmount() {
        a && (Ve(l, f._instance, 16), e(null, f._container), delete f._container.__vue_app__);
      },
      provide(c, u) {
        return ((i.provides[c] = u), f);
      },
      runWithContext(c) {
        const u = Pt;
        Pt = f;
        try {
          return c();
        } finally {
          Pt = u;
        }
      }
    });
    return f;
  };
}
let Pt = null;
function Uf(e, t) {
  if (be) {
    let n = be.provides;
    const s = be.parent && be.parent.provides;
    (s === n && (n = be.provides = Object.create(s)), (n[e] = t));
  }
}
function gn(e, t, n = !1) {
  const s = be || me;
  if (s || Pt) {
    const r = Pt
      ? Pt._context.provides
      : s
        ? s.parent == null
          ? s.vnode.appContext && s.vnode.appContext.provides
          : s.parent.provides
        : void 0;
    if (r && e in r) return r[e];
    if (arguments.length > 1) return n && U(t) ? t.call(s && s.proxy) : t;
  }
}
function Hf() {
  return !!(be || me || Pt);
}
const fl = {},
  ul = () => Object.create(fl),
  dl = (e) => Object.getPrototypeOf(e) === fl;
function Qf(e, t, n, s = !1) {
  const r = {},
    i = ul();
  ((e.propsDefaults = Object.create(null)), pl(e, t, r, i));
  for (const o in e.propsOptions[0]) o in r || (r[o] = void 0);
  (n ? (e.props = s ? r : sf(r)) : e.type.props ? (e.props = r) : (e.props = i), (e.attrs = i));
}
function Vf(e, t, n, s) {
  const {
      props: r,
      attrs: i,
      vnode: { patchFlag: o }
    } = e,
    l = Y(r),
    [a] = e.propsOptions;
  let f = !1;
  if ((s || o > 0) && !(o & 16)) {
    if (o & 8) {
      const c = e.vnode.dynamicProps;
      for (let u = 0; u < c.length; u++) {
        let m = c[u];
        if (_s(e.emitsOptions, m)) continue;
        const y = t[m];
        if (a)
          if (re(i, m)) y !== i[m] && ((i[m] = y), (f = !0));
          else {
            const h = Le(m);
            r[h] = sr(a, l, h, y, e, !1);
          }
        else y !== i[m] && ((i[m] = y), (f = !0));
      }
    }
  } else {
    pl(e, t, r, i) && (f = !0);
    let c;
    for (const u in l)
      (!t || (!re(t, u) && ((c = xt(u)) === u || !re(t, c)))) &&
        (a
          ? n && (n[u] !== void 0 || n[c] !== void 0) && (r[u] = sr(a, l, u, void 0, e, !0))
          : delete r[u]);
    if (i !== l) for (const u in i) (!t || !re(t, u)) && (delete i[u], (f = !0));
  }
  f && ot(e.attrs, 'set', '');
}
function pl(e, t, n, s) {
  const [r, i] = e.propsOptions;
  let o = !1,
    l;
  if (t)
    for (let a in t) {
      if (un(a)) continue;
      const f = t[a];
      let c;
      r && re(r, (c = Le(a)))
        ? !i || !i.includes(c)
          ? (n[c] = f)
          : ((l || (l = {}))[c] = f)
        : _s(e.emitsOptions, a) || ((!(a in s) || f !== s[a]) && ((s[a] = f), (o = !0)));
    }
  if (i) {
    const a = Y(n),
      f = l || oe;
    for (let c = 0; c < i.length; c++) {
      const u = i[c];
      n[u] = sr(r, a, u, f[u], e, !re(f, u));
    }
  }
  return o;
}
function sr(e, t, n, s, r, i) {
  const o = e[n];
  if (o != null) {
    const l = re(o, 'default');
    if (l && s === void 0) {
      const a = o.default;
      if (o.type !== Function && !o.skipFactory && U(a)) {
        const { propsDefaults: f } = r;
        if (n in f) s = f[n];
        else {
          const c = Mn(r);
          ((s = f[n] = a.call(null, t)), c());
        }
      } else s = a;
      r.ce && r.ce._setProp(n, s);
    }
    o[0] && (i && !l ? (s = !1) : o[1] && (s === '' || s === xt(n)) && (s = !0));
  }
  return s;
}
const Wf = new WeakMap();
function hl(e, t, n = !1) {
  const s = n ? Wf : t.propsCache,
    r = s.get(e);
  if (r) return r;
  const i = e.props,
    o = {},
    l = [];
  let a = !1;
  if (!U(e)) {
    const c = (u) => {
      a = !0;
      const [m, y] = hl(u, t, !0);
      (ge(o, m), y && l.push(...y));
    };
    (!n && t.mixins.length && t.mixins.forEach(c),
      e.extends && c(e.extends),
      e.mixins && e.mixins.forEach(c));
  }
  if (!i && !a) return (ae(e) && s.set(e, Qt), Qt);
  if (B(i))
    for (let c = 0; c < i.length; c++) {
      const u = Le(i[c]);
      di(u) && (o[u] = oe);
    }
  else if (i)
    for (const c in i) {
      const u = Le(c);
      if (di(u)) {
        const m = i[c],
          y = (o[u] = B(m) || U(m) ? { type: m } : ge({}, m)),
          h = y.type;
        let q = !1,
          w = !0;
        if (B(h))
          for (let O = 0; O < h.length; ++O) {
            const $ = h[O],
              N = U($) && $.name;
            if (N === 'Boolean') {
              q = !0;
              break;
            } else N === 'String' && (w = !1);
          }
        else q = U(h) && h.name === 'Boolean';
        ((y[0] = q), (y[1] = w), (q || re(y, 'default')) && l.push(u));
      }
    }
  const f = [o, l];
  return (ae(e) && s.set(e, f), f);
}
function di(e) {
  return e[0] !== '$' && !un(e);
}
const ml = (e) => e[0] === '_' || e === '$stable',
  kr = (e) => (B(e) ? e.map(nt) : [nt(e)]),
  Kf = (e, t, n) => {
    if (t._n) return t;
    const s = St((...r) => kr(t(...r)), n);
    return ((s._c = !1), s);
  },
  gl = (e, t, n) => {
    const s = e._ctx;
    for (const r in e) {
      if (ml(r)) continue;
      const i = e[r];
      if (U(i)) t[r] = Kf(r, i, s);
      else if (i != null) {
        const o = kr(i);
        t[r] = () => o;
      }
    }
  },
  bl = (e, t) => {
    const n = kr(t);
    e.slots.default = () => n;
  },
  yl = (e, t, n) => {
    for (const s in t) (n || s !== '_') && (e[s] = t[s]);
  },
  Gf = (e, t, n) => {
    const s = (e.slots = ul());
    if (e.vnode.shapeFlag & 32) {
      const r = t._;
      r ? (yl(s, t, n), n && qo(s, '_', r, !0)) : gl(t, s);
    } else t && bl(e, t);
  },
  Jf = (e, t, n) => {
    const { vnode: s, slots: r } = e;
    let i = !0,
      o = oe;
    if (s.shapeFlag & 32) {
      const l = t._;
      (l ? (n && l === 1 ? (i = !1) : yl(r, t, n)) : ((i = !t.$stable), gl(t, r)), (o = t));
    } else t && (bl(e, t), (o = { default: 1 }));
    if (i) for (const l in r) !ml(l) && o[l] == null && delete r[l];
  },
  $e = fu;
function Xf(e) {
  return Zf(e);
}
function Zf(e, t) {
  const n = bs();
  n.__VUE__ = !0;
  const {
      insert: s,
      remove: r,
      patchProp: i,
      createElement: o,
      createText: l,
      createComment: a,
      setText: f,
      setElementText: c,
      parentNode: u,
      nextSibling: m,
      setScopeId: y = st,
      insertStaticContent: h
    } = e,
    q = (d, p, b, S = null, v = null, _ = null, k = void 0, T = null, E = !!p.dynamicChildren) => {
      if (d === p) return;
      (d && !At(d, p) && ((S = Nn(d)), ye(d, v, _, !0), (d = null)),
        p.patchFlag === -2 && ((E = !1), (p.dynamicChildren = null)));
      const { type: C, ref: L, shapeFlag: P } = p;
      switch (C) {
        case Ss:
          w(d, p, b, S);
          break;
        case Fe:
          O(d, p, b, S);
          break;
        case Kn:
          d == null && $(p, b, S, k);
          break;
        case he:
          A(d, p, b, S, v, _, k, T, E);
          break;
        default:
          P & 1
            ? j(d, p, b, S, v, _, k, T, E)
            : P & 6
              ? G(d, p, b, S, v, _, k, T, E)
              : (P & 64 || P & 128) && C.process(d, p, b, S, v, _, k, T, E, rn);
      }
      L != null && v && ss(L, d && d.ref, _, p || d, !p);
    },
    w = (d, p, b, S) => {
      if (d == null) s((p.el = l(p.children)), b, S);
      else {
        const v = (p.el = d.el);
        p.children !== d.children && f(v, p.children);
      }
    },
    O = (d, p, b, S) => {
      d == null ? s((p.el = a(p.children || '')), b, S) : (p.el = d.el);
    },
    $ = (d, p, b, S) => {
      [d.el, d.anchor] = h(d.children, p, b, S, d.el, d.anchor);
    },
    N = ({ el: d, anchor: p }, b, S) => {
      let v;
      for (; d && d !== p; ) ((v = m(d)), s(d, b, S), (d = v));
      s(p, b, S);
    },
    F = ({ el: d, anchor: p }) => {
      let b;
      for (; d && d !== p; ) ((b = m(d)), r(d), (d = b));
      r(p);
    },
    j = (d, p, b, S, v, _, k, T, E) => {
      (p.type === 'svg' ? (k = 'svg') : p.type === 'math' && (k = 'mathml'),
        d == null ? te(p, b, S, v, _, k, T, E) : x(d, p, v, _, k, T, E));
    },
    te = (d, p, b, S, v, _, k, T) => {
      let E, C;
      const { props: L, shapeFlag: P, transition: z, dirs: D } = d;
      if (
        ((E = d.el = o(d.type, _, L && L.is, L)),
        P & 8 ? c(E, d.children) : P & 16 && I(d.children, E, null, S, v, Bs(d, _), k, T),
        D && Ct(d, null, S, 'created'),
        K(E, d, d.scopeId, k, S),
        L)
      ) {
        for (const ce in L) ce !== 'value' && !un(ce) && i(E, ce, null, L[ce], _, S);
        ('value' in L && i(E, 'value', null, L.value, _),
          (C = L.onVnodeBeforeMount) && Ye(C, S, d));
      }
      D && Ct(d, null, S, 'beforeMount');
      const Z = Yf(v, z);
      (Z && z.beforeEnter(E),
        s(E, p, b),
        ((C = L && L.onVnodeMounted) || Z || D) &&
          $e(() => {
            (C && Ye(C, S, d), Z && z.enter(E), D && Ct(d, null, S, 'mounted'));
          }, v));
    },
    K = (d, p, b, S, v) => {
      if ((b && y(d, b), S)) for (let _ = 0; _ < S.length; _++) y(d, S[_]);
      if (v) {
        let _ = v.subTree;
        if (p === _ || (Sl(_.type) && (_.ssContent === p || _.ssFallback === p))) {
          const k = v.vnode;
          K(d, k, k.scopeId, k.slotScopeIds, v.parent);
        }
      }
    },
    I = (d, p, b, S, v, _, k, T, E = 0) => {
      for (let C = E; C < d.length; C++) {
        const L = (d[C] = T ? gt(d[C]) : nt(d[C]));
        q(null, L, p, b, S, v, _, k, T);
      }
    },
    x = (d, p, b, S, v, _, k) => {
      const T = (p.el = d.el);
      let { patchFlag: E, dynamicChildren: C, dirs: L } = p;
      E |= d.patchFlag & 16;
      const P = d.props || oe,
        z = p.props || oe;
      let D;
      if (
        (b && Et(b, !1),
        (D = z.onVnodeBeforeUpdate) && Ye(D, b, p, d),
        L && Ct(p, d, b, 'beforeUpdate'),
        b && Et(b, !0),
        ((P.innerHTML && z.innerHTML == null) || (P.textContent && z.textContent == null)) &&
          c(T, ''),
        C
          ? M(d.dynamicChildren, C, T, b, S, Bs(p, v), _)
          : k || X(d, p, T, null, b, S, Bs(p, v), _, !1),
        E > 0)
      ) {
        if (E & 16) W(T, P, z, b, v);
        else if (
          (E & 2 && P.class !== z.class && i(T, 'class', null, z.class, v),
          E & 4 && i(T, 'style', P.style, z.style, v),
          E & 8)
        ) {
          const Z = p.dynamicProps;
          for (let ce = 0; ce < Z.length; ce++) {
            const ie = Z[ce],
              Ie = P[ie],
              ke = z[ie];
            (ke !== Ie || ie === 'value') && i(T, ie, Ie, ke, v, b);
          }
        }
        E & 1 && d.children !== p.children && c(T, p.children);
      } else !k && C == null && W(T, P, z, b, v);
      ((D = z.onVnodeUpdated) || L) &&
        $e(() => {
          (D && Ye(D, b, p, d), L && Ct(p, d, b, 'updated'));
        }, S);
    },
    M = (d, p, b, S, v, _, k) => {
      for (let T = 0; T < p.length; T++) {
        const E = d[T],
          C = p[T],
          L = E.el && (E.type === he || !At(E, C) || E.shapeFlag & 70) ? u(E.el) : b;
        q(E, C, L, null, S, v, _, k, !0);
      }
    },
    W = (d, p, b, S, v) => {
      if (p !== b) {
        if (p !== oe) for (const _ in p) !un(_) && !(_ in b) && i(d, _, p[_], null, v, S);
        for (const _ in b) {
          if (un(_)) continue;
          const k = b[_],
            T = p[_];
          k !== T && _ !== 'value' && i(d, _, T, k, v, S);
        }
        'value' in b && i(d, 'value', p.value, b.value, v);
      }
    },
    A = (d, p, b, S, v, _, k, T, E) => {
      const C = (p.el = d ? d.el : l('')),
        L = (p.anchor = d ? d.anchor : l(''));
      let { patchFlag: P, dynamicChildren: z, slotScopeIds: D } = p;
      (D && (T = T ? T.concat(D) : D),
        d == null
          ? (s(C, b, S), s(L, b, S), I(p.children || [], b, L, v, _, k, T, E))
          : P > 0 && P & 64 && z && d.dynamicChildren
            ? (M(d.dynamicChildren, z, b, v, _, k, T),
              (p.key != null || (v && p === v.subTree)) && ql(d, p, !0))
            : X(d, p, b, L, v, _, k, T, E));
    },
    G = (d, p, b, S, v, _, k, T, E) => {
      ((p.slotScopeIds = T),
        d == null
          ? p.shapeFlag & 512
            ? v.ctx.activate(p, b, S, k, E)
            : se(p, b, S, v, _, k, E)
          : Ae(d, p, E));
    },
    se = (d, p, b, S, v, _, k) => {
      const T = (d.component = bu(d, S, v));
      if ((xs(d) && (T.ctx.renderer = rn), yu(T, !1, k), T.asyncDep)) {
        if ((v && v.registerDep(T, J, k), !d.el)) {
          const E = (T.subTree = ne(Fe));
          O(null, E, p, b);
        }
      } else J(T, d, p, b, v, _, k);
    },
    Ae = (d, p, b) => {
      const S = (p.component = d.component);
      if (au(d, p, b))
        if (S.asyncDep && !S.asyncResolved) {
          V(S, p, b);
          return;
        } else ((S.next = p), S.update());
      else ((p.el = d.el), (S.vnode = p));
    },
    J = (d, p, b, S, v, _, k) => {
      const T = () => {
        if (d.isMounted) {
          let { next: P, bu: z, u: D, parent: Z, vnode: ce } = d;
          {
            const Je = wl(d);
            if (Je) {
              (P && ((P.el = ce.el), V(d, P, k)),
                Je.asyncDep.then(() => {
                  d.isUnmounted || T();
                }));
              return;
            }
          }
          let ie = P,
            Ie;
          (Et(d, !1),
            P ? ((P.el = ce.el), V(d, P, k)) : (P = ce),
            z && Wn(z),
            (Ie = P.props && P.props.onVnodeBeforeUpdate) && Ye(Ie, Z, P, ce),
            Et(d, !0));
          const ke = hi(d),
            Ge = d.subTree;
          ((d.subTree = ke),
            q(Ge, ke, u(Ge.el), Nn(Ge), d, v, _),
            (P.el = ke.el),
            ie === null && cu(d, ke.el),
            D && $e(D, v),
            (Ie = P.props && P.props.onVnodeUpdated) && $e(() => Ye(Ie, Z, P, ce), v));
        } else {
          let P;
          const { el: z, props: D } = p,
            { bm: Z, m: ce, parent: ie, root: Ie, type: ke } = d,
            Ge = Kt(p);
          (Et(d, !1),
            Z && Wn(Z),
            !Ge && (P = D && D.onVnodeBeforeMount) && Ye(P, ie, p),
            Et(d, !0));
          {
            Ie.ce && Ie.ce._injectChildStyle(ke);
            const Je = (d.subTree = hi(d));
            (q(null, Je, b, S, d, v, _), (p.el = Je.el));
          }
          if ((ce && $e(ce, v), !Ge && (P = D && D.onVnodeMounted))) {
            const Je = p;
            $e(() => Ye(P, ie, Je), v);
          }
          ((p.shapeFlag & 256 || (ie && Kt(ie.vnode) && ie.vnode.shapeFlag & 256)) &&
            d.a &&
            $e(d.a, v),
            (d.isMounted = !0),
            (p = b = S = null));
        }
      };
      d.scope.on();
      const E = (d.effect = new Eo(T));
      d.scope.off();
      const C = (d.update = E.run.bind(E)),
        L = (d.job = E.runIfDirty.bind(E));
      ((L.i = d), (L.id = d.uid), (E.scheduler = () => Tr(L)), Et(d, !0), C());
    },
    V = (d, p, b) => {
      p.component = d;
      const S = d.vnode.props;
      ((d.vnode = p),
        (d.next = null),
        Vf(d, p.props, S, b),
        Jf(d, p.children, b),
        vt(),
        ii(d),
        _t());
    },
    X = (d, p, b, S, v, _, k, T, E = !1) => {
      const C = d && d.children,
        L = d ? d.shapeFlag : 0,
        P = p.children,
        { patchFlag: z, shapeFlag: D } = p;
      if (z > 0) {
        if (z & 128) {
          Bt(C, P, b, S, v, _, k, T, E);
          return;
        } else if (z & 256) {
          Ke(C, P, b, S, v, _, k, T, E);
          return;
        }
      }
      D & 8
        ? (L & 16 && sn(C, v, _), P !== C && c(b, P))
        : L & 16
          ? D & 16
            ? Bt(C, P, b, S, v, _, k, T, E)
            : sn(C, v, _, !0)
          : (L & 8 && c(b, ''), D & 16 && I(P, b, S, v, _, k, T, E));
    },
    Ke = (d, p, b, S, v, _, k, T, E) => {
      ((d = d || Qt), (p = p || Qt));
      const C = d.length,
        L = p.length,
        P = Math.min(C, L);
      let z;
      for (z = 0; z < P; z++) {
        const D = (p[z] = E ? gt(p[z]) : nt(p[z]));
        q(d[z], D, b, null, v, _, k, T, E);
      }
      C > L ? sn(d, v, _, !0, !1, P) : I(p, b, S, v, _, k, T, E, P);
    },
    Bt = (d, p, b, S, v, _, k, T, E) => {
      let C = 0;
      const L = p.length;
      let P = d.length - 1,
        z = L - 1;
      for (; C <= P && C <= z; ) {
        const D = d[C],
          Z = (p[C] = E ? gt(p[C]) : nt(p[C]));
        if (At(D, Z)) q(D, Z, b, null, v, _, k, T, E);
        else break;
        C++;
      }
      for (; C <= P && C <= z; ) {
        const D = d[P],
          Z = (p[z] = E ? gt(p[z]) : nt(p[z]));
        if (At(D, Z)) q(D, Z, b, null, v, _, k, T, E);
        else break;
        (P--, z--);
      }
      if (C > P) {
        if (C <= z) {
          const D = z + 1,
            Z = D < L ? p[D].el : S;
          for (; C <= z; ) (q(null, (p[C] = E ? gt(p[C]) : nt(p[C])), b, Z, v, _, k, T, E), C++);
        }
      } else if (C > z) for (; C <= P; ) (ye(d[C], v, _, !0), C++);
      else {
        const D = C,
          Z = C,
          ce = new Map();
        for (C = Z; C <= z; C++) {
          const Me = (p[C] = E ? gt(p[C]) : nt(p[C]));
          Me.key != null && ce.set(Me.key, C);
        }
        let ie,
          Ie = 0;
        const ke = z - Z + 1;
        let Ge = !1,
          Je = 0;
        const on = new Array(ke);
        for (C = 0; C < ke; C++) on[C] = 0;
        for (C = D; C <= P; C++) {
          const Me = d[C];
          if (Ie >= ke) {
            ye(Me, v, _, !0);
            continue;
          }
          let Xe;
          if (Me.key != null) Xe = ce.get(Me.key);
          else
            for (ie = Z; ie <= z; ie++)
              if (on[ie - Z] === 0 && At(Me, p[ie])) {
                Xe = ie;
                break;
              }
          Xe === void 0
            ? ye(Me, v, _, !0)
            : ((on[Xe - Z] = C + 1),
              Xe >= Je ? (Je = Xe) : (Ge = !0),
              q(Me, p[Xe], b, null, v, _, k, T, E),
              Ie++);
        }
        const Nr = Ge ? eu(on) : Qt;
        for (ie = Nr.length - 1, C = ke - 1; C >= 0; C--) {
          const Me = Z + C,
            Xe = p[Me],
            jr = Me + 1 < L ? p[Me + 1].el : S;
          on[C] === 0
            ? q(null, Xe, b, jr, v, _, k, T, E)
            : Ge && (ie < 0 || C !== Nr[ie] ? we(Xe, b, jr, 2) : ie--);
        }
      }
    },
    we = (d, p, b, S, v = null) => {
      const { el: _, type: k, transition: T, children: E, shapeFlag: C } = d;
      if (C & 6) {
        we(d.component.subTree, p, b, S);
        return;
      }
      if (C & 128) {
        d.suspense.move(p, b, S);
        return;
      }
      if (C & 64) {
        k.move(d, p, b, rn);
        return;
      }
      if (k === he) {
        s(_, p, b);
        for (let P = 0; P < E.length; P++) we(E[P], p, b, S);
        s(d.anchor, p, b);
        return;
      }
      if (k === Kn) {
        N(d, p, b);
        return;
      }
      if (S !== 2 && C & 1 && T)
        if (S === 0) (T.beforeEnter(_), s(_, p, b), $e(() => T.enter(_), v));
        else {
          const { leave: P, delayLeave: z, afterLeave: D } = T,
            Z = () => s(_, p, b),
            ce = () => {
              P(_, () => {
                (Z(), D && D());
              });
            };
          z ? z(_, Z, ce) : ce();
        }
      else s(_, p, b);
    },
    ye = (d, p, b, S = !1, v = !1) => {
      const {
        type: _,
        props: k,
        ref: T,
        children: E,
        dynamicChildren: C,
        shapeFlag: L,
        patchFlag: P,
        dirs: z,
        cacheIndex: D
      } = d;
      if (
        (P === -2 && (v = !1),
        T != null && ss(T, null, b, d, !0),
        D != null && (p.renderCache[D] = void 0),
        L & 256)
      ) {
        p.ctx.deactivate(d);
        return;
      }
      const Z = L & 1 && z,
        ce = !Kt(d);
      let ie;
      if ((ce && (ie = k && k.onVnodeBeforeUnmount) && Ye(ie, p, d), L & 6)) $n(d.component, b, S);
      else {
        if (L & 128) {
          d.suspense.unmount(b, S);
          return;
        }
        (Z && Ct(d, null, p, 'beforeUnmount'),
          L & 64
            ? d.type.remove(d, p, b, rn, S)
            : C && !C.hasOnce && (_ !== he || (P > 0 && P & 64))
              ? sn(C, p, b, !1, !0)
              : ((_ === he && P & 384) || (!v && L & 16)) && sn(E, p, b),
          S && zt(d));
      }
      ((ce && (ie = k && k.onVnodeUnmounted)) || Z) &&
        $e(() => {
          (ie && Ye(ie, p, d), Z && Ct(d, null, p, 'unmounted'));
        }, b);
    },
    zt = (d) => {
      const { type: p, el: b, anchor: S, transition: v } = d;
      if (p === he) {
        Lt(b, S);
        return;
      }
      if (p === Kn) {
        F(d);
        return;
      }
      const _ = () => {
        (r(b), v && !v.persisted && v.afterLeave && v.afterLeave());
      };
      if (d.shapeFlag & 1 && v && !v.persisted) {
        const { leave: k, delayLeave: T } = v,
          E = () => k(b, _);
        T ? T(d.el, _, E) : E();
      } else _();
    },
    Lt = (d, p) => {
      let b;
      for (; d !== p; ) ((b = m(d)), r(d), (d = b));
      r(p);
    },
    $n = (d, p, b) => {
      const { bum: S, scope: v, job: _, subTree: k, um: T, m: E, a: C } = d;
      (pi(E),
        pi(C),
        S && Wn(S),
        v.stop(),
        _ && ((_.flags |= 8), ye(k, d, p, b)),
        T && $e(T, p),
        $e(() => {
          d.isUnmounted = !0;
        }, p),
        p &&
          p.pendingBranch &&
          !p.isUnmounted &&
          d.asyncDep &&
          !d.asyncResolved &&
          d.suspenseId === p.pendingId &&
          (p.deps--, p.deps === 0 && p.resolve()));
    },
    sn = (d, p, b, S = !1, v = !1, _ = 0) => {
      for (let k = _; k < d.length; k++) ye(d[k], p, b, S, v);
    },
    Nn = (d) => {
      if (d.shapeFlag & 6) return Nn(d.component.subTree);
      if (d.shapeFlag & 128) return d.suspense.next();
      const p = m(d.anchor || d.el),
        b = p && p[qf];
      return b ? m(b) : p;
    };
  let Fs = !1;
  const $r = (d, p, b) => {
      (d == null
        ? p._vnode && ye(p._vnode, null, null, !0)
        : q(p._vnode || null, d, p, null, null, null, b),
        (p._vnode = d),
        Fs || ((Fs = !0), ii(), Ho(), (Fs = !1)));
    },
    rn = { p: q, um: ye, m: we, r: zt, mt: se, mc: I, pc: X, pbc: M, n: Nn, o: e };
  return { render: $r, hydrate: void 0, createApp: Df($r) };
}
function Bs({ type: e, props: t }, n) {
  return (n === 'svg' && e === 'foreignObject') ||
    (n === 'mathml' && e === 'annotation-xml' && t && t.encoding && t.encoding.includes('html'))
    ? void 0
    : n;
}
function Et({ effect: e, job: t }, n) {
  n ? ((e.flags |= 32), (t.flags |= 4)) : ((e.flags &= -33), (t.flags &= -5));
}
function Yf(e, t) {
  return (!e || (e && !e.pendingBranch)) && t && !t.persisted;
}
function ql(e, t, n = !1) {
  const s = e.children,
    r = t.children;
  if (B(s) && B(r))
    for (let i = 0; i < s.length; i++) {
      const o = s[i];
      let l = r[i];
      (l.shapeFlag & 1 &&
        !l.dynamicChildren &&
        ((l.patchFlag <= 0 || l.patchFlag === 32) && ((l = r[i] = gt(r[i])), (l.el = o.el)),
        !n && l.patchFlag !== -2 && ql(o, l)),
        l.type === Ss && (l.el = o.el));
    }
}
function eu(e) {
  const t = e.slice(),
    n = [0];
  let s, r, i, o, l;
  const a = e.length;
  for (s = 0; s < a; s++) {
    const f = e[s];
    if (f !== 0) {
      if (((r = n[n.length - 1]), e[r] < f)) {
        ((t[s] = r), n.push(s));
        continue;
      }
      for (i = 0, o = n.length - 1; i < o; )
        ((l = (i + o) >> 1), e[n[l]] < f ? (i = l + 1) : (o = l));
      f < e[n[i]] && (i > 0 && (t[s] = n[i - 1]), (n[i] = s));
    }
  }
  for (i = n.length, o = n[i - 1]; i-- > 0; ) ((n[i] = o), (o = t[o]));
  return n;
}
function wl(e) {
  const t = e.subTree.component;
  if (t) return t.asyncDep && !t.asyncResolved ? t : wl(t);
}
function pi(e) {
  if (e) for (let t = 0; t < e.length; t++) e[t].flags |= 8;
}
const tu = Symbol.for('v-scx'),
  nu = () => gn(tu);
function Gt(e, t, n) {
  return xl(e, t, n);
}
function xl(e, t, n = oe) {
  const { immediate: s, deep: r, flush: i, once: o } = n,
    l = ge({}, n),
    a = (t && s) || (!t && i !== 'post');
  let f;
  if (En) {
    if (i === 'sync') {
      const y = nu();
      f = y.__watcherHandles || (y.__watcherHandles = []);
    } else if (!a) {
      const y = () => {};
      return ((y.stop = st), (y.resume = st), (y.pause = st), y);
    }
  }
  const c = be;
  l.call = (y, h, q) => Ve(y, c, h, q);
  let u = !1;
  (i === 'post'
    ? (l.scheduler = (y) => {
        $e(y, c && c.suspense);
      })
    : i !== 'sync' &&
      ((u = !0),
      (l.scheduler = (y, h) => {
        h ? y() : Tr(y);
      })),
    (l.augmentJob = (y) => {
      (t && (y.flags |= 4), u && ((y.flags |= 2), c && ((y.id = c.uid), (y.i = c))));
    }));
  const m = hf(e, t, l);
  return (En && (f ? f.push(m) : a && m()), m);
}
function su(e, t, n) {
  const s = this.proxy,
    r = ue(e) ? (e.includes('.') ? vl(s, e) : () => s[e]) : e.bind(s, s);
  let i;
  U(t) ? (i = t) : ((i = t.handler), (n = t));
  const o = Mn(this),
    l = xl(r, i.bind(s), n);
  return (o(), l);
}
function vl(e, t) {
  const n = t.split('.');
  return () => {
    let s = e;
    for (let r = 0; r < n.length && s; r++) s = s[n[r]];
    return s;
  };
}
const ru = (e, t) =>
  t === 'modelValue' || t === 'model-value'
    ? e.modelModifiers
    : e[`${t}Modifiers`] || e[`${Le(t)}Modifiers`] || e[`${xt(t)}Modifiers`];
function iu(e, t, ...n) {
  if (e.isUnmounted) return;
  const s = e.vnode.props || oe;
  let r = n;
  const i = t.startsWith('update:'),
    o = i && ru(s, t.slice(7));
  o && (o.trim && (r = n.map((c) => (ue(c) ? c.trim() : c))), o.number && (r = n.map(Zn)));
  let l,
    a = s[(l = Os(t))] || s[(l = Os(Le(t)))];
  (!a && i && (a = s[(l = Os(xt(t)))]), a && Ve(a, e, 6, r));
  const f = s[l + 'Once'];
  if (f) {
    if (!e.emitted) e.emitted = {};
    else if (e.emitted[l]) return;
    ((e.emitted[l] = !0), Ve(f, e, 6, r));
  }
}
function _l(e, t, n = !1) {
  const s = t.emitsCache,
    r = s.get(e);
  if (r !== void 0) return r;
  const i = e.emits;
  let o = {},
    l = !1;
  if (!U(e)) {
    const a = (f) => {
      const c = _l(f, t, !0);
      c && ((l = !0), ge(o, c));
    };
    (!n && t.mixins.length && t.mixins.forEach(a),
      e.extends && a(e.extends),
      e.mixins && e.mixins.forEach(a));
  }
  return !i && !l
    ? (ae(e) && s.set(e, null), null)
    : (B(i) ? i.forEach((a) => (o[a] = null)) : ge(o, i), ae(e) && s.set(e, o), o);
}
function _s(e, t) {
  return !e || !hs(t)
    ? !1
    : ((t = t.slice(2).replace(/Once$/, '')),
      re(e, t[0].toLowerCase() + t.slice(1)) || re(e, xt(t)) || re(e, t));
}
function hi(e) {
  const {
      type: t,
      vnode: n,
      proxy: s,
      withProxy: r,
      propsOptions: [i],
      slots: o,
      attrs: l,
      emit: a,
      render: f,
      renderCache: c,
      props: u,
      data: m,
      setupState: y,
      ctx: h,
      inheritAttrs: q
    } = e,
    w = ns(e);
  let O, $;
  try {
    if (n.shapeFlag & 4) {
      const F = r || s,
        j = F;
      ((O = nt(f.call(j, F, c, u, y, m, h))), ($ = l));
    } else {
      const F = t;
      ((O = nt(F.length > 1 ? F(u, { attrs: l, slots: o, emit: a }) : F(u, null))),
        ($ = t.props ? l : ou(l)));
    }
  } catch (F) {
    ((bn.length = 0), ws(F, e, 1), (O = ne(Fe)));
  }
  let N = O;
  if ($ && q !== !1) {
    const F = Object.keys($),
      { shapeFlag: j } = N;
    F.length && j & 7 && (i && F.some(hr) && ($ = lu($, i)), (N = qt(N, $, !1, !0)));
  }
  return (
    n.dirs && ((N = qt(N, null, !1, !0)), (N.dirs = N.dirs ? N.dirs.concat(n.dirs) : n.dirs)),
    n.transition && Nt(N, n.transition),
    (O = N),
    ns(w),
    O
  );
}
const ou = (e) => {
    let t;
    for (const n in e) (n === 'class' || n === 'style' || hs(n)) && ((t || (t = {}))[n] = e[n]);
    return t;
  },
  lu = (e, t) => {
    const n = {};
    for (const s in e) (!hr(s) || !(s.slice(9) in t)) && (n[s] = e[s]);
    return n;
  };
function au(e, t, n) {
  const { props: s, children: r, component: i } = e,
    { props: o, children: l, patchFlag: a } = t,
    f = i.emitsOptions;
  if (t.dirs || t.transition) return !0;
  if (n && a >= 0) {
    if (a & 1024) return !0;
    if (a & 16) return s ? mi(s, o, f) : !!o;
    if (a & 8) {
      const c = t.dynamicProps;
      for (let u = 0; u < c.length; u++) {
        const m = c[u];
        if (o[m] !== s[m] && !_s(f, m)) return !0;
      }
    }
  } else
    return (r || l) && (!l || !l.$stable) ? !0 : s === o ? !1 : s ? (o ? mi(s, o, f) : !0) : !!o;
  return !1;
}
function mi(e, t, n) {
  const s = Object.keys(t);
  if (s.length !== Object.keys(e).length) return !0;
  for (let r = 0; r < s.length; r++) {
    const i = s[r];
    if (t[i] !== e[i] && !_s(n, i)) return !0;
  }
  return !1;
}
function cu({ vnode: e, parent: t }, n) {
  for (; t; ) {
    const s = t.subTree;
    if ((s.suspense && s.suspense.activeBranch === e && (s.el = e.el), s === e))
      (((e = t.vnode).el = n), (t = t.parent));
    else break;
  }
}
const Sl = (e) => e.__isSuspense;
function fu(e, t) {
  t && t.pendingBranch ? (B(e) ? t.effects.push(...e) : t.effects.push(e)) : bf(e);
}
const he = Symbol.for('v-fgt'),
  Ss = Symbol.for('v-txt'),
  Fe = Symbol.for('v-cmt'),
  Kn = Symbol.for('v-stc'),
  bn = [];
let Ne = null;
function Q(e = !1) {
  bn.push((Ne = e ? null : []));
}
function uu() {
  (bn.pop(), (Ne = bn[bn.length - 1] || null));
}
let Sn = 1;
function gi(e, t = !1) {
  ((Sn += e), e < 0 && Ne && t && (Ne.hasOnce = !0));
}
function Cl(e) {
  return ((e.dynamicChildren = Sn > 0 ? Ne || Qt : null), uu(), Sn > 0 && Ne && Ne.push(e), e);
}
function ee(e, t, n, s, r, i) {
  return Cl(R(e, t, n, s, r, i, !0));
}
function ct(e, t, n, s, r) {
  return Cl(ne(e, t, n, s, r, !0));
}
function Cn(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function At(e, t) {
  return e.type === t.type && e.key === t.key;
}
const El = ({ key: e }) => e ?? null,
  Gn = ({ ref: e, ref_key: t, ref_for: n }) => (
    typeof e == 'number' && (e = '' + e),
    e != null ? (ue(e) || de(e) || U(e) ? { i: me, r: e, k: t, f: !!n } : e) : null
  );
function R(e, t = null, n = null, s = 0, r = null, i = e === he ? 0 : 1, o = !1, l = !1) {
  const a = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && El(t),
    ref: t && Gn(t),
    scopeId: Vo,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: i,
    patchFlag: s,
    dynamicProps: r,
    dynamicChildren: null,
    appContext: null,
    ctx: me
  };
  return (
    l ? (Rr(a, n), i & 128 && e.normalize(a)) : n && (a.shapeFlag |= ue(n) ? 8 : 16),
    Sn > 0 && !o && Ne && (a.patchFlag > 0 || i & 6) && a.patchFlag !== 32 && Ne.push(a),
    a
  );
}
const ne = du;
function du(e, t = null, n = null, s = 0, r = null, i = !1) {
  if (((!e || e === sl) && (e = Fe), Cn(e))) {
    const l = qt(e, t, !0);
    return (
      n && Rr(l, n),
      Sn > 0 && !i && Ne && (l.shapeFlag & 6 ? (Ne[Ne.indexOf(e)] = l) : Ne.push(l)),
      (l.patchFlag = -2),
      l
    );
  }
  if ((vu(e) && (e = e.__vccOpts), t)) {
    t = pu(t);
    let { class: l, style: a } = t;
    (l && !ue(l) && (t.class = Pe(l)),
      ae(a) && (Sr(a) && !B(a) && (a = ge({}, a)), (t.style = nn(a))));
  }
  const o = ue(e) ? 1 : Sl(e) ? 128 : Wo(e) ? 64 : ae(e) ? 4 : U(e) ? 2 : 0;
  return R(e, t, n, s, r, o, i, !0);
}
function pu(e) {
  return e ? (Sr(e) || dl(e) ? ge({}, e) : e) : null;
}
function qt(e, t, n = !1, s = !1) {
  const { props: r, ref: i, patchFlag: o, children: l, transition: a } = e,
    f = t ? Tl(r || {}, t) : r,
    c = {
      __v_isVNode: !0,
      __v_skip: !0,
      type: e.type,
      props: f,
      key: f && El(f),
      ref: t && t.ref ? (n && i ? (B(i) ? i.concat(Gn(t)) : [i, Gn(t)]) : Gn(t)) : i,
      scopeId: e.scopeId,
      slotScopeIds: e.slotScopeIds,
      children: l,
      target: e.target,
      targetStart: e.targetStart,
      targetAnchor: e.targetAnchor,
      staticCount: e.staticCount,
      shapeFlag: e.shapeFlag,
      patchFlag: t && e.type !== he ? (o === -1 ? 16 : o | 16) : o,
      dynamicProps: e.dynamicProps,
      dynamicChildren: e.dynamicChildren,
      appContext: e.appContext,
      dirs: e.dirs,
      transition: a,
      component: e.component,
      suspense: e.suspense,
      ssContent: e.ssContent && qt(e.ssContent),
      ssFallback: e.ssFallback && qt(e.ssFallback),
      el: e.el,
      anchor: e.anchor,
      ctx: e.ctx,
      ce: e.ce
    };
  return (a && s && Nt(c, a.clone(c)), c);
}
function is(e = ' ', t = 0) {
  return ne(Ss, null, e, t);
}
function hu(e, t) {
  const n = ne(Kn, null, e);
  return ((n.staticCount = t), n);
}
function He(e = '', t = !1) {
  return t ? (Q(), ct(Fe, null, e)) : ne(Fe, null, e);
}
function nt(e) {
  return e == null || typeof e == 'boolean'
    ? ne(Fe)
    : B(e)
      ? ne(he, null, e.slice())
      : Cn(e)
        ? gt(e)
        : ne(Ss, null, String(e));
}
function gt(e) {
  return (e.el === null && e.patchFlag !== -1) || e.memo ? e : qt(e);
}
function Rr(e, t) {
  let n = 0;
  const { shapeFlag: s } = e;
  if (t == null) t = null;
  else if (B(t)) n = 16;
  else if (typeof t == 'object')
    if (s & 65) {
      const r = t.default;
      r && (r._c && (r._d = !1), Rr(e, r()), r._c && (r._d = !0));
      return;
    } else {
      n = 32;
      const r = t._;
      !r && !dl(t)
        ? (t._ctx = me)
        : r === 3 && me && (me.slots._ === 1 ? (t._ = 1) : ((t._ = 2), (e.patchFlag |= 1024)));
    }
  else
    U(t)
      ? ((t = { default: t, _ctx: me }), (n = 32))
      : ((t = String(t)), s & 64 ? ((n = 16), (t = [is(t)])) : (n = 8));
  ((e.children = t), (e.shapeFlag |= n));
}
function Tl(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    for (const r in s)
      if (r === 'class') t.class !== s.class && (t.class = Pe([t.class, s.class]));
      else if (r === 'style') t.style = nn([t.style, s.style]);
      else if (hs(r)) {
        const i = t[r],
          o = s[r];
        o && i !== o && !(B(i) && i.includes(o)) && (t[r] = i ? [].concat(i, o) : o);
      } else r !== '' && (t[r] = s[r]);
  }
  return t;
}
function Ye(e, t, n, s = null) {
  Ve(e, t, 7, [n, s]);
}
const mu = cl();
let gu = 0;
function bu(e, t, n) {
  const s = e.type,
    r = (t ? t.appContext : e.appContext) || mu,
    i = {
      uid: gu++,
      vnode: e,
      type: s,
      parent: t,
      appContext: r,
      root: null,
      next: null,
      subTree: null,
      effect: null,
      update: null,
      job: null,
      scope: new _o(!0),
      render: null,
      proxy: null,
      exposed: null,
      exposeProxy: null,
      withProxy: null,
      provides: t ? t.provides : Object.create(r.provides),
      ids: t ? t.ids : ['', 0, 0],
      accessCache: null,
      renderCache: [],
      components: null,
      directives: null,
      propsOptions: hl(s, r),
      emitsOptions: _l(s, r),
      emit: null,
      emitted: null,
      propsDefaults: oe,
      inheritAttrs: s.inheritAttrs,
      ctx: oe,
      data: oe,
      props: oe,
      attrs: oe,
      slots: oe,
      refs: oe,
      setupState: oe,
      setupContext: null,
      suspense: n,
      suspenseId: n ? n.pendingId : 0,
      asyncDep: null,
      asyncResolved: !1,
      isMounted: !1,
      isUnmounted: !1,
      isDeactivated: !1,
      bc: null,
      c: null,
      bm: null,
      m: null,
      bu: null,
      u: null,
      um: null,
      bum: null,
      da: null,
      a: null,
      rtg: null,
      rtc: null,
      ec: null,
      sp: null
    };
  return (
    (i.ctx = { _: i }),
    (i.root = t ? t.root : i),
    (i.emit = iu.bind(null, i)),
    e.ce && e.ce(i),
    i
  );
}
let be = null;
const Or = () => be || me;
let os, rr;
{
  const e = bs(),
    t = (n, s) => {
      let r;
      return (
        (r = e[n]) || (r = e[n] = []),
        r.push(s),
        (i) => {
          r.length > 1 ? r.forEach((o) => o(i)) : r[0](i);
        }
      );
    };
  ((os = t('__VUE_INSTANCE_SETTERS__', (n) => (be = n))),
    (rr = t('__VUE_SSR_SETTERS__', (n) => (En = n))));
}
const Mn = (e) => {
    const t = be;
    return (
      os(e),
      e.scope.on(),
      () => {
        (e.scope.off(), os(t));
      }
    );
  },
  bi = () => {
    (be && be.scope.off(), os(null));
  };
function Fl(e) {
  return e.vnode.shapeFlag & 4;
}
let En = !1;
function yu(e, t = !1, n = !1) {
  t && rr(t);
  const { props: s, children: r } = e.vnode,
    i = Fl(e);
  (Qf(e, s, i, t), Gf(e, r, n));
  const o = i ? qu(e, t) : void 0;
  return (t && rr(!1), o);
}
function qu(e, t) {
  const n = e.type;
  ((e.accessCache = Object.create(null)), (e.proxy = new Proxy(e.ctx, If)));
  const { setup: s } = n;
  if (s) {
    vt();
    const r = (e.setupContext = s.length > 1 ? kl(e) : null),
      i = Mn(e),
      o = On(s, e, 0, [e.props, r]),
      l = go(o);
    if ((_t(), i(), (l || e.sp) && !Kt(e) && Yo(e), l)) {
      if ((o.then(bi, bi), t))
        return o
          .then((a) => {
            yi(e, a);
          })
          .catch((a) => {
            ws(a, e, 0);
          });
      e.asyncDep = o;
    } else yi(e, o);
  } else Al(e);
}
function yi(e, t, n) {
  (U(t)
    ? e.type.__ssrInlineRender
      ? (e.ssrRender = t)
      : (e.render = t)
    : ae(t) && (e.setupState = Lo(t)),
    Al(e));
}
function Al(e, t, n) {
  const s = e.type;
  e.render || (e.render = s.render || st);
  {
    const r = Mn(e);
    vt();
    try {
      $f(e);
    } finally {
      (_t(), r());
    }
  }
}
const wu = {
  get(e, t) {
    return (xe(e, 'get', ''), e[t]);
  }
};
function kl(e) {
  const t = (n) => {
    e.exposed = n || {};
  };
  return { attrs: new Proxy(e.attrs, wu), slots: e.slots, emit: e.emit, expose: t };
}
function Cs(e) {
  return e.exposed
    ? e.exposeProxy ||
        (e.exposeProxy = new Proxy(Lo(Cr(e.exposed)), {
          get(t, n) {
            if (n in t) return t[n];
            if (n in mn) return mn[n](e);
          },
          has(t, n) {
            return n in t || n in mn;
          }
        }))
    : e.proxy;
}
function xu(e, t = !0) {
  return U(e) ? e.displayName || e.name : e.name || (t && e.__name);
}
function vu(e) {
  return U(e) && '__vccOpts' in e;
}
const le = (e, t) => df(e, t, En);
function _u(e, t, n) {
  const s = arguments.length;
  return s === 2
    ? ae(t) && !B(t)
      ? Cn(t)
        ? ne(e, null, [t])
        : ne(e, t)
      : ne(e, null, t)
    : (s > 3 ? (n = Array.prototype.slice.call(arguments, 2)) : s === 3 && Cn(n) && (n = [n]),
      ne(e, t, n));
}
const Su = '3.5.13';
/**
 * @vue/runtime-dom v3.5.13
 * (c) 2018-present Yuxi (Evan) You and Vue contributors
 * @license MIT
 **/ let ir;
const qi = typeof window < 'u' && window.trustedTypes;
if (qi)
  try {
    ir = qi.createPolicy('vue', { createHTML: (e) => e });
  } catch {}
const Rl = ir ? (e) => ir.createHTML(e) : (e) => e,
  Cu = 'http://www.w3.org/2000/svg',
  Eu = 'http://www.w3.org/1998/Math/MathML',
  it = typeof document < 'u' ? document : null,
  wi = it && it.createElement('template'),
  Tu = {
    insert: (e, t, n) => {
      t.insertBefore(e, n || null);
    },
    remove: (e) => {
      const t = e.parentNode;
      t && t.removeChild(e);
    },
    createElement: (e, t, n, s) => {
      const r =
        t === 'svg'
          ? it.createElementNS(Cu, e)
          : t === 'mathml'
            ? it.createElementNS(Eu, e)
            : n
              ? it.createElement(e, { is: n })
              : it.createElement(e);
      return (
        e === 'select' && s && s.multiple != null && r.setAttribute('multiple', s.multiple),
        r
      );
    },
    createText: (e) => it.createTextNode(e),
    createComment: (e) => it.createComment(e),
    setText: (e, t) => {
      e.nodeValue = t;
    },
    setElementText: (e, t) => {
      e.textContent = t;
    },
    parentNode: (e) => e.parentNode,
    nextSibling: (e) => e.nextSibling,
    querySelector: (e) => it.querySelector(e),
    setScopeId(e, t) {
      e.setAttribute(t, '');
    },
    insertStaticContent(e, t, n, s, r, i) {
      const o = n ? n.previousSibling : t.lastChild;
      if (r && (r === i || r.nextSibling))
        for (; t.insertBefore(r.cloneNode(!0), n), !(r === i || !(r = r.nextSibling)); );
      else {
        wi.innerHTML = Rl(
          s === 'svg' ? `<svg>${e}</svg>` : s === 'mathml' ? `<math>${e}</math>` : e
        );
        const l = wi.content;
        if (s === 'svg' || s === 'mathml') {
          const a = l.firstChild;
          for (; a.firstChild; ) l.appendChild(a.firstChild);
          l.removeChild(a);
        }
        t.insertBefore(l, n);
      }
      return [o ? o.nextSibling : t.firstChild, n ? n.previousSibling : t.lastChild];
    }
  },
  ut = 'transition',
  cn = 'animation',
  Xt = Symbol('_vtc'),
  Ol = {
    name: String,
    type: String,
    css: { type: Boolean, default: !0 },
    duration: [String, Number, Object],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
  },
  Pl = ge({}, Go, Ol),
  Fu = (e) => ((e.displayName = 'Transition'), (e.props = Pl), e),
  Il = Fu((e, { slots: t }) => _u(xf, Ml(e), t)),
  Tt = (e, t = []) => {
    B(e) ? e.forEach((n) => n(...t)) : e && e(...t);
  },
  xi = (e) => (e ? (B(e) ? e.some((t) => t.length > 1) : e.length > 1) : !1);
function Ml(e) {
  const t = {};
  for (const A in e) A in Ol || (t[A] = e[A]);
  if (e.css === !1) return t;
  const {
      name: n = 'v',
      type: s,
      duration: r,
      enterFromClass: i = `${n}-enter-from`,
      enterActiveClass: o = `${n}-enter-active`,
      enterToClass: l = `${n}-enter-to`,
      appearFromClass: a = i,
      appearActiveClass: f = o,
      appearToClass: c = l,
      leaveFromClass: u = `${n}-leave-from`,
      leaveActiveClass: m = `${n}-leave-active`,
      leaveToClass: y = `${n}-leave-to`
    } = e,
    h = Au(r),
    q = h && h[0],
    w = h && h[1],
    {
      onBeforeEnter: O,
      onEnter: $,
      onEnterCancelled: N,
      onLeave: F,
      onLeaveCancelled: j,
      onBeforeAppear: te = O,
      onAppear: K = $,
      onAppearCancelled: I = N
    } = t,
    x = (A, G, se, Ae) => {
      ((A._enterCancelled = Ae), dt(A, G ? c : l), dt(A, G ? f : o), se && se());
    },
    M = (A, G) => {
      ((A._isLeaving = !1), dt(A, u), dt(A, y), dt(A, m), G && G());
    },
    W = (A) => (G, se) => {
      const Ae = A ? K : $,
        J = () => x(G, A, se);
      (Tt(Ae, [G, J]),
        vi(() => {
          (dt(G, A ? a : i), et(G, A ? c : l), xi(Ae) || _i(G, s, q, J));
        }));
    };
  return ge(t, {
    onBeforeEnter(A) {
      (Tt(O, [A]), et(A, i), et(A, o));
    },
    onBeforeAppear(A) {
      (Tt(te, [A]), et(A, a), et(A, f));
    },
    onEnter: W(!1),
    onAppear: W(!0),
    onLeave(A, G) {
      A._isLeaving = !0;
      const se = () => M(A, G);
      (et(A, u),
        A._enterCancelled ? (et(A, m), or()) : (or(), et(A, m)),
        vi(() => {
          A._isLeaving && (dt(A, u), et(A, y), xi(F) || _i(A, s, w, se));
        }),
        Tt(F, [A, se]));
    },
    onEnterCancelled(A) {
      (x(A, !1, void 0, !0), Tt(N, [A]));
    },
    onAppearCancelled(A) {
      (x(A, !0, void 0, !0), Tt(I, [A]));
    },
    onLeaveCancelled(A) {
      (M(A), Tt(j, [A]));
    }
  });
}
function Au(e) {
  if (e == null) return null;
  if (ae(e)) return [zs(e.enter), zs(e.leave)];
  {
    const t = zs(e);
    return [t, t];
  }
}
function zs(e) {
  return Ac(e);
}
function et(e, t) {
  (t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e[Xt] || (e[Xt] = new Set())).add(t));
}
function dt(e, t) {
  t.split(/\s+/).forEach((s) => s && e.classList.remove(s));
  const n = e[Xt];
  n && (n.delete(t), n.size || (e[Xt] = void 0));
}
function vi(e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}
let ku = 0;
function _i(e, t, n, s) {
  const r = (e._endId = ++ku),
    i = () => {
      r === e._endId && s();
    };
  if (n != null) return setTimeout(i, n);
  const { type: o, timeout: l, propCount: a } = $l(e, t);
  if (!o) return s();
  const f = o + 'end';
  let c = 0;
  const u = () => {
      (e.removeEventListener(f, m), i());
    },
    m = (y) => {
      y.target === e && ++c >= a && u();
    };
  (setTimeout(() => {
    c < a && u();
  }, l + 1),
    e.addEventListener(f, m));
}
function $l(e, t) {
  const n = window.getComputedStyle(e),
    s = (h) => (n[h] || '').split(', '),
    r = s(`${ut}Delay`),
    i = s(`${ut}Duration`),
    o = Si(r, i),
    l = s(`${cn}Delay`),
    a = s(`${cn}Duration`),
    f = Si(l, a);
  let c = null,
    u = 0,
    m = 0;
  t === ut
    ? o > 0 && ((c = ut), (u = o), (m = i.length))
    : t === cn
      ? f > 0 && ((c = cn), (u = f), (m = a.length))
      : ((u = Math.max(o, f)),
        (c = u > 0 ? (o > f ? ut : cn) : null),
        (m = c ? (c === ut ? i.length : a.length) : 0));
  const y = c === ut && /\b(transform|all)(,|$)/.test(s(`${ut}Property`).toString());
  return { type: c, timeout: u, propCount: m, hasTransform: y };
}
function Si(e, t) {
  for (; e.length < t.length; ) e = e.concat(e);
  return Math.max(...t.map((n, s) => Ci(n) + Ci(e[s])));
}
function Ci(e) {
  return e === 'auto' ? 0 : Number(e.slice(0, -1).replace(',', '.')) * 1e3;
}
function or() {
  return document.body.offsetHeight;
}
function Ru(e, t, n) {
  const s = e[Xt];
  (s && (t = (t ? [t, ...s] : [...s]).join(' ')),
    t == null ? e.removeAttribute('class') : n ? e.setAttribute('class', t) : (e.className = t));
}
const Ei = Symbol('_vod'),
  Ou = Symbol('_vsh'),
  Pu = Symbol(''),
  Iu = /(^|;)\s*display\s*:/;
function Mu(e, t, n) {
  const s = e.style,
    r = ue(n);
  let i = !1;
  if (n && !r) {
    if (t)
      if (ue(t))
        for (const o of t.split(';')) {
          const l = o.slice(0, o.indexOf(':')).trim();
          n[l] == null && Jn(s, l, '');
        }
      else for (const o in t) n[o] == null && Jn(s, o, '');
    for (const o in n) (o === 'display' && (i = !0), Jn(s, o, n[o]));
  } else if (r) {
    if (t !== n) {
      const o = s[Pu];
      (o && (n += ';' + o), (s.cssText = n), (i = Iu.test(n)));
    }
  } else t && e.removeAttribute('style');
  Ei in e && ((e[Ei] = i ? s.display : ''), e[Ou] && (s.display = 'none'));
}
const Ti = /\s*!important$/;
function Jn(e, t, n) {
  if (B(n)) n.forEach((s) => Jn(e, t, s));
  else if ((n == null && (n = ''), t.startsWith('--'))) e.setProperty(t, n);
  else {
    const s = $u(e, t);
    Ti.test(n) ? e.setProperty(xt(s), n.replace(Ti, ''), 'important') : (e[s] = n);
  }
}
const Fi = ['Webkit', 'Moz', 'ms'],
  Ls = {};
function $u(e, t) {
  const n = Ls[t];
  if (n) return n;
  let s = Le(t);
  if (s !== 'filter' && s in e) return (Ls[t] = s);
  s = gs(s);
  for (let r = 0; r < Fi.length; r++) {
    const i = Fi[r] + s;
    if (i in e) return (Ls[t] = i);
  }
  return t;
}
const Ai = 'http://www.w3.org/1999/xlink';
function ki(e, t, n, s, r, i = Mc(t)) {
  s && t.startsWith('xlink:')
    ? n == null
      ? e.removeAttributeNS(Ai, t.slice(6, t.length))
      : e.setAttributeNS(Ai, t, n)
    : n == null || (i && !wo(n))
      ? e.removeAttribute(t)
      : e.setAttribute(t, i ? '' : Qe(n) ? String(n) : n);
}
function Ri(e, t, n, s, r) {
  if (t === 'innerHTML' || t === 'textContent') {
    n != null && (e[t] = t === 'innerHTML' ? Rl(n) : n);
    return;
  }
  const i = e.tagName;
  if (t === 'value' && i !== 'PROGRESS' && !i.includes('-')) {
    const l = i === 'OPTION' ? e.getAttribute('value') || '' : e.value,
      a = n == null ? (e.type === 'checkbox' ? 'on' : '') : String(n);
    ((l !== a || !('_value' in e)) && (e.value = a),
      n == null && e.removeAttribute(t),
      (e._value = n));
    return;
  }
  let o = !1;
  if (n === '' || n == null) {
    const l = typeof e[t];
    l === 'boolean'
      ? (n = wo(n))
      : n == null && l === 'string'
        ? ((n = ''), (o = !0))
        : l === 'number' && ((n = 0), (o = !0));
  }
  try {
    e[t] = n;
  } catch {}
  o && e.removeAttribute(r || t);
}
function at(e, t, n, s) {
  e.addEventListener(t, n, s);
}
function Nu(e, t, n, s) {
  e.removeEventListener(t, n, s);
}
const Oi = Symbol('_vei');
function ju(e, t, n, s, r = null) {
  const i = e[Oi] || (e[Oi] = {}),
    o = i[t];
  if (s && o) o.value = s;
  else {
    const [l, a] = Bu(t);
    if (s) {
      const f = (i[t] = Du(s, r));
      at(e, l, f, a);
    } else o && (Nu(e, l, o, a), (i[t] = void 0));
  }
}
const Pi = /(?:Once|Passive|Capture)$/;
function Bu(e) {
  let t;
  if (Pi.test(e)) {
    t = {};
    let s;
    for (; (s = e.match(Pi)); )
      ((e = e.slice(0, e.length - s[0].length)), (t[s[0].toLowerCase()] = !0));
  }
  return [e[2] === ':' ? e.slice(3) : xt(e.slice(2)), t];
}
let Ds = 0;
const zu = Promise.resolve(),
  Lu = () => Ds || (zu.then(() => (Ds = 0)), (Ds = Date.now()));
function Du(e, t) {
  const n = (s) => {
    if (!s._vts) s._vts = Date.now();
    else if (s._vts <= n.attached) return;
    Ve(Uu(s, n.value), t, 5, [s]);
  };
  return ((n.value = e), (n.attached = Lu()), n);
}
function Uu(e, t) {
  if (B(t)) {
    const n = e.stopImmediatePropagation;
    return (
      (e.stopImmediatePropagation = () => {
        (n.call(e), (e._stopped = !0));
      }),
      t.map((s) => (r) => !r._stopped && s && s(r))
    );
  } else return t;
}
const Ii = (e) =>
    e.charCodeAt(0) === 111 &&
    e.charCodeAt(1) === 110 &&
    e.charCodeAt(2) > 96 &&
    e.charCodeAt(2) < 123,
  Hu = (e, t, n, s, r, i) => {
    const o = r === 'svg';
    t === 'class'
      ? Ru(e, s, o)
      : t === 'style'
        ? Mu(e, n, s)
        : hs(t)
          ? hr(t) || ju(e, t, n, s, i)
          : (
                t[0] === '.'
                  ? ((t = t.slice(1)), !0)
                  : t[0] === '^'
                    ? ((t = t.slice(1)), !1)
                    : Qu(e, t, s, o)
              )
            ? (Ri(e, t, s),
              !e.tagName.includes('-') &&
                (t === 'value' || t === 'checked' || t === 'selected') &&
                ki(e, t, s, o, i, t !== 'value'))
            : e._isVueCE && (/[A-Z]/.test(t) || !ue(s))
              ? Ri(e, Le(t), s, i, t)
              : (t === 'true-value'
                  ? (e._trueValue = s)
                  : t === 'false-value' && (e._falseValue = s),
                ki(e, t, s, o));
  };
function Qu(e, t, n, s) {
  if (s) return !!(t === 'innerHTML' || t === 'textContent' || (t in e && Ii(t) && U(n)));
  if (
    t === 'spellcheck' ||
    t === 'draggable' ||
    t === 'translate' ||
    t === 'form' ||
    (t === 'list' && e.tagName === 'INPUT') ||
    (t === 'type' && e.tagName === 'TEXTAREA')
  )
    return !1;
  if (t === 'width' || t === 'height') {
    const r = e.tagName;
    if (r === 'IMG' || r === 'VIDEO' || r === 'CANVAS' || r === 'SOURCE') return !1;
  }
  return Ii(t) && ue(n) ? !1 : t in e;
}
const Nl = new WeakMap(),
  jl = new WeakMap(),
  ls = Symbol('_moveCb'),
  Mi = Symbol('_enterCb'),
  Vu = (e) => (delete e.props.mode, e),
  Wu = Vu({
    name: 'TransitionGroup',
    props: ge({}, Pl, { tag: String, moveClass: String }),
    setup(e, { slots: t }) {
      const n = Or(),
        s = Ko();
      let r, i;
      return (
        tl(() => {
          if (!r.length) return;
          const o = e.moveClass || `${e.name || 'v'}-move`;
          if (!Zu(r[0].el, n.vnode.el, o)) return;
          (r.forEach(Gu), r.forEach(Ju));
          const l = r.filter(Xu);
          (or(),
            l.forEach((a) => {
              const f = a.el,
                c = f.style;
              (et(f, o), (c.transform = c.webkitTransform = c.transitionDuration = ''));
              const u = (f[ls] = (m) => {
                (m && m.target !== f) ||
                  ((!m || /transform$/.test(m.propertyName)) &&
                    (f.removeEventListener('transitionend', u), (f[ls] = null), dt(f, o)));
              });
              f.addEventListener('transitionend', u);
            }));
        }),
        () => {
          const o = Y(e),
            l = Ml(o);
          let a = o.tag || he;
          if (((r = []), i))
            for (let f = 0; f < i.length; f++) {
              const c = i[f];
              c.el &&
                c.el instanceof Element &&
                (r.push(c), Nt(c, _n(c, l, s, n)), Nl.set(c, c.el.getBoundingClientRect()));
            }
          i = t.default ? Fr(t.default()) : [];
          for (let f = 0; f < i.length; f++) {
            const c = i[f];
            c.key != null && Nt(c, _n(c, l, s, n));
          }
          return ne(a, null, i);
        }
      );
    }
  }),
  Ku = Wu;
function Gu(e) {
  const t = e.el;
  (t[ls] && t[ls](), t[Mi] && t[Mi]());
}
function Ju(e) {
  jl.set(e, e.el.getBoundingClientRect());
}
function Xu(e) {
  const t = Nl.get(e),
    n = jl.get(e),
    s = t.left - n.left,
    r = t.top - n.top;
  if (s || r) {
    const i = e.el.style;
    return (
      (i.transform = i.webkitTransform = `translate(${s}px,${r}px)`),
      (i.transitionDuration = '0s'),
      e
    );
  }
}
function Zu(e, t, n) {
  const s = e.cloneNode(),
    r = e[Xt];
  (r &&
    r.forEach((l) => {
      l.split(/\s+/).forEach((a) => a && s.classList.remove(a));
    }),
    n.split(/\s+/).forEach((l) => l && s.classList.add(l)),
    (s.style.display = 'none'));
  const i = t.nodeType === 1 ? t : t.parentNode;
  i.appendChild(s);
  const { hasTransform: o } = $l(s);
  return (i.removeChild(s), o);
}
const wt = (e) => {
  const t = e.props['onUpdate:modelValue'] || !1;
  return B(t) ? (n) => Wn(t, n) : t;
};
function Yu(e) {
  e.target.composing = !0;
}
function $i(e) {
  const t = e.target;
  t.composing && ((t.composing = !1), t.dispatchEvent(new Event('input')));
}
const ze = Symbol('_assign'),
  Ni = {
    created(e, { modifiers: { lazy: t, trim: n, number: s } }, r) {
      e[ze] = wt(r);
      const i = s || (r.props && r.props.type === 'number');
      (at(e, t ? 'change' : 'input', (o) => {
        if (o.target.composing) return;
        let l = e.value;
        (n && (l = l.trim()), i && (l = Zn(l)), e[ze](l));
      }),
        n &&
          at(e, 'change', () => {
            e.value = e.value.trim();
          }),
        t || (at(e, 'compositionstart', Yu), at(e, 'compositionend', $i), at(e, 'change', $i)));
    },
    mounted(e, { value: t }) {
      e.value = t ?? '';
    },
    beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: s, trim: r, number: i } }, o) {
      if (((e[ze] = wt(o)), e.composing)) return;
      const l = (i || e.type === 'number') && !/^0\d/.test(e.value) ? Zn(e.value) : e.value,
        a = t ?? '';
      l !== a &&
        ((document.activeElement === e &&
          e.type !== 'range' &&
          ((s && t === n) || (r && e.value.trim() === a))) ||
          (e.value = a));
    }
  },
  ed = {
    deep: !0,
    created(e, t, n) {
      ((e[ze] = wt(n)),
        at(e, 'change', () => {
          const s = e._modelValue,
            r = Zt(e),
            i = e.checked,
            o = e[ze];
          if (B(s)) {
            const l = br(s, r),
              a = l !== -1;
            if (i && !a) o(s.concat(r));
            else if (!i && a) {
              const f = [...s];
              (f.splice(l, 1), o(f));
            }
          } else if (tn(s)) {
            const l = new Set(s);
            (i ? l.add(r) : l.delete(r), o(l));
          } else o(Bl(e, i));
        }));
    },
    mounted: ji,
    beforeUpdate(e, t, n) {
      ((e[ze] = wt(n)), ji(e, t, n));
    }
  };
function ji(e, { value: t, oldValue: n }, s) {
  e._modelValue = t;
  let r;
  if (B(t)) r = br(t, s.props.value) > -1;
  else if (tn(t)) r = t.has(s.props.value);
  else {
    if (t === n) return;
    r = Mt(t, Bl(e, !0));
  }
  e.checked !== r && (e.checked = r);
}
const td = {
    created(e, { value: t }, n) {
      ((e.checked = Mt(t, n.props.value)),
        (e[ze] = wt(n)),
        at(e, 'change', () => {
          e[ze](Zt(e));
        }));
    },
    beforeUpdate(e, { value: t, oldValue: n }, s) {
      ((e[ze] = wt(s)), t !== n && (e.checked = Mt(t, s.props.value)));
    }
  },
  nd = {
    deep: !0,
    created(e, { value: t, modifiers: { number: n } }, s) {
      const r = tn(t);
      (at(e, 'change', () => {
        const i = Array.prototype.filter
          .call(e.options, (o) => o.selected)
          .map((o) => (n ? Zn(Zt(o)) : Zt(o)));
        (e[ze](e.multiple ? (r ? new Set(i) : i) : i[0]),
          (e._assigning = !0),
          Er(() => {
            e._assigning = !1;
          }));
      }),
        (e[ze] = wt(s)));
    },
    mounted(e, { value: t }) {
      Bi(e, t);
    },
    beforeUpdate(e, t, n) {
      e[ze] = wt(n);
    },
    updated(e, { value: t }) {
      e._assigning || Bi(e, t);
    }
  };
function Bi(e, t) {
  const n = e.multiple,
    s = B(t);
  if (!(n && !s && !tn(t))) {
    for (let r = 0, i = e.options.length; r < i; r++) {
      const o = e.options[r],
        l = Zt(o);
      if (n)
        if (s) {
          const a = typeof l;
          a === 'string' || a === 'number'
            ? (o.selected = t.some((f) => String(f) === String(l)))
            : (o.selected = br(t, l) > -1);
        } else o.selected = t.has(l);
      else if (Mt(Zt(o), t)) {
        e.selectedIndex !== r && (e.selectedIndex = r);
        return;
      }
    }
    !n && e.selectedIndex !== -1 && (e.selectedIndex = -1);
  }
}
function Zt(e) {
  return '_value' in e ? e._value : e.value;
}
function Bl(e, t) {
  const n = t ? '_trueValue' : '_falseValue';
  return n in e ? e[n] : t;
}
const sd = {
  created(e, t, n) {
    Un(e, t, n, null, 'created');
  },
  mounted(e, t, n) {
    Un(e, t, n, null, 'mounted');
  },
  beforeUpdate(e, t, n, s) {
    Un(e, t, n, s, 'beforeUpdate');
  },
  updated(e, t, n, s) {
    Un(e, t, n, s, 'updated');
  }
};
function rd(e, t) {
  switch (e) {
    case 'SELECT':
      return nd;
    case 'TEXTAREA':
      return Ni;
    default:
      switch (t) {
        case 'checkbox':
          return ed;
        case 'radio':
          return td;
        default:
          return Ni;
      }
  }
}
function Un(e, t, n, s, r) {
  const o = rd(e.tagName, n.props && n.props.type)[r];
  o && o(e, t, n, s);
}
const id = ['ctrl', 'shift', 'alt', 'meta'],
  od = {
    stop: (e) => e.stopPropagation(),
    prevent: (e) => e.preventDefault(),
    self: (e) => e.target !== e.currentTarget,
    ctrl: (e) => !e.ctrlKey,
    shift: (e) => !e.shiftKey,
    alt: (e) => !e.altKey,
    meta: (e) => !e.metaKey,
    left: (e) => 'button' in e && e.button !== 0,
    middle: (e) => 'button' in e && e.button !== 1,
    right: (e) => 'button' in e && e.button !== 2,
    exact: (e, t) => id.some((n) => e[`${n}Key`] && !t.includes(n))
  },
  ld = (e, t) => {
    const n = e._withMods || (e._withMods = {}),
      s = t.join('.');
    return (
      n[s] ||
      (n[s] = (r, ...i) => {
        for (let o = 0; o < t.length; o++) {
          const l = od[t[o]];
          if (l && l(r, t)) return;
        }
        return e(r, ...i);
      })
    );
  },
  ad = {
    esc: 'escape',
    space: ' ',
    up: 'arrow-up',
    left: 'arrow-left',
    right: 'arrow-right',
    down: 'arrow-down',
    delete: 'backspace'
  },
  cd = (e, t) => {
    const n = e._withKeys || (e._withKeys = {}),
      s = t.join('.');
    return (
      n[s] ||
      (n[s] = (r) => {
        if (!('key' in r)) return;
        const i = xt(r.key);
        if (t.some((o) => o === i || ad[o] === i)) return e(r);
      })
    );
  },
  fd = ge({ patchProp: Hu }, Tu);
let zi;
function ud() {
  return zi || (zi = Xf(fd));
}
const dd = (...e) => {
  const t = ud().createApp(...e),
    { mount: n } = t;
  return (
    (t.mount = (s) => {
      const r = hd(s);
      if (!r) return;
      const i = t._component;
      (!U(i) && !i.render && !i.template && (i.template = r.innerHTML),
        r.nodeType === 1 && (r.textContent = ''));
      const o = n(r, !1, pd(r));
      return (
        r instanceof Element && (r.removeAttribute('v-cloak'), r.setAttribute('data-v-app', '')),
        o
      );
    }),
    t
  );
};
function pd(e) {
  if (e instanceof SVGElement) return 'svg';
  if (typeof MathMLElement == 'function' && e instanceof MathMLElement) return 'mathml';
}
function hd(e) {
  return ue(e) ? document.querySelector(e) : e;
}
/*!
 * pinia v3.0.2
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ let zl;
const Es = (e) => (zl = e),
  Ll = Symbol();
function lr(e) {
  return (
    e &&
    typeof e == 'object' &&
    Object.prototype.toString.call(e) === '[object Object]' &&
    typeof e.toJSON != 'function'
  );
}
var yn;
(function (e) {
  ((e.direct = 'direct'), (e.patchObject = 'patch object'), (e.patchFunction = 'patch function'));
})(yn || (yn = {}));
function md() {
  const e = So(!0),
    t = e.run(() => Te({}));
  let n = [],
    s = [];
  const r = Cr({
    install(i) {
      (Es(r),
        (r._a = i),
        i.provide(Ll, r),
        (i.config.globalProperties.$pinia = r),
        s.forEach((o) => n.push(o)),
        (s = []));
    },
    use(i) {
      return (this._a ? n.push(i) : s.push(i), this);
    },
    _p: n,
    _a: null,
    _e: e,
    _s: new Map(),
    state: t
  });
  return r;
}
const Dl = () => {};
function Li(e, t, n, s = Dl) {
  e.push(t);
  const r = () => {
    const i = e.indexOf(t);
    i > -1 && (e.splice(i, 1), s());
  };
  return (!n && Co() && Nc(r), r);
}
function Ut(e, ...t) {
  e.slice().forEach((n) => {
    n(...t);
  });
}
const gd = (e) => e(),
  Di = Symbol(),
  Us = Symbol();
function ar(e, t) {
  e instanceof Map && t instanceof Map
    ? t.forEach((n, s) => e.set(s, n))
    : e instanceof Set && t instanceof Set && t.forEach(e.add, e);
  for (const n in t) {
    if (!t.hasOwnProperty(n)) continue;
    const s = t[n],
      r = e[n];
    lr(r) && lr(s) && e.hasOwnProperty(n) && !de(s) && !yt(s) ? (e[n] = ar(r, s)) : (e[n] = s);
  }
  return e;
}
const bd = Symbol();
function yd(e) {
  return !lr(e) || !Object.prototype.hasOwnProperty.call(e, bd);
}
const { assign: pt } = Object;
function qd(e) {
  return !!(de(e) && e.effect);
}
function wd(e, t, n, s) {
  const { state: r, actions: i, getters: o } = t,
    l = n.state.value[e];
  let a;
  function f() {
    l || (n.state.value[e] = r ? r() : {});
    const c = af(n.state.value[e]);
    return pt(
      c,
      i,
      Object.keys(o || {}).reduce(
        (u, m) => (
          (u[m] = Cr(
            le(() => {
              Es(n);
              const y = n._s.get(e);
              return o[m].call(y, y);
            })
          )),
          u
        ),
        {}
      )
    );
  }
  return ((a = Ul(e, f, t, n, s, !0)), a);
}
function Ul(e, t, n = {}, s, r, i) {
  let o;
  const l = pt({ actions: {} }, n),
    a = { deep: !0 };
  let f,
    c,
    u = [],
    m = [],
    y;
  const h = s.state.value[e];
  (!i && !h && (s.state.value[e] = {}), Te({}));
  let q;
  function w(I) {
    let x;
    ((f = c = !1),
      typeof I == 'function'
        ? (I(s.state.value[e]), (x = { type: yn.patchFunction, storeId: e, events: y }))
        : (ar(s.state.value[e], I),
          (x = { type: yn.patchObject, payload: I, storeId: e, events: y })));
    const M = (q = Symbol());
    (Er().then(() => {
      q === M && (f = !0);
    }),
      (c = !0),
      Ut(u, x, s.state.value[e]));
  }
  const O = i
    ? function () {
        const { state: x } = n,
          M = x ? x() : {};
        this.$patch((W) => {
          pt(W, M);
        });
      }
    : Dl;
  function $() {
    (o.stop(), (u = []), (m = []), s._s.delete(e));
  }
  const N = (I, x = '') => {
      if (Di in I) return ((I[Us] = x), I);
      const M = function () {
        Es(s);
        const W = Array.from(arguments),
          A = [],
          G = [];
        function se(V) {
          A.push(V);
        }
        function Ae(V) {
          G.push(V);
        }
        Ut(m, { args: W, name: M[Us], store: j, after: se, onError: Ae });
        let J;
        try {
          J = I.apply(this && this.$id === e ? this : j, W);
        } catch (V) {
          throw (Ut(G, V), V);
        }
        return J instanceof Promise
          ? J.then((V) => (Ut(A, V), V)).catch((V) => (Ut(G, V), Promise.reject(V)))
          : (Ut(A, J), J);
      };
      return ((M[Di] = !0), (M[Us] = x), M);
    },
    F = {
      _p: s,
      $id: e,
      $onAction: Li.bind(null, m),
      $patch: w,
      $reset: O,
      $subscribe(I, x = {}) {
        const M = Li(u, I, x.detached, () => W()),
          W = o.run(() =>
            Gt(
              () => s.state.value[e],
              (A) => {
                (x.flush === 'sync' ? c : f) && I({ storeId: e, type: yn.direct, events: y }, A);
              },
              pt({}, a, x)
            )
          );
        return M;
      },
      $dispose: $
    },
    j = qs(F);
  s._s.set(e, j);
  const K = ((s._a && s._a.runWithContext) || gd)(() =>
    s._e.run(() => (o = So()).run(() => t({ action: N })))
  );
  for (const I in K) {
    const x = K[I];
    if ((de(x) && !qd(x)) || yt(x))
      i || (h && yd(x) && (de(x) ? (x.value = h[I]) : ar(x, h[I])), (s.state.value[e][I] = x));
    else if (typeof x == 'function') {
      const M = N(x, I);
      ((K[I] = M), (l.actions[I] = x));
    }
  }
  return (
    pt(j, K),
    pt(Y(j), K),
    Object.defineProperty(j, '$state', {
      get: () => s.state.value[e],
      set: (I) => {
        w((x) => {
          pt(x, I);
        });
      }
    }),
    s._p.forEach((I) => {
      pt(
        j,
        o.run(() => I({ store: j, app: s._a, pinia: s, options: l }))
      );
    }),
    h && i && n.hydrate && n.hydrate(j.$state, h),
    (f = !0),
    (c = !0),
    j
  );
}
/*! #__NO_SIDE_EFFECTS__ */ function xd(e, t, n) {
  let s;
  const r = typeof t == 'function';
  s = r ? n : t;
  function i(o, l) {
    const a = Hf();
    return (
      (o = o || (a ? gn(Ll, null) : null)),
      o && Es(o),
      (o = zl),
      o._s.has(e) || (r ? Ul(e, t, s, o) : wd(e, s, o)),
      o._s.get(e)
    );
  }
  return ((i.$id = e), i);
}
const vd = (e, t) => {
    const n = e.__vccOpts || e;
    for (const [s, r] of t) n[s] = r;
    return n;
  },
  _d = {},
  Sd = {
    class:
      'qlfqa:!min-h-screen qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center qlfqa:sm:!pt-0 qlfqa:!bg-[#F6F4F2]'
  },
  Cd = {
    class:
      'qlfqa:!w-full qlfqa:sm:!max-w-md qlfqa:!mt-4 qlfqa:!px-6 qlfqa:!bg-[#F6F4F2] qlfqa:!overflow-hidden'
  };
function Ed(e, t) {
  return (
    Q(),
    ee('div', Sd, [
      R('div', Cd, [
        t[0] ||
          (t[0] = R(
            'div',
            { class: 'qlfqa:!mb-4 qlfqa:!flex qlfqa:!justify-center' },
            [
              R('img', {
                src: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/logo.png?v=1753083867',
                alt: 'Logo',
                style: { width: '50px !important', height: '50px !important' }
              })
            ],
            -1
          )),
        rl(e.$slots, 'default')
      ]),
      t[1] ||
        (t[1] = R(
          'footer',
          {
            class:
              'qlfqa:!mx-auto qlfqa:!w-full qlfqa:sm:!max-w-md qlfqa:!px-6 qlfqa:!pt-6 qlfqa:!pb-5 qlfqa:!text-center qlfqa:!text-xs qlfqa:!text-gray-400'
          },
          [
            R(
              'a',
              {
                href: '/pages/impressum',
                target: '_blank',
                class: 'qlfqa:!text-gray-400 qlfqa:hover:!text-gray-500'
              },
              'Impressum'
            ),
            R('span', { class: 'qlfqa:!mx-2' }, '|'),
            R(
              'a',
              {
                href: '/pages/datenschutz',
                target: '_blank',
                class: 'qlfqa:!text-gray-400 qlfqa:hover:!text-gray-500'
              },
              'Datenschutz'
            )
          ],
          -1
        ))
    ])
  );
}
const Td = vd(_d, [['render', Ed]]),
  jt = xd('quiz', {
    state: () => ({
      age: '',
      gender: 'w',
      q02: '',
      q03: '',
      q04: '',
      q05: '',
      q06: ['Bauch', 'Beine', 'Po'],
      q07: 'Moderat',
      q08: '',
      q09: '',
      q10: '',
      q11: '',
      q12: '',
      q13: '',
      q14: '',
      q15: '',
      q16: '',
      q17: '',
      q18: '1.55,Moderat',
      q19: '',
      q20: '',
      q21: '',
      q22: '',
      q23: '',
      q24: '',
      q25: '',
      q26: '',
      q27: '',
      q28: '',
      q29: '',
      q30: '',
      q31: '',
      q32: '',
      currentScreen: 'QuizScreen01',
      screenHistory: [],
      quizCompleted: !1,
      results: null
    }),
    getters: {
      currentQuestion() {
        if (!this.gender) return null;
        const e = this.gender === 'male' ? this.maleQuestions : this.femaleQuestions;
        if (this.currentQuestionIndex < e.length) return e[this.currentQuestionIndex];
        {
          const t = this.currentQuestionIndex - e.length;
          return t < this.commonQuestions.length ? this.commonQuestions[t] : null;
        }
      },
      isFinished() {
        if (!this.gender) return !1;
        const e = this.gender === 'male' ? this.maleQuestions : this.femaleQuestions;
        return this.currentQuestionIndex >= e.length + this.commonQuestions.length;
      }
    },
    actions: {
      saveCurrentScreenData(e) {
        if (
          this.currentScreen === 'QuizScreen09' &&
          e &&
          typeof e == 'object' &&
          !Array.isArray(e)
        ) {
          ((this.q09 = e.q09 ?? this.q09),
            (this.q10 = e.q10 ?? this.q10),
            (this.q11 = e.q11 ?? this.q11));
          return;
        }
        const t = this.getDataPropertyForScreen(this.currentScreen);
        t && (this[t] = e);
      },
      goToNextScreen(e = null) {
        (e != null && this.saveCurrentScreenData(e),
          this.screenHistory.push(this.currentScreen),
          (this.currentScreen = this.getNextScreen()));
      },
      goBack() {
        this.screenHistory.length > 0 && (this.currentScreen = this.screenHistory.pop());
      },
      getNextScreen() {
        const t = {
          QuizScreen01: 'QuizScreen02',
          QuizScreen02: 'QuizScreen03',
          QuizScreen03: 'QuizScreen04',
          QuizScreen04: 'QuizScreen12',
          QuizScreen12: 'QuizScreen09',
          QuizScreen09: 'QuizScreen32'
        }[this.currentScreen];
        return typeof t == 'function' ? t() : t;
      },
      getDataPropertyForScreen(e) {
        return (
          {
            QuizScreen01: 'age',
            QuizScreen02: 'q02',
            QuizScreen03: 'q03',
            QuizScreen04: 'q04',
            QuizScreen09: 'q09',
            QuizScreen12: 'q12',
            QuizScreen32: 'q32'
          }[e] || null
        );
      },
      resetQuiz() {
        this.$reset();
      },
      completeQuiz() {
        ((this.quizCompleted = !0), this.calculateResults());
      },
      calculateResults() {
        const e = (n) => Math.round(n * 100) / 100,
          t = this.gender;
        if (t === 'm') {
          const s =
              (88.362 +
                13.397 * parseInt(this.q10) +
                4.799 * parseInt(this.q11) -
                5.677 * parseInt(this.q09)) *
              parseFloat(this.q18.split(',')[0]),
            r = e(s) - 200,
            i = (parseInt(this.q11) - 80) * 2,
            o = (r * 0.25) / 9,
            l = (r - 50 - i * 4 - o * 9) / 4;
          this.results = {
            gender: t,
            calorieIntake: e(s),
            calorieIntakeRange: [e(s) - 500, e(r)],
            proteinIntake: e(i),
            fatIntake: e(o),
            carbohydrates: e(l),
            caloriesMax: e(r)
          };
        } else {
          const s =
              (444.593 +
                9.247 * parseInt(this.q10) +
                3.098 * parseInt(this.q11) -
                4.33 * parseInt(this.q09)) *
              parseFloat(this.q18.split(',')[0]),
            r = e(s) - 200,
            i = (parseInt(this.q11) - 105) * 2,
            o = (r * 0.3) / 9,
            l = (r - 50 - i * 4 - o * 9) / 4;
          this.results = {
            gender: t,
            calorieIntake: e(s),
            calorieIntakeRange: [e(s) - 500, e(r)],
            proteinIntake: e(i),
            fatIntake: e(o),
            carbohydrates: e(l),
            caloriesMax: e(r)
          };
        }
      }
    }
  }),
  Fd = { class: 'qlfqa:!mb-5', 'aria-label': 'Quiz-Fortschritt' },
  Ad = { class: 'qlfqa:!flex qlfqa:!items-start' },
  kd = { class: 'qlfqa:!flex qlfqa:!min-w-0 qlfqa:!flex-col qlfqa:!items-center qlfqa:!gap-1.5' },
  Rd = { key: 0 },
  Od = { key: 1 },
  Pd = {
    key: 0,
    class:
      'qlfqa:!mx-1.5 qlfqa:!mt-3 qlfqa:!h-[2px] qlfqa:!flex-1 qlfqa:!rounded-full qlfqa:!bg-[#d8d8dc]'
  },
  Id = De({
    __name: 'LoadingBar',
    props: { currentScreen: {}, steps: {} },
    setup(e) {
      const t = [
          { label: 'Motivation', screens: [] },
          { label: 'Phase', screens: ['QuizScreen02'] },
          { label: 'Ziel', screens: ['QuizScreen03', 'QuizScreen04', 'QuizScreen05'] },
          { label: 'Attribute', screens: ['QuizScreen09', 'QuizScreen32'] }
        ],
        n = e,
        s = le(() => (n.steps && n.steps.length > 0 ? n.steps : t)),
        r = le(() => {
          const f = s.value.findIndex((u) => u.screens.includes(n.currentScreen));
          if (f !== -1) return f;
          const c = s.value.findIndex((u) => u.screens.length > 0);
          return c === -1 ? 0 : c;
        }),
        i = le(() =>
          s.value.map((f, c) => ({
            ...f,
            state: c < r.value ? 'completed' : c === r.value ? 'current' : 'upcoming'
          }))
        );
      function o(f) {
        return f < r.value ? 100 : 0;
      }
      function l(f) {
        return f === 'completed'
          ? 'qlfqa:!border-[#fdd539] qlfqa:!bg-[#fdd539] qlfqa:!text-[#1f1f1f]'
          : f === 'current'
            ? 'qlfqa:!border-[#1f1f1f] qlfqa:!bg-[#1f1f1f] qlfqa:!text-white'
            : 'qlfqa:!border-[#d1d5db] qlfqa:!bg-white qlfqa:!text-[#9ca3af]';
      }
      function a(f) {
        return f === 'upcoming' ? 'qlfqa:!text-[#9ca3af]' : 'qlfqa:!text-[#1f1f1f]';
      }
      return (f, c) => (
        Q(),
        ee('div', Fd, [
          R('div', Ad, [
            (Q(!0),
            ee(
              he,
              null,
              In(
                i.value,
                (u, m) => (
                  Q(),
                  ee(
                    he,
                    { key: u.label },
                    [
                      R('div', kd, [
                        R(
                          'div',
                          {
                            class: Pe([
                              'qlfqa:!flex qlfqa:!h-6 qlfqa:!w-6 qlfqa:!items-center qlfqa:!justify-center qlfqa:!rounded-full qlfqa:!border qlfqa:!text-[0.7rem] qlfqa:!font-semibold qlfqa:!transition-all qlfqa:!duration-300',
                              l(u.state)
                            ])
                          },
                          [
                            u.state === 'completed'
                              ? (Q(), ee('span', Rd, '✓'))
                              : (Q(), ee('span', Od, qe(m + 1), 1))
                          ],
                          2
                        ),
                        R(
                          'span',
                          {
                            class: Pe([
                              'qlfqa:!text-center qlfqa:!text-[0.63rem] qlfqa:!font-medium qlfqa:!leading-3.5 qlfqa:!transition-colors qlfqa:!duration-300',
                              a(u.state)
                            ])
                          },
                          qe(u.label),
                          3
                        )
                      ]),
                      m < i.value.length - 1
                        ? (Q(),
                          ee('div', Pd, [
                            R(
                              'div',
                              {
                                class:
                                  'qlfqa:!h-full qlfqa:!rounded-full qlfqa:!bg-[#fdd539] qlfqa:!transition-all qlfqa:!duration-300',
                                style: nn({ width: `${o(m)}%` })
                              },
                              null,
                              4
                            )
                          ]))
                        : He('', !0)
                    ],
                    64
                  )
                )
              ),
              128
            ))
          ])
        ])
      );
    }
  }),
  cr = 280,
  Hl = [200, 280, 320, 480],
  Ui = [40, 50, 60, 80, 100, 120, 150, 160, 200, 220, 280, 320, 400, 420, 480, 520, 560, 640, 720],
  Ql = (e = cr) => {
    const t = Number(e);
    if (!Number.isFinite(t) || t <= 0) return cr;
    let n = Ui[0];
    for (const s of Ui) {
      if (s > t) break;
      n = s;
    }
    return n;
  },
  Md = (e = Hl) =>
    [...new Set(e.map((t) => Ql(t)).filter((t) => Number.isFinite(t) && t > 0))].sort(
      (t, n) => t - n
    ),
  Vl = (e = '') => {
    if (!e) return '';
    const t = e.indexOf('#'),
      n = t >= 0 ? e.slice(t) : '',
      s = t >= 0 ? e.slice(0, t) : e,
      [r, ...i] = s.split('?'),
      o = i.filter(Boolean).join('&');
    return o ? `${r}?${o}${n}` : `${r}${n}`;
  },
  Ts = (e, { width: t = cr, format: n = 'webp' } = {}) => {
    if (!e) return '';
    const s = Vl(e),
      r = s.indexOf('#'),
      i = r >= 0 ? s.slice(r) : '',
      o = r >= 0 ? s.slice(0, r) : s,
      [l, a = ''] = o.split('?'),
      f = new URLSearchParams(a);
    n ? f.set('format', n) : f.delete('format');
    const c = t ? Ql(t) : void 0;
    c ? f.set('width', String(c)) : f.delete('width');
    const u = f.toString();
    return u ? `${l}?${u}${i}` : `${l}${i}`;
  },
  Wl = (e, t = Hl, n = 'webp') =>
    Md(t)
      .map((s) => `${Ts(e, { width: s, format: n })} ${s}w`)
      .join(', '),
  $d = (e) => Ts(e, { width: 150 }),
  Nd = () => ({
    buildImageUrl: Ts,
    generateSrcSetImages: Wl,
    convertImageUrlTo150: $d,
    normalizeImageUrl: Vl
  }),
  jd = ['src', 'srcset', 'sizes', 'alt', 'aria-hidden', 'loading', 'decoding', 'fetchpriority'],
  Pr = {
    __name: 'Image',
    props: {
      src: { type: String, required: !0 },
      alt: { type: String, default: '' },
      sizes: { type: String, default: '(max-width: 640px) 50vw, 220px' },
      imageWidth: { type: [Number, String], default: null },
      srcsetWidths: { type: Array, default: () => [200, 280, 320] },
      format: { type: String, default: 'webp' },
      loading: { type: String, default: 'lazy' },
      decoding: { type: String, default: 'async' },
      fetchpriority: { type: String, default: 'auto' },
      isPriority: { type: Boolean, default: !1 },
      class: { type: [String, Array, Object], default: 'qlfqa:!w-full qlfqa:!h-auto' }
    },
    setup(e) {
      const { buildImageUrl: t, generateSrcSetImages: n } = Nd(),
        s = ol(),
        r = e,
        i = le(() => r.class),
        o = le(() => {
          const f = Number(r.imageWidth);
          if (Number.isFinite(f) && f > 0) return f;
          const c = Number(s.width);
          return Number.isFinite(c) && c > 0 ? c : 280;
        }),
        l = le(() => t(r.src, { width: o.value, format: r.format })),
        a = le(() => n(r.src, r.srcsetWidths, r.format));
      return (f, c) =>
        e.src
          ? (Q(),
            ee(
              'img',
              {
                key: 0,
                src: l.value,
                srcset: a.value,
                sizes: e.sizes,
                alt: e.alt,
                class: Pe(i.value),
                'aria-hidden': e.alt === '',
                loading: e.isPriority ? 'eager' : e.loading,
                decoding: e.decoding,
                fetchpriority: e.isPriority ? 'high' : e.fetchpriority,
                role: 'img'
              },
              null,
              10,
              jd
            ))
          : He('', !0);
    }
  },
  Bd = ['disabled'],
  Ir = {
    __name: 'ImageButton',
    props: {
      text: { type: String, default: 'Weiter' },
      disabled: { type: Boolean, default: !1 },
      variant: { type: String, default: 'primary' },
      customClass: { type: String, default: '' }
    },
    emits: ['click'],
    setup(e, { emit: t }) {
      const n = e,
        s = t,
        r = le(() => {
          const o = 'qlfqa:!px-2 qlfqa:!py-2',
            l = { primary: 'qlfqa:hover:!cursor-pointer qlfqa:!text-white' };
          return `${o} ${l[n.variant] || l.primary} ${n.customClass}`;
        }),
        i = (o) => {
          s('click', o);
        };
      return (o, l) => (
        Q(),
        ee(
          'button',
          { onClick: i, disabled: e.disabled, class: Pe(r.value) },
          [rl(o.$slots, 'default', {}, () => [is(qe(e.text), 1)])],
          10,
          Bd
        )
      );
    }
  },
  Hi = new Set(),
  as = {
    selectionGrid: {
      width: 280,
      srcsetWidths: [200, 280, 320],
      sizes: '(max-width: 640px) 50vw, 220px'
    },
    multiSelectionThumb: { width: 60, srcsetWidths: [40, 60, 80], sizes: '60px' }
  };
function zd(e) {
  var r;
  if (!e) return;
  if (typeof e == 'string') return { href: e, key: e };
  if (!e.src) return;
  const t = Ts(e.src, { width: e.width, format: e.format }),
    n = (r = e.srcsetWidths) != null && r.length ? Wl(e.src, e.srcsetWidths, e.format) : void 0,
    s = n ? e.sizes : void 0;
  return { href: t, key: [t, n ?? '', s ?? ''].join('|'), srcset: n, sizes: s };
}
function Ld() {
  const e = document.createElement('link');
  return 'imageSrcset' in e && 'imageSizes' in e;
}
function Dd(e) {
  if (!document.head) return !1;
  const t = document.createElement('link');
  return (
    (t.rel = 'preload'),
    (t.as = 'image'),
    (t.href = e.href),
    e.srcset &&
      e.sizes &&
      ((t.imageSrcset = e.srcset),
      (t.imageSizes = e.sizes),
      t.setAttribute('imagesrcset', e.srcset),
      t.setAttribute('imagesizes', e.sizes)),
    document.head.appendChild(t),
    !0
  );
}
function Ud(e) {
  const t = zd(e);
  return !t || Hi.has(t.key) || (Hi.add(t.key), t.srcset && t.sizes && Ld() && Dd(t))
    ? Promise.resolve()
    : new Promise((n) => {
        const s = new window.Image();
        ((s.decoding = 'async'),
          t.srcset && (s.srcset = t.srcset),
          t.sizes && (s.sizes = t.sizes),
          (s.onload = async () => {
            try {
              await s.decode();
            } catch {}
            n();
          }),
          (s.onerror = () => n()),
          (s.src = t.href));
      });
}
function qn(e) {
  for (const t of e) Ud(t);
}
const Hd = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'age-title' },
  Qd = {
    class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
    role: 'radiogroup',
    'aria-label': 'Wähle deine Altersgruppe'
  },
  Vd = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
  Wd = De({
    __name: 'QuizScreen01',
    emits: ['next'],
    setup(e, { emit: t }) {
      const n = t,
        s = Te([]),
        r = [
          {
            id: 1,
            text: '40-44',
            val: '5',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage1-Alter-Frau-40-44.jpg?v=1771919061',
            altText: ''
          },
          {
            id: 2,
            text: '45-49',
            val: '0',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage1-Alter-Frau-45-49.jpg?v=1771919061',
            altText: ''
          },
          {
            id: 3,
            text: '50-54',
            val: '0',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage1-Alter-Frau-50-54.png?v=1771919524',
            altText: ''
          },
          {
            id: 4,
            text: '55+',
            val: '10',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage1-Alter-Frau-55plus.jpg?v=1771919060',
            altText: ''
          }
        ],
        i = {
          '18-29': [
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-18bis29.jpg?format=webp',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-18bis29.jpg?format=webp'
          ],
          '30-44': [
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-30bis44.jpg?format=webp',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-30bis44.jpg?format=webp'
          ],
          '45-59': [
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-45bis59.jpg?format=webp',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-45bis59.jpg?format=webp'
          ],
          '60+': [
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-ab60.jpg?format=webp',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-ab60.jpg?format=webp'
          ]
        };
      function o(u) {
        const y = (i[u] ?? []).map((h) => ({ src: h, ...as.selectionGrid }));
        qn(y);
      }
      function l() {
        const u = r[0].text;
        o(u);
      }
      Pn(() => {
        (l(), f());
      });
      const a = [
        'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-Schlank.jpg?format=webp',
        'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau_Skinny-fat.jpg?format=webp',
        'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-schlank.jpg?format=webp',
        'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-skinnyfat.jpg?format=webp'
      ];
      function f() {
        qn(a.map((u) => ({ src: u, ...as.selectionGrid })));
      }
      function c(u, m) {
        s.value = [u, m];
        const h = { '40-44': '40bis44', '45-49': '45bis49', '50-54': '50bis54', '55+': '55plus' }[
          u
        ];
        if (h) {
          const w = ['schlank', 'skinnyfat', 'uebergewichtig', 'adipoes'].map((O) => {
            let $ = 'jpg';
            return (
              O === 'skinnyfat' && h === '40bis44' && ($ = 'png'),
              `https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage3-Frau-${O}-${h}.${$}`
            );
          });
          qn(w);
        }
        (o(u), n('next', u));
      }
      return (u, m) => (
        Q(),
        ee('div', Hd, [
          m[0] ||
            (m[0] = R(
              'h1',
              {
                id: 'age-title',
                class: 'qlfqa:!text-2xl qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center'
              },
              'Bauchfett verlieren für Frauen ab 40+',
              -1
            )),
          m[1] ||
            (m[1] = R(
              'p',
              { class: 'qlfqa:!mb-4 qlfqa:!text-center qlfqa:!text-gray-700' },
              ' Erfahre den einfachsten Weg zum Abnehmen für deinen Körpertypen und deine Voraussetzung. ',
              -1
            )),
          R('div', Qd, [
            (Q(),
            ee(
              he,
              null,
              In(r, (y) =>
                ne(
                  Ir,
                  {
                    class: Pe([
                      'qlfqa:!w-6/12 qlfqa:!flex',
                      { 'qlfqa:!border-2 qlfqa:!border-[#FED43CFF]': s.value[1] === y.val }
                    ]),
                    key: y.id,
                    onPointerenter: (h) => o(y.text),
                    onPointerdown: (h) => o(y.text),
                    onClick: (h) => c(y.text, y.val),
                    role: 'radio',
                    'aria-checked': s.value[1] === y.val,
                    'aria-label': 'Altersgruppe ' + y.text
                  },
                  {
                    default: St(() => [
                      R('span', Vd, [
                        ne(
                          Pr,
                          {
                            src: y.image,
                            alt: 'Person in Altersgruppe ' + y.text,
                            sizes: '(max-width: 640px) 50vw, 220px',
                            'is-priority': y.id <= 2,
                            class: 'qlfqa:!w-full qlfqa:!h-auto'
                          },
                          null,
                          8,
                          ['src', 'alt', 'is-priority']
                        )
                      ])
                    ]),
                    _: 2
                  },
                  1032,
                  [
                    'class',
                    'onPointerenter',
                    'onPointerdown',
                    'onClick',
                    'aria-checked',
                    'aria-label'
                  ]
                )
              ),
              64
            ))
          ])
        ])
      );
    }
  }),
  Kd = { class: 'qlfqa:!mt-5 qlfqa:!flex qlfqa:!gap-4' },
  Gd = ['disabled'],
  Jd = ['disabled'],
  Mr = De({
    __name: 'NavigationButtons',
    props: {
      showBackButton: { type: Boolean, default: !0 },
      disableContinue: { type: Boolean, default: !1 },
      hideContinue: { type: Boolean, default: !1 },
      backText: { type: String, default: 'Zurück' },
      continueText: { type: String, default: 'Weiter' }
    },
    emits: ['back', 'continue'],
    setup(e, { emit: t }) {
      const n = e,
        s = t,
        r = (i) => {
          i.key === 'Enter' && !n.disableContinue && !n.hideContinue && s('continue');
        };
      return (
        Pn(() => {
          window.addEventListener('keydown', r);
        }),
        Ar(() => {
          window.removeEventListener('keydown', r);
        }),
        (i, o) => (
          Q(),
          ee('div', Kd, [
            e.hideContinue
              ? He('', !0)
              : (Q(),
                ee(
                  'button',
                  {
                    key: 0,
                    onClick: o[0] || (o[0] = (l) => i.$emit('back')),
                    disabled: !e.showBackButton,
                    class:
                      'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                  },
                  qe(e.backText),
                  9,
                  Gd
                )),
            e.hideContinue
              ? He('', !0)
              : (Q(),
                ee(
                  'button',
                  {
                    key: 1,
                    onClick: o[1] || (o[1] = (l) => i.$emit('continue')),
                    disabled: e.disableContinue,
                    class:
                      'qlfqa:!bg-custom-yellow qlfqa:!text-[#131313] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2 qlfqa:!font-medium'
                  },
                  qe(e.continueText),
                  9,
                  Jd
                ))
          ])
        )
      );
    }
  }),
  Xd = ['onClick', 'onKeydown', 'aria-checked', 'aria-label', 'aria-description'],
  Zd = ['onMouseenter'],
  Yd = { class: 'qlfqa:!flex qlfqa:!flex-1' },
  ep = { class: 'qlfqa:!flex qlfqa:!items-center' },
  tp = { class: 'qlfqa:!block qlfqa:!text-sm qlfqa:!font-medium qlfqa:!text-gray-900' },
  np = {
    key: 0,
    class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300'
  },
  Kl = {
    __name: 'SelectionGroup',
    props: {
      modelValue: { type: [String, Number], default: null },
      options: { type: Array, default: null }
    },
    emits: ['update:modelValue'],
    setup(e, { emit: t }) {
      const n = e,
        s = t,
        r = Te(n.modelValue),
        i = Te(null);
      (Gt(
        () => n.modelValue,
        (l) => {
          r.value = l;
        }
      ),
        Gt(r, (l) => {
          s('update:modelValue', l);
        }));
      function o(l) {
        r.value = l;
      }
      return (l, a) => (
        Q(),
        ct(
          Ku,
          {
            tag: 'div',
            name: 'stagger-fade',
            appearance: '',
            class:
              'qlfqa:!mt-2 qlfqa:!grid qlfqa:!grid-cols-1 qlfqa:!gap-y-3 qlfqa:sm:!gap-x-4 qlfqa:!w-full'
          },
          {
            default: St(() => [
              (Q(!0),
              ee(
                he,
                null,
                In(
                  e.options,
                  (f, c) => (
                    Q(),
                    ee(
                      'div',
                      {
                        key: f.id,
                        style: nn({
                          '--stagger-delay': `${c * 100}ms`,
                          'animation-delay': `${c * 100}ms`
                        }),
                        class: 'qlfqa:!flex-1 answer-item',
                        onClick: (u) => o(f.val),
                        onKeydown: cd(
                          ld((u) => o(f.val), ['prevent']),
                          ['space']
                        ),
                        tabindex: '0',
                        role: 'radio',
                        'aria-checked': r.value === f.val,
                        'aria-label': f.text,
                        'aria-description': `Select ${f.text}`
                      },
                      [
                        R(
                          'div',
                          {
                            class: Pe([
                              r.value === f.val
                                ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                                : 'qlfqa:!border-gray-300',
                              i.value === f.val
                                ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                                : '',
                              'qlfqa:!relative qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!h-14 qlfqa:!border qlfqa:!bg-white qlfqa:!p-4 qlfqa:!shadow-md qlfqa:focus:!outline-none'
                            ]),
                            onMouseenter: (u) => (i.value = f.val),
                            onMouseleave: a[0] || (a[0] = (u) => (i.value = null))
                          },
                          [
                            R('span', Yd, [R('span', ep, [R('span', tp, qe(f.text), 1)])]),
                            r.value === f.val
                              ? (Q(),
                                ee(
                                  'span',
                                  np,
                                  a[1] ||
                                    (a[1] = [
                                      R(
                                        'svg',
                                        {
                                          xmlns: 'http://www.w3.org/2000/svg',
                                          viewBox: '0 0 24 24',
                                          fill: 'currentColor',
                                          class: 'qlfqa:!size-5'
                                        },
                                        [
                                          R('path', {
                                            'fill-rule': 'evenodd',
                                            d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                            'clip-rule': 'evenodd'
                                          })
                                        ],
                                        -1
                                      )
                                    ])
                                ))
                              : He('', !0),
                            R(
                              'span',
                              {
                                class: Pe([
                                  i.value === f.val ? 'qlfqa:!border' : 'qlfqa:!border-2',
                                  r.value === f.val
                                    ? 'qlfqa:!border-yellow-300'
                                    : 'qlfqa:!border-transparent',
                                  'qlfqa:!pointer-events-none qlfqa:!absolute qlfqa:!-inset-px qlfqa:!rounded-lg'
                                ]),
                                'aria-hidden': 'true'
                              },
                              null,
                              2
                            )
                          ],
                          42,
                          Zd
                        )
                      ],
                      44,
                      Xd
                    )
                  )
                ),
                128
              ))
            ]),
            _: 1
          }
        )
      );
    }
  },
  sp = { class: 'qlfqa:!py-2' },
  rp = { class: 'qlfqa:!flex' },
  ip = De({
    __name: 'QuizScreen02',
    emits: ['next'],
    setup(e, { emit: t }) {
      const n = t,
        s = jt(),
        r = Te(''),
        i = [
          { id: 1, text: 'Ja, mitten in der Menopause', val: '0' },
          { id: 1, text: 'Kurz davor (Prä-Menopause)', val: '2' },
          { id: 2, text: 'Schon durch die Menopause (Post-Menopause)', val: '30' },
          { id: 3, text: 'Noch nicht', val: '40' }
        ],
        o = le(() => s.screenHistory.length > 0);
      function l() {
        n('next', r.value);
      }
      function a() {
        s.goBack();
      }
      return (f, c) => (
        Q(),
        ee('div', sp, [
          c[1] ||
            (c[1] = R(
              'h2',
              { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
              'Bist du aktuell in den Wechseljahren?',
              -1
            )),
          R('div', rp, [
            ne(
              Kl,
              {
                class: 'qlfqa:!flex',
                options: i,
                modelValue: r.value,
                'onUpdate:modelValue': c[0] || (c[0] = (u) => (r.value = u))
              },
              null,
              8,
              ['modelValue']
            )
          ]),
          ne(
            Mr,
            { showBackButton: o.value, disableContinue: !r.value, onBack: a, onContinue: l },
            null,
            8,
            ['showBackButton', 'disableContinue']
          )
        ])
      );
    }
  }),
  op = { class: 'qlfqa:!py-2' },
  lp = { class: 'qlfqa:!flex' },
  ap = De({
    __name: 'QuizScreen03',
    emits: ['next'],
    setup(e, { emit: t }) {
      const n = t,
        s = jt(),
        r = Te(''),
        i = [
          { id: 1, text: 'Langfristig 1-10 kg abnehmen', val: '0' },
          { id: 2, text: 'Langfristig 11-20 kg abnehmen', val: '30' },
          { id: 3, text: 'Langfristig mehr als 20 kg abnehmen', val: '40' },
          { id: 4, text: 'Mein Gewicht halten und gesünder leben', val: '-5' }
        ],
        o = le(() => s.screenHistory.length > 0);
      function l() {
        n('next', r.value);
      }
      function a() {
        s.goBack();
      }
      return (f, c) => (
        Q(),
        ee('div', op, [
          c[1] ||
            (c[1] = R(
              'h2',
              { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
              'Was ist dein aktuelles Ziel?',
              -1
            )),
          R('div', lp, [
            ne(
              Kl,
              {
                class: 'qlfqa:!flex',
                options: i,
                modelValue: r.value,
                'onUpdate:modelValue': c[0] || (c[0] = (u) => (r.value = u))
              },
              null,
              8,
              ['modelValue']
            )
          ]),
          ne(
            Mr,
            { showBackButton: o.value, disableContinue: !r.value, onBack: a, onContinue: l },
            null,
            8,
            ['showBackButton', 'disableContinue']
          )
        ])
      );
    }
  }),
  cp = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'age-title' },
  fp = {
    class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
    role: 'radiogroup',
    'aria-label': 'Wähle deinen Körpertyp'
  },
  up = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
  dp = { class: 'qlfqa:!mt-5 qlfqa:!flex qlfqa:!justify-center' },
  pp = ['disabled'],
  hp = De({
    __name: 'QuizScreen04',
    emits: ['next'],
    setup(e, { emit: t }) {
      const n = t,
        s = jt(),
        r = Te(''),
        i = {
          w: [
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-schlank.jpg?format=webp',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-definiert.jpg?format=webp',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Fra-kurvig-sportlich.jpg?format=webp',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-normal.jpg?format=webp'
          ],
          m: [
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-schlank.jpg?format=webp',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-definiert.jpg?format=webp',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-sportlich.jpg?format=webp',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-normal.jpg?format=webp'
          ]
        };
      let o = !1;
      function l() {
        if (o) return;
        o = !0;
        const y = s.gender;
        if (!y) return;
        const q = (i[y] ?? []).map((w) => ({ src: w, ...as.selectionGrid }));
        qn(q);
      }
      const a = [
          {
            id: 1,
            text: 'schlank',
            gender: 'w',
            val: '1',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-Schlank.jpg?format=webp',
            altText: ''
          },
          {
            id: 2,
            text: 'skinnyfat',
            gender: 'w',
            val: '2',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau_Skinny-fat.jpg?format=webp',
            altText: ''
          },
          {
            id: 3,
            text: 'uebergewichtig',
            gender: 'w',
            val: '3',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-uebergewichtig.jpg?format=webp',
            altText: ''
          },
          {
            id: 4,
            text: 'adipoes',
            gender: 'w',
            val: '4',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-adipoes.jpg?format=webp',
            altText: ''
          },
          {
            id: 5,
            text: 'schlank',
            gender: 'm',
            val: '1',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-schlank.jpg?format=webp',
            altText: ''
          },
          {
            id: 6,
            text: 'skinnyfat',
            gender: 'm',
            val: '2',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-skinnyfat.jpg?format=webp',
            altText: ''
          },
          {
            id: 7,
            text: 'uebergewichtig',
            gender: 'm',
            val: '3',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-uebergewicht.jpg?format=webp',
            altText: ''
          },
          {
            id: 8,
            text: 'adipoes',
            gender: 'm',
            val: '4',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Mann-adipoes.jpg?format=webp',
            altText: ''
          }
        ],
        f = le(() => {
          const y = s.gender,
            h = s.age;
          return a
            .filter((q) => q.gender === y)
            .map((q) => {
              let w = q.image;
              if (y === 'w') {
                const $ =
                    { '40-44': '40bis44', '45-49': '45bis49', '50-54': '50bis54', '55+': '55plus' }[
                      h
                    ] || '40bis44',
                  F = {
                    schlank: 'schlank',
                    skinnyfat: 'skinnyfat',
                    uebergewichtig: 'uebergewichtig',
                    adipoes: 'adipoes'
                  }[q.text];
                if (F) {
                  let j = 'jpg';
                  (F === 'skinnyfat' && $ === '40bis44' && (j = 'png'),
                    (w = `https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage3-Frau-${F}-${$}.${j}?v=1771919604`));
                }
              }
              return { ...q, image: w };
            });
        }),
        c = le(() => s.screenHistory.length > 0);
      function u(y) {
        ((r.value = y), l(), r.value && n('next', r.value));
      }
      function m() {
        s.goBack();
      }
      return (y, h) => (
        Q(),
        ee('div', cp, [
          h[2] ||
            (h[2] = R(
              'h2',
              { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
              'Welcher Körpertyp trifft auf dich zu?',
              -1
            )),
          R('div', fp, [
            (Q(!0),
            ee(
              he,
              null,
              In(
                f.value,
                (q) => (
                  Q(),
                  ct(
                    Ir,
                    {
                      class: 'qlfqa:!w-6/12 qlfqa:!flex',
                      key: q.id,
                      onPointerenter: h[0] || (h[0] = (w) => l()),
                      onPointerdown: h[1] || (h[1] = (w) => l()),
                      onClick: (w) => u(q.val),
                      role: 'radio',
                      'aria-checked': r.value === q.val,
                      alt: 'Körpertyp ' + q.text
                    },
                    {
                      default: St(() => [
                        R('span', up, [
                          ne(
                            Pr,
                            {
                              src: q.image,
                              alt: 'Person in Altersgruppe ' + q.text,
                              class: 'qlfqa:!w-full qlfqa:!h-auto',
                              sizes: '(max-width: 640px) 50vw, 220px',
                              'is-priority': f.value.indexOf(q) < 2
                            },
                            null,
                            8,
                            ['src', 'alt', 'is-priority']
                          )
                        ])
                      ]),
                      _: 2
                    },
                    1032,
                    ['onClick', 'aria-checked', 'alt']
                  )
                )
              ),
              128
            ))
          ]),
          R('div', dp, [
            R(
              'button',
              {
                onClick: m,
                disabled: !c.value,
                class:
                  'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
              },
              ' Zurück ',
              8,
              pp
            )
          ])
        ])
      );
    }
  }),
  mp = ['for'],
  gp = { key: 0, class: 'qlfqa-input-label' },
  bp = { class: 'qlfqa-input-row qlfqa:!h-14' },
  yp = { class: 'qlfqa-input-content' },
  qp = { key: 0, class: 'qlfqa-input-hint' },
  wp = ['id', 'type', 'placeholder'],
  xp = { key: 0, class: 'qlfqa-input-suffix' },
  Hs = De({
    inheritAttrs: !1,
    __name: 'QuizInputField',
    props: {
      id: {},
      modelValue: {},
      type: { default: 'text' },
      label: { default: '' },
      hint: { default: '' },
      placeholder: { default: '' },
      suffix: { default: '' },
      invalid: { type: Boolean, default: !1 },
      large: { type: Boolean, default: !1 }
    },
    emits: ['update:modelValue'],
    setup(e, { emit: t }) {
      const n = e,
        s = t,
        r = ol(),
        i = le(() => r.class),
        o = le(() => r.style),
        l = le(() => {
          const f = { ...r };
          return (delete f.class, delete f.style, f);
        }),
        a = le({ get: () => n.modelValue ?? '', set: (f) => s('update:modelValue', f) });
      return (f, c) => (
        Q(),
        ee(
          'div',
          { class: Pe(['qlfqa-input-field', i.value]), style: nn(o.value) },
          [
            R(
              'label',
              {
                for: f.id,
                class: Pe([
                  'qlfqa-input-shell qlfqa:!h-14',
                  {
                    'is-invalid': f.invalid,
                    'is-large': f.large,
                    'has-label': f.label,
                    'has-hint': f.hint
                  }
                ])
              },
              [
                f.label ? (Q(), ee('span', gp, qe(f.label), 1)) : He('', !0),
                R('div', bp, [
                  R('div', yp, [
                    f.hint ? (Q(), ee('span', qp, qe(f.hint), 1)) : He('', !0),
                    yf(
                      R(
                        'input',
                        Tl(
                          {
                            id: f.id,
                            'onUpdate:modelValue': c[0] || (c[0] = (u) => (a.value = u)),
                            type: f.type,
                            placeholder: f.placeholder
                          },
                          l.value,
                          {
                            class: [
                              'qlfqa-input-control',
                              f.large
                                ? 'qlfqa-input-control--large'
                                : 'qlfqa-input-control--default'
                            ]
                          }
                        ),
                        null,
                        16,
                        wp
                      ),
                      [[sd, a.value]]
                    )
                  ]),
                  f.suffix ? (Q(), ee('span', xp, qe(f.suffix), 1)) : He('', !0)
                ])
              ],
              10,
              mp
            )
          ],
          6
        )
      );
    }
  }),
  vp = { class: 'qlfqa:!py-2' },
  _p = { class: 'qlfqa:!mt-8' },
  Sp = { class: 'qlfqa:!mt-8' },
  Cp = {
    key: 0,
    class:
      'qlfqa:!mt-4 qlfqa:!border qlfqa:!border-[#e0a959] qlfqa:!rounded-2xl qlfqa:!p-5 qlfqa:!bg-[#faf3e9]'
  },
  Ep = { class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2' },
  Tp = { class: 'qlfqa:!font-semibold qlfqa:!text-xs' },
  Fp = { class: 'qlfqa:!mt-2 qlfqa:!text-xs' },
  Ap = { key: 0, class: 'qlfqa:!text-red-500 qlfqa:!mt-4 qlfqa:!text-sm' },
  kp = De({
    __name: 'QuizScreen09',
    emits: ['next'],
    setup(e, { emit: t }) {
      const n = t,
        s = jt(),
        r = Te(s.q09 || ''),
        i = Te(s.q11 || ''),
        o = Te(s.q10 || ''),
        l = Te(''),
        a = Te({ age: !1, height: !1, weight: !1 }),
        f = [
          {
            bmi_range: [0, 16],
            headline1: 'Dein BMI beträgt',
            headline2: ', womit du stark untergewichtig bist',
            text: 'Ein BMI-Wert unter 16 ist bedenklich und gilt bei Männern wie Frauen als anorektisch. Um deine Gesundheit nicht zu gefährden, raten wir dir stark von einer weiteren Abnahme ab. Bitte beende dieses Quiz daher.'
          },
          {
            bmi_range: [16, 18.5],
            headline1: 'Dein BMI beträgt',
            headline2: ', womit du untergewichtig bist',
            text: 'Dein BMI-Wert ist bereits sehr niedrig, weshalb wir dir an der Stelle nur raten können, nicht weitere Maßnahmen zur Gewichtsreduktion zu unternehmen. Bitte beende daher dieses Quiz jetzt.'
          },
          {
            bmi_range: [18.5, 25],
            headline1: 'Dein BMI beträgt',
            headline2: ', womit du Normalgewicht hast',
            text: 'Klasse, dein BMI-Wert ist im grünen Bereich. Das ist eine gute Ausgangslage, deine Gesundheit und dein Wohlbefinden zu optimieren, gezielt Fett zu verlieren, den Körper zu straffen und schöne Muskulatur aufzubauen.'
          },
          {
            bmi_range: [25, 30],
            headline1: 'Dein BMI beträgt',
            headline2: ', womit du Übergewicht hast',
            text: 'Dein BMI-Wert ist bereits erhöht und das Risiko diverser Krankheiten beginnt zu steigen (Herz-Kreislauf, Diabetes Typ-2, Krebs). Mit den richtigen Strategien kannst du jedoch schnell beeindruckende Resultate erzielen.'
          },
          {
            bmi_range: [30, 999],
            headline1: 'Dein BMI beträgt',
            headline2: ', womit du starkes Übergewicht hast',
            text: 'Du leidest somit an einem stark erhöhten Risiko für diverse Krankheiten, wie Diabetes Typ-2, Krebs & Herz-Kreislauf-Erkrankungen. Zusammen können wir aber schnelle und wichtige Verbesserungen erzielen.'
          }
        ],
        c = le(() => s.screenHistory.length > 0),
        u = le(() => r.value.trim() !== '' && i.value.trim() !== '' && o.value.trim() !== ''),
        m = le(() => K()),
        y = le(() => i.value.trim() !== '' && o.value.trim() !== '' && m.value),
        h = le(() => {
          if (!i.value.trim() || !o.value.trim()) return !1;
          const I = parseFloat(te());
          return Number.isFinite(I) && I < 18.5;
        });
      function q() {
        a.value = { age: !1, height: !1, weight: !1 };
      }
      function w(I, x) {
        return ((a.value[I] = !0), (l.value = x), !1);
      }
      function O(I) {
        (a.value[I] && (a.value[I] = !1), l.value && (l.value = ''));
      }
      function $(I, x, M, W, A, G) {
        if (x.trim() === '') return !1;
        const se = Number(x);
        return Number.isFinite(se)
          ? se < M
            ? w(I, A)
            : se > W
              ? w(I, G)
              : !0
          : w(I, 'Bitte gib nur Zahlen ein.');
      }
      function N() {
        return (
          (l.value = ''),
          q(),
          r.value.trim()
            ? $(
                'age',
                r.value,
                18,
                99,
                'Alter muss mindestens 18 Jahre betragen.',
                'Alter darf maximal 99 Jahre betragen.'
              )
              ? i.value.trim()
                ? $(
                    'height',
                    i.value,
                    60,
                    250,
                    'Größe muss mindestens 60 cm betragen.',
                    'Größe darf maximal 250 cm betragen.'
                  )
                  ? o.value.trim()
                    ? !!$(
                        'weight',
                        o.value,
                        30,
                        250,
                        'Gewicht muss mindestens 30 kg betragen.',
                        'Gewicht darf 250 kg nicht überschreiten.'
                      )
                    : w('weight', 'Bitte gib dein Gewicht ein.')
                  : !1
                : w('height', 'Bitte gib deine Größe ein.')
              : !1
            : w('age', 'Bitte gib dein Alter ein.')
        );
      }
      function F() {
        !N() ||
          h.value ||
          n('next', { q09: r.value.trim(), q10: o.value.trim(), q11: i.value.trim() });
      }
      function j() {
        s.goBack();
      }
      function te() {
        const I = Number(o.value),
          x = Number(i.value);
        return !Number.isFinite(I) || !Number.isFinite(x) || x <= 0
          ? ''
          : (I / (x / 100) ** 2).toFixed(2);
      }
      function K() {
        const I = parseFloat(te());
        return (
          (Number.isFinite(I) && f.find((M) => I >= M.bmi_range[0] && I < M.bmi_range[1])) || null
        );
      }
      return (I, x) => (
        Q(),
        ee('div', vp, [
          x[10] ||
            (x[10] = R(
              'div',
              { class: 'qlfqa:!mb-8' },
              [
                R(
                  'h2',
                  { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-3' },
                  'Alter, Größe und Gewicht'
                ),
                R(
                  'p',
                  { class: 'qlfqa:!text-base qlfqa:!leading-6 qlfqa:!text-[#4b5563]' },
                  ' Anhand dieser Daten können wir deine individuellen Empfehlungen genau bestimmen. '
                )
              ],
              -1
            )),
          R('div', null, [
            x[6] ||
              (x[6] = R(
                'p',
                { class: 'qlfqa:!mb-2 qlfqa:!text-center qlfqa:!text-[#5a5a5a]' },
                'Alter',
                -1
              )),
            ne(
              Hs,
              {
                id: 'quiz-age',
                modelValue: r.value,
                'onUpdate:modelValue': x[0] || (x[0] = (M) => (r.value = M)),
                type: 'tel',
                inputmode: 'numeric',
                pattern: '[0-9]*',
                autocomplete: 'off',
                enterkeyhint: 'next',
                'aria-label': 'Gebe dein Alter ein',
                min: '18',
                max: '99',
                placeholder: 'Dein Alter',
                suffix: 'Jahre',
                invalid: a.value.age,
                onInput: x[1] || (x[1] = (M) => O('age'))
              },
              null,
              8,
              ['modelValue', 'invalid']
            )
          ]),
          R('div', _p, [
            x[7] ||
              (x[7] = R(
                'p',
                { class: 'qlfqa:!mb-2 qlfqa:!text-center qlfqa:!text-[#5a5a5a]' },
                'Größe in cm',
                -1
              )),
            ne(
              Hs,
              {
                id: 'quiz-height',
                modelValue: i.value,
                'onUpdate:modelValue': x[2] || (x[2] = (M) => (i.value = M)),
                type: 'tel',
                inputmode: 'numeric',
                pattern: '[0-9]*',
                autocomplete: 'off',
                enterkeyhint: 'next',
                'aria-label': 'Gebe deine Größe ein',
                min: '60',
                max: '250',
                placeholder: 'Deine Größe',
                suffix: 'cm',
                invalid: a.value.height,
                onInput: x[3] || (x[3] = (M) => O('height'))
              },
              null,
              8,
              ['modelValue', 'invalid']
            )
          ]),
          R('div', Sp, [
            x[8] ||
              (x[8] = R(
                'p',
                { class: 'qlfqa:!mb-2 qlfqa:!text-center qlfqa:!text-[#5a5a5a]' },
                'Gewicht in kg',
                -1
              )),
            ne(
              Hs,
              {
                id: 'quiz-current-weight',
                modelValue: o.value,
                'onUpdate:modelValue': x[4] || (x[4] = (M) => (o.value = M)),
                type: 'tel',
                inputmode: 'numeric',
                pattern: '[0-9]*',
                autocomplete: 'off',
                name: 'age',
                'data-form-type': 'other',
                enterkeyhint: 'done',
                'aria-label': 'Gebe dein aktuelles Gewicht ein',
                min: '30',
                max: '250',
                placeholder: 'Dein aktuelles Gewicht',
                suffix: 'kg',
                invalid: a.value.weight,
                onInput: x[5] || (x[5] = (M) => O('weight'))
              },
              null,
              8,
              ['modelValue', 'invalid']
            )
          ]),
          ne(
            Il,
            { name: 'fade' },
            {
              default: St(() => {
                var M, W, A;
                return [
                  y.value
                    ? (Q(),
                      ee('div', Cp, [
                        R('div', Ep, [
                          x[9] ||
                            (x[9] = R(
                              'div',
                              {
                                class:
                                  'qlfqa:!text-sm qlfqa:!border qlfqa:!border-[#e0a959] qlfqa:!text-[#e0a959] qlfqa:!rounded-full qlfqa:!flex qlfqa:!w-[20px] qlfqa:!h-[20px] qlfqa:!justify-center qlfqa:!items-center qlfqa:!font-bold'
                              },
                              ' ! ',
                              -1
                            )),
                          R(
                            'h3',
                            Tp,
                            qe((M = m.value) == null ? void 0 : M.headline1) +
                              ' ' +
                              qe(te()) +
                              qe((W = m.value) == null ? void 0 : W.headline2),
                            1
                          )
                        ]),
                        R('p', Fp, qe((A = m.value) == null ? void 0 : A.text), 1)
                      ]))
                    : He('', !0)
                ];
              }),
              _: 1
            }
          ),
          l.value ? (Q(), ee('div', Ap, qe(l.value), 1)) : He('', !0),
          ne(
            Mr,
            {
              showBackButton: c.value,
              disableContinue: !u.value || h.value,
              onBack: j,
              onContinue: F
            },
            null,
            8,
            ['showBackButton', 'disableContinue']
          )
        ])
      );
    }
  }),
  Rp = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'age-title' },
  Op = {
    class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
    role: 'radiogroup',
    'aria-label': 'Was ist deine Wunschfigur?'
  },
  Pp = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
  Ip = { class: 'qlfqa:!mt-5 qlfqa:!flex qlfqa:!justify-center' },
  Mp = ['disabled'],
  $p = De({
    __name: 'QuizScreen12',
    emits: ['next'],
    setup(e, { emit: t }) {
      const n = t,
        s = jt(),
        r = Te(''),
        i = {
          schlank: {
            '40-44':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-schlank-40-44_13f04237-6369-42ad-a2ce-34cc9195089f.jpg?v=1771920937',
            '45-49':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-schlank-45-49_59f1a6fc-19b9-4b36-b0a0-a642080b5711.jpg?v=1771920937',
            '50-54':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-schlank-50-54_a16996d4-32bb-420b-a96b-1c459e6a1f2b.jpg?v=1771920937',
            '55+':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-schlank-55plus_e86e4020-2b56-418c-ada0-ca741cfa6aec.jpg?v=1771920937'
          },
          definiert: {
            '40-44':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-definiert-40-44.jpg?v=1771920938',
            '45-49':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-definiert-45-49_36b0986e-f63b-49c9-8f4b-221dc79178c9.jpg?v=1771920938',
            '50-54':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-definiert-50-54_3b7733fa-fc89-4a4f-983c-c62707797882.jpg?v=1771920938',
            '55+':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-definiert-55plus_5897eaba-31d5-4cc8-b3f5-22fd60a77cfa.jpg?v=1771920939'
          },
          kurvig: {
            '40-44':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-kurvig-40-44_83e26a96-98ab-4446-ab6e-fee219706c84.jpg?v=1771920938',
            '45-49':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-kurvig-45-49_ca615ac9-5206-460b-9646-9c92b65ebbbe.jpg?v=1771920938',
            '50-54':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-kurvig-50-54_b60fc481-283e-46aa-8e04-05abf2ab9bc0.jpg?v=1771920938',
            '55+':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-kurvig-55plus_8fe74363-b44f-4eb0-abfd-475a36b177d4.jpg?v=1771920938'
          },
          normal: {
            '40-44':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-normal-40-44_faec7d2c-78b8-4d2f-bc4e-99d5e9e520b6.jpg?v=1771920935',
            '45-49':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-normal-45-49_fbca433d-565b-44ef-834b-c5fd1d400396.jpg?v=1771920937',
            '50-54':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-normal-50-54_306af7d7-54ee-4300-80a2-8633561216c6.jpg?v=1771920937',
            '55+':
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-Frau-normal-55plus_1cc787c1-3c0c-40ce-927f-44798f268ddf.jpg?v=1771920936'
          }
        },
        o = [
          {
            id: 1,
            text: 'schlank',
            gender: 'w',
            val: '1',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-schlank.jpg?format=webp',
            altText: ''
          },
          {
            id: 2,
            text: 'definiert',
            gender: 'w',
            val: '2',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-definiert.jpg?format=webp',
            altText: ''
          },
          {
            id: 3,
            text: 'kurvig',
            gender: 'w',
            val: '3',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Fra-kurvig-sportlich.jpg?format=webp',
            altText: ''
          },
          {
            id: 4,
            text: 'normal',
            gender: 'w',
            val: '4',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Frau-normal.jpg?format=webp',
            altText: ''
          },
          {
            id: 5,
            text: 'schlank',
            gender: 'm',
            val: '5',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-schlank.jpg?format=webp',
            altText: ''
          },
          {
            id: 6,
            text: 'definiert',
            gender: 'm',
            val: '6',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-definiert.jpg?format=webp',
            altText: ''
          },
          {
            id: 7,
            text: 'sportlich',
            gender: 'm',
            val: '7',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-sportlich.jpg?format=webp',
            altText: ''
          },
          {
            id: 8,
            text: 'normal',
            gender: 'm',
            val: '8',
            image:
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage5-Mann-normal.jpg?format=webp',
            altText: ''
          }
        ],
        l = le(() => {
          const h = s.gender,
            q = s.age;
          return o
            .filter((w) => w.gender === h)
            .map((w) => {
              var $;
              let O = w.image;
              if (h === 'w' && q) {
                const N = w.text,
                  F = ($ = i[N]) == null ? void 0 : $[q];
                F && (O = F);
              }
              return { ...w, image: O };
            });
        });
      function a(h) {
        ((r.value = h), r.value && n('next', r.value));
      }
      const f = {
        m: [
          'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Bauch.jpg?format=webp',
          'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Po.jpg?format=webp',
          'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Huefte.jpg?format=webp',
          'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Beine.jpg?format=webp',
          'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Gesicht.jpg?format=webp'
        ],
        w: [
          'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Bauch.jpg?format=webp',
          'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Po1.jpg?format=webp',
          'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Huefte.jpg?format=webp',
          'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Beine.jpg?format=webp',
          'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Gesicht.jpg?format=webp'
        ]
      };
      let c = !1;
      function u() {
        if (c) return;
        c = !0;
        const h = s.gender;
        if (!h) return;
        const w = (f[h] ?? []).map((O) => ({ src: O, ...as.multiSelectionThumb }));
        qn(w);
      }
      const m = le(() => s.screenHistory.length > 0);
      function y() {
        s.goBack();
      }
      return (h, q) => (
        Q(),
        ee('div', Rp, [
          q[2] ||
            (q[2] = R(
              'h2',
              { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
              'Was ist deine Wunschfigur?',
              -1
            )),
          R('div', Op, [
            (Q(!0),
            ee(
              he,
              null,
              In(
                l.value,
                (w) => (
                  Q(),
                  ct(
                    Ir,
                    {
                      class: Pe([
                        'qlfqa:!w-6/12 qlfqa:!flex',
                        { 'qlfqa:!border-2 qlfqa:!border-[#FED43CFF]': r.value === w.val }
                      ]),
                      key: w.id,
                      onPointerenter: q[0] || (q[0] = (O) => u()),
                      onPointerdown: q[1] || (q[1] = (O) => u()),
                      onClick: (O) => a(w.val),
                      role: 'radio',
                      'aria-checked': r.value === w.val,
                      'aria-label': 'Wunschfigur ' + w.text
                    },
                    {
                      default: St(() => [
                        R('span', Pp, [
                          ne(
                            Pr,
                            {
                              src: w.image,
                              alt: '',
                              class: 'qlfqa:!w-full qlfqa:!h-auto',
                              sizes: '(max-width: 640px) 50vw, 220px',
                              'is-priority': l.value.indexOf(w) < 2
                            },
                            null,
                            8,
                            ['src', 'is-priority']
                          )
                        ])
                      ]),
                      _: 2
                    },
                    1032,
                    ['class', 'onClick', 'aria-checked', 'aria-label']
                  )
                )
              ),
              128
            ))
          ]),
          R('div', Ip, [
            R(
              'button',
              {
                onClick: y,
                disabled: !m.value,
                class:
                  'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
              },
              ' Zurück ',
              8,
              Mp
            )
          ])
        ])
      );
    }
  }),
  Np = { class: 'qlfqa:!py-2', role: 'article' },
  jp = { class: 'qlfqa:!mb-4' },
  Bp = { class: 'weight-predict-chart__chart-wrapper' },
  zp = { 'data-weight-chart': 'weight-predict', class: 'weight-predict-chart__chart' },
  Lp = { class: 'weight-predict-chart__top-value weight-predict-chart__text-value' },
  Dp = { class: 'weight-predict-chart__bottom-right-value weight-predict-chart__text-value' },
  Up = De({
    __name: 'QuizScreen32',
    setup(e) {
      const t = jt(),
        n = Te(!1),
        s = le(() => {
          const l = new Date(),
            a = new Date(l);
          a.setDate(a.getDate() + 28);
          const f = [
              'Januar',
              'Februar',
              'März',
              'April',
              'Mai',
              'Juni',
              'Juli',
              'August',
              'September',
              'Oktober',
              'November',
              'Dezember'
            ],
            c = a.getDate(),
            u = f[a.getMonth()],
            m = a.getFullYear();
          return `${c}. ${u} ${m}`;
        });
      Pn(function () {
        (t.completeQuiz(),
          setTimeout(() => {
            n.value = !0;
          }, 3200));
      });
      function r() {
        o();
      }
      let i = !1;
      function o() {
        if (!i) {
          i = !0;
          try {
            const l = new URLSearchParams();
            if (t.results) {
              const u = t.results;
              (l.append('calorieIntake1', u.calorieIntakeRange[0]),
                l.append('calorieIntake2', u.calorieIntakeRange[1]),
                l.append('proteinIntake', u.proteinIntake),
                l.append('fatIntake', u.fatIntake),
                l.append('carbohydrates', u.carbohydrates));
            } else
              (l.append('calorieIntakeRange', '0'),
                l.append('calorieIntake2', '0'),
                l.append('proteinIntake', '0'),
                l.append('fatIntake', '0'),
                l.append('carbohydrates', '0'));
            const a = 'https://qlf.de/pages/ergebnisbauchfett',
              f = 'https://qlf.de/pages/ergebnisbauchfett';
            let c;
            t.gender === 'w' ? (c = `${a}?${l.toString()}`) : (c = `${f}?${l.toString()}`);
            try {
              window.location.href = c;
            } catch {
              window.location.replace(c);
            }
          } catch {
            window.location.href = 'https://qlf.de/pages/stoffwechsel';
          }
        }
      }
      return (l, a) => (
        Q(),
        ee('div', Np, [
          a[6] ||
            (a[6] = R(
              'h2',
              { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
              'Geschafft 🤩',
              -1
            )),
          a[7] ||
            (a[7] = R(
              'p',
              { class: 'qlfqa:!text-gray-700 qlfqa:!text-center qlfqa:!mb-4' },
              ' Wir haben jetzt alle Informationen, um dir mithilfe der Studienlage und unserer Datenbank deinen ersten 4-Wochen Fahrplan zum Fettverlust zu erstellen! ',
              -1
            )),
          R('div', jp, [
            R('div', Bp, [
              R('div', zp, [
                a[1] ||
                  (a[1] = R(
                    'div',
                    { class: 'weight-predict-chart__grid-item weight-predict-chart__grid-item-1' },
                    null,
                    -1
                  )),
                a[2] ||
                  (a[2] = R(
                    'div',
                    { class: 'weight-predict-chart__grid-item weight-predict-chart__grid-item-2' },
                    null,
                    -1
                  )),
                a[3] ||
                  (a[3] = R(
                    'div',
                    { class: 'weight-predict-chart__grid-item weight-predict-chart__grid-item-3' },
                    null,
                    -1
                  )),
                R('div', Lp, qe(hn(t).q10) + ' kg', 1),
                a[4] ||
                  (a[4] = R(
                    'div',
                    {
                      class:
                        'weight-predict-chart__bottom-left-value weight-predict-chart__text-value'
                    },
                    'JETZT',
                    -1
                  )),
                R('div', Dp, qe(s.value), 1),
                a[5] ||
                  (a[5] = hu(
                    '<div class="weight-predict-chart__svg-wrapper"><svg preserveAspectRatio="xMidYMid meet" class="weight-predict-chart__svg-chart" viewBox="0 0 400 150" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="area-gradient" x1="0%" x2="100%" y1="0%" y2="0%"><stop offset="0%" stop-color="rgba(253, 213, 57, 0.22)"></stop><stop offset="100%" stop-color="rgba(253, 213, 57, 0.1)"></stop></linearGradient></defs><line x1="10" y1="0" x2="10" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="100" y1="0" x2="100" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="200" y1="0" x2="200" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="300" y1="0" x2="300" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="400" y1="0" x2="400" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><path d="M11,30.222C56.267,35.587,101.533,40.953,146.8,55.762C192.067,70.572,237.333,103.851,282.6,119.08C302,125.607,321.4,132.923,340.8,135.423C360.2,137.923,379.6,138.548,399,139.173L399,89.173C379.6,91.048,360.2,92.923,340.8,92.923C321.4,92.923,302,88.107,282.6,84.08C237.333,74.684,192.067,43.622,146.8,38.262C101.533,32.902,56.267,31.562,11,30.222Z" fill="url(#area-gradient)" opacity="0"><animate attributeName="opacity" from="0" to="1" dur="0.6s" begin="0.5s" fill="freeze"></animate></path><circle cx="11" cy="30.222222222222264" r="4" fill="#fdd539"></circle><path id="drawPath" d="M11,30.222C56.267,33.021,101.533,35.819,146.8,47.012C192.067,58.206,237.333,89.267,282.6,101.58C302,106.857,321.4,114.173,340.8,114.173C360.2,114.173,379.6,114.173,399,114.173" stroke="#fdd539" stroke-width="3" fill="none" stroke-linecap="round" pathLength="1" stroke-dasharray="1" stroke-dashoffset="1"><animate id="lineAnim" attributeName="stroke-dashoffset" from="1" to="0.0" dur="1.5s" fill="freeze" calcMode="spline" keyTimes="0;1" keySplines="0.25 0.1 0.25 1"></animate></path><g id="marker" visibility="hidden"><circle r="7.2" fill="#fdd539" stroke="#fdd539" stroke-width="0"></circle><circle r="7" fill="#fdd539" stroke="#fff" stroke-width="2" stroke-opacity="1"></circle><animateMotion id="markerMotion" begin="lineAnim.end" dur="2s" fill="freeze" calcMode="spline" keyTimes="0;1" keySplines="0.25 0.1 0.25 1" keyPoints="0;0.875"><mpath xlink:href="#drawPath"></mpath></animateMotion><set attributeName="visibility" to="visible" begin="markerMotion.begin" fill="freeze"></set><animateTransform attributeName="transform" type="scale" values="1;1.2;1" begin="markerMotion.end" dur="0.4s" fill="freeze"></animateTransform></g></svg></div>',
                    1
                  )),
                R(
                  'div',
                  {
                    'data-bounds': 'tooltip',
                    class: Pe([
                      { 'weight-predict-chart__goal-label--visible': n.value },
                      'weight-predict-chart__goal-label'
                    ])
                  },
                  a[0] ||
                    (a[0] = [
                      R('div', { class: 'weight-predict-chart__goal-label-chevron' }, null, -1),
                      R(
                        'div',
                        { class: 'weight-predict-chart__goal-label-text' },
                        [is(' 2 - 5 Kilo'), R('br'), is(' Fettverlust ')],
                        -1
                      )
                    ]),
                  2
                )
              ])
            ])
          ]),
          R(
            'div',
            {
              class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
              role: 'group',
              'aria-label': 'Navigation'
            },
            [
              R(
                'button',
                {
                  onClick: r,
                  'aria-label': 'Alles klar und weiter',
                  class:
                    'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-full qlfqa:!font-semibold'
                },
                ' Weiter zur finalen Berechnung! '
              )
            ]
          )
        ])
      );
    }
  }),
  Hp = { class: 'quiz-container' },
  Qp = De({
    __name: 'Quiz',
    setup(e) {
      const t = jt(),
        n = {
          QuizScreen01: Wd,
          QuizScreen02: ip,
          QuizScreen03: ap,
          QuizScreen04: hp,
          QuizScreen09: kp,
          QuizScreen12: $p,
          QuizScreen32: Up
        },
        s = le(() => n[t.currentScreen]);
      function r(i) {
        t.goToNextScreen(i);
      }
      return (i, o) => (
        Q(),
        ee('div', Hp, [
          hn(t).currentScreen !== 'HealthPhase2Screen'
            ? (Q(),
              ct(Id, { key: 0, 'current-screen': hn(t).currentScreen }, null, 8, [
                'current-screen'
              ]))
            : He('', !0),
          ne(
            Il,
            { name: hn(t).currentScreen === 'QuizScreen32' ? 'zoom' : 'fade', mode: 'out-in' },
            { default: St(() => [(Q(), ct(Of(s.value), { onNext: r }, null, 32))]), _: 1 },
            8,
            ['name']
          )
        ])
      );
    }
  }),
  Vp = De({
    __name: 'Index',
    setup(e) {
      return (t, n) => (Q(), ct(Td, null, { default: St(() => [ne(Qp)]), _: 1 }));
    }
  }),
  Wp = md(),
  Gl = dd(Vp);
Gl.use(Wp);
Gl.mount('#qlfswquizapp');
